{
  "accept.action.button": "Accept",
  "accessDenied.message": "You do not have access to this module ,please contact your system administrator",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Access Denied",
  "accession.entry": "Accession Number Entry",
  "activityReportByPanel": "Activity report By Panel",
  "activityReportByTest": "Activity report By test",
  "activityReportByTestSection": "Activity report By Test Section",
  "add.age.range": "Add Another Age Range +",
  "add.aliquot": "Add Aliquot",
  "add.new.dictionary.menu": "Add New Dictionary Menu",
  "adjustment.button": "Adjust Quantity",
  "adjustment.newQuantity": "New Quantity",
  "adjustment.notes": "Notes",
  "adjustment.notes.placeholder": "Provide details about this adjustment",
  "adjustment.reason": "Reason for Adjustment",
  "adjustment.reason.select": "Select reason",
  "adjustment.success": "Lot quantity adjusted successfully",
  "adjustment.title": "Adjust Lot Quantity",
  "admin.dashboard.subtitle": "Choose an administration area to configure OpenELIS.",
  "admin.dashboard.title": "Admin dashboard",
  "admin.formEntryConfig": "General Configurations",
  "admin.config.logo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "admin.config.logo.formats": "Formats: JPG, PNG, GIF (max 2MB)",
  "admin.label": "Admin",
  "admin.legacy": "Legacy Admin",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Add",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Deactivate",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Exit",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modify",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Save",
  "admin.page.configuration.formEntryConfigMenu.description": "Description",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Edit Record",
  "admin.page.configuration.formEntryConfigMenu.name": "Name",
  "admin.page.configuration.formEntryConfigMenu.select": "Select",
  "admin.page.configuration.formEntryConfigMenu.value": "Value",
  "admin.labelPresets.title": "Label Presets",
  "admin.labelPresets.addButton": "Add Preset",
  "admin.labelPresets.search.placeholder": "Search presets...",
  "admin.labelPresets.col.name": "Name",
  "admin.labelPresets.col.barcodeType": "Barcode Type",
  "admin.labelPresets.col.dimensions": "Dimensions",
  "admin.labelPresets.col.scope": "Scope",
  "admin.labelPresets.col.status": "Status",
  "admin.labelPresets.col.actions": "Actions",
  "admin.labelPresets.systemTag": "System",
  "admin.labelPresets.status.active": "Active",
  "admin.labelPresets.status.inactive": "Inactive",
  "admin.labelPresets.scope.order": "Order",
  "admin.labelPresets.scope.sample": "Sample",
  "admin.labelPresets.action.edit": "Edit",
  "admin.labelPresets.action.duplicate": "Duplicate",
  "admin.labelPresets.action.activate": "Activate",
  "admin.labelPresets.action.deactivate": "Deactivate",
  "admin.labelPresets.duplicateName": "Copy of {name}",
  "admin.labelPresets.duplicated": "Preset duplicated",
  "admin.labelPresets.duplicateFailed": "Duplicate failed",
  "admin.labelPresets.activated": "Preset activated",
  "admin.labelPresets.deactivated": "Preset deactivated",
  "admin.labelPresets.toggleFailed": "Status change failed",
  "admin.labelPresets.saveFailed": "Save failed",
  "admin.labelPresets.editor.titleAdd": "Add Label Preset",
  "admin.labelPresets.editor.titleEdit": "Edit Label Preset",
  "admin.labelPresets.editor.section.basicInfo": "Basic Info",
  "admin.labelPresets.editor.section.dimensions": "Dimensions (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Barcode Settings",
  "admin.labelPresets.editor.section.printScope": "Print Scope & Quantities",
  "admin.labelPresets.field.name": "Preset Name",
  "admin.labelPresets.field.isActive": "Active",
  "admin.labelPresets.field.heightMm": "Height (mm)",
  "admin.labelPresets.field.widthMm": "Width (mm)",
  "admin.labelPresets.field.barcodeType": "Barcode Type",
  "admin.labelPresets.field.defaultPerOrder": "Default per Order",
  "admin.labelPresets.field.maxPerOrder": "Max per Order",
  "admin.labelPresets.field.defaultPerSample": "Default per Sample",
  "admin.labelPresets.field.maxPerSample": "Max per Sample",
  "admin.labelPresets.validation.name.required": "Name is required",
  "admin.labelPresets.validation.name.toolong": "Name must not exceed 120 characters",
  "admin.labelPresets.validation.dimension.range": "Dimension must be between 5 and 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Barcode type is required",
  "admin.labelPresets.validation.scope.required": "At least one print scope (Order or Sample) must be selected",
  "admin.labelPresets.validation.max.lte": "Max must be greater than or equal to default",
  "advanced.search": "Advanced Search",
  "alert.expired.title": "Expired Items",
  "alert.expiring.title": "Expiring Soon",
  "alert.lowStock.title": "Low Stock Alert",
  "alerts.acknowledge.button": "Acknowledge",
  "alerts.acknowledge.comment": "Resolution Comment",
  "alerts.acknowledge.comment.placeholder": "Describe how this alert was addressed...",
  "alerts.acknowledge.comment.required": "Resolution comment is required for critical alerts",
  "alerts.acknowledge.error": "Failed to acknowledge alert",
  "alerts.acknowledge.success": "Alert acknowledged successfully",
  "alerts.acknowledge.title": "Acknowledge Alert",
  "alerts.autoRefresh": "Auto-refresh every 60 seconds",
  "alerts.dashboard.title": "Alerts Dashboard",
  "alerts.empty": "No alerts to display",
  "alerts.eqaDeadlineSummary.critical": "Critical",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} upcoming deadlines",
  "alerts.eqaDeadlineSummary.subtitle": "Upcoming EQA submission deadlines grouped by provider",
  "alerts.eqaDeadlineSummary.title": "EQA Deadline Summary",
  "alerts.eqaDeadlineSummary.viewAll": "View All",
  "alerts.filter.myAlerts": "My Alerts",
  "alerts.filter.search": "Search alerts...",
  "alerts.filter.severity": "Severity",
  "alerts.filter.status": "Status",
  "alerts.filter.type": "Alert Type",
  "alerts.severity.critical": "Critical",
  "alerts.severity.warning": "Warning",
  "alerts.status.acknowledged": "Acknowledged",
  "alerts.status.open": "Open",
  "alerts.status.resolved": "Resolved",
  "alerts.summary.critical": "Critical Alerts",
  "alerts.summary.eqaDeadlines": "EQA Deadlines",
  "alerts.summary.sampleExpiration": "Samples Expiring",
  "alerts.summary.statOverdue": "Overdue STAT Orders",
  "alerts.summary.totalOpen": "Total Open",
  "alerts.table.actions": "Actions",
  "alerts.table.created": "Created",
  "alerts.table.message": "Message",
  "alerts.table.severity": "Severity",
  "alerts.table.status": "Status",
  "alerts.table.type": "Type",
  "alerts.type.critical_unacknowledged": "Unacknowledged Critical",
  "alerts.type.eqa_deadline": "EQA Deadline",
  "alerts.type.sample_expiration": "Sample Expiration",
  "alerts.type.stat_overdue": "STAT Overdue",
  "alerts.type.stat_upcoming": "STAT Upcoming",
  "aliquot": "Aliquot",
  "aliquot.analyses.count": "Analyses: {count}",
  "aliquot.id": "Aliquot ID",
  "aliquot.quantity": "Aliquot Quantity",
  "aliquot.quantity.not.balanced": "Quantity not balanced for sample type",
  "aliquot.save.error": "Error saving aliquoting data.",
  "aliquot.save.success": "Aliquoting data saved successfully.",
  "aliquot.tests.not.assigned": "Tests not assigned for sample type",
  "aliquot.validation.errors": "Validation Errors",
  "aliquoting": "Aliquoting",
  "aliquoting.section": "Aliquoting Section",
  "all.label": "All",
  "all.tests.assigned": "All tests assigned",
  "allocated.to.aliquots": "Allocated to Aliquots",
  "analysis.count": "Analysis Count",
  "analysis.details": "Analysis Details",
  "analyzer.action.add": "Add Analyzer",
  "analyzer.action.copyMappings": "Copy Mappings",
  "analyzer.action.delete": "Delete",
  "analyzer.action.edit": "Edit",
  "analyzer.action.fieldMappings": "Field Mappings",
  "analyzer.action.qcRules": "QC Rules",
  "analyzer.action.testConnection": "Test Connection",
  "analyzer.combinationName.notification": "The combination of analyzer and analyzer test name must be unique",
  "analyzer.copyMappings.confirmation.message": "Are you sure you want to copy {count} mappings? Existing mappings will be overwritten.",
  "analyzer.copyMappings.confirmation.title": "Confirm Copy Mappings",
  "analyzer.copyMappings.copy": "Copy Mappings",
  "analyzer.copyMappings.error": "Error copying mappings",
  "analyzer.copyMappings.error.noSourceMappings": "Source analyzer has no active mappings to copy",
  "analyzer.copyMappings.loading": "Copying mappings...",
  "analyzer.copyMappings.source": "Source Analyzer",
  "analyzer.copyMappings.source.name": "Name",
  "analyzer.copyMappings.source.type": "Type",
  "analyzer.copyMappings.subtitle": "Copy field mappings from {source} to {target}",
  "analyzer.copyMappings.success": "Successfully copied {count} mappings",
  "analyzer.copyMappings.success.viewTarget": "View Target Analyzer",
  "analyzer.copyMappings.summary": "Mapping Summary",
  "analyzer.copyMappings.summary.breakdown": "Field mappings: {fieldCount}, Unit conversions: {unitCount}, Qualitative mappings: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} mappings will be copied",
  "analyzer.copyMappings.target": "Target Analyzer",
  "analyzer.copyMappings.target.placeholder": "Select target analyzer",
  "analyzer.copyMappings.target.required": "Target Analyzer *",
  "analyzer.copyMappings.title": "Copy Field Mappings",
  "analyzer.copyMappings.warning": "This will copy all field mappings including unit conversions and qualitative value mappings. Existing mappings will be overwritten.",
  "analyzer.delete.cancel": "Cancel",
  "analyzer.delete.delete": "Delete",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Analyzer ID is required",
  "analyzer.delete.error.unknown": "An unknown error occurred while deleting the analyzer",
  "analyzer.delete.message": "Are you sure you want to delete '{name}'? This action cannot be undone and will remove all associated field mappings.",
  "analyzer.delete.success": "Analyzer deleted",
  "analyzer.delete.title": "Delete Analyzer",
  "analyzer.delete.unknown": "Unknown Analyzer",
  "analyzer.errorDashboard.acknowledgeAll": "Acknowledge All",
  "analyzer.errorDashboard.action.acknowledge": "Acknowledge",
  "analyzer.errorDashboard.action.menu": "Error actions",
  "analyzer.errorDashboard.action.viewDetails": "View Details",
  "analyzer.errorDashboard.errorType.connection": "Connection",
  "analyzer.errorDashboard.errorType.mapping": "Mapping",
  "analyzer.errorDashboard.errorType.protocol": "Protocol",
  "analyzer.errorDashboard.errorType.timeout": "Timeout",
  "analyzer.errorDashboard.errorType.validation": "Validation",
  "analyzer.errorDashboard.filter.analyzer": "Analyzer",
  "analyzer.errorDashboard.filter.analyzer.all": "All",
  "analyzer.errorDashboard.filter.search": "Search errors...",
  "analyzer.errorDashboard.filter.severity": "Severity",
  "analyzer.errorDashboard.filter.severity.all": "All Severities",
  "analyzer.errorDashboard.filter.type": "Error Type",
  "analyzer.errorDashboard.filter.type.all": "All Types",
  "analyzer.errorDashboard.severity.critical": "Critical",
  "analyzer.errorDashboard.severity.error": "Error",
  "analyzer.errorDashboard.severity.warning": "Warning",
  "analyzer.errorDashboard.stats.critical": "Critical",
  "analyzer.errorDashboard.stats.last24Hours": "Last 24 Hours",
  "analyzer.errorDashboard.stats.total": "Total Errors",
  "analyzer.errorDashboard.stats.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.status.acknowledged": "Acknowledged",
  "analyzer.errorDashboard.status.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.subtitle": "View and manage analyzer errors and alerts",
  "analyzer.errorDashboard.table.analyzer": "Analyzer",
  "analyzer.errorDashboard.table.message": "Message",
  "analyzer.errorDashboard.table.severity": "Severity",
  "analyzer.errorDashboard.table.status": "Status",
  "analyzer.errorDashboard.table.timestamp": "Timestamp",
  "analyzer.errorDashboard.table.type": "Type",
  "analyzer.errorDashboard.title": "Error Dashboard",
  "analyzer.errorDetails.acknowledged": "Acknowledged",
  "analyzer.errorDetails.acknowledgedBy": "By {user} on {date}",
  "analyzer.errorDetails.analyzer": "Analyzer",
  "analyzer.errorDetails.analyzerId": "Analyzer ID",
  "analyzer.errorDetails.close": "Close",
  "analyzer.errorDetails.copy": "Copy",
  "analyzer.errorDetails.createMapping": "Create Mapping",
  "analyzer.errorDetails.download": "Download",
  "analyzer.errorDetails.errorId": "Error ID",
  "analyzer.errorDetails.errorMessage": "Error Message",
  "analyzer.errorDetails.errorType": "Error Type",
  "analyzer.errorDetails.logs": "Analyzer Logs ({count} entries)",
  "analyzer.errorDetails.recommendedActions": "Recommended Actions",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Check IP address and port configuration in analyzer settings",
  "analyzer.errorDetails.recommendedActions.createMapping": "Create a mapping for the unmapped field to resolve this error",
  "analyzer.errorDetails.recommendedActions.testConnection": "Test connection using the 'Test Connection' feature",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verify analyzer is powered on and network cable is connected",
  "analyzer.errorDetails.severity": "Severity",
  "analyzer.errorDetails.subtitle": "Detailed information and analyzer logs for error {id}",
  "analyzer.errorDetails.timestamp": "Timestamp",
  "analyzer.errorDetails.title": "Error Details",
  "analyzer.fhirImport.error.importFailed": "FHIR bundle import failed",
  "analyzer.fhirImport.error.invalidBundleType": "Bundle type must be 'transaction' or 'batch', got: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle contains no Observation resources with results",
  "analyzer.fieldCreation.acceptedUnits.label": "Accepted Units",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Select accepted units",
  "analyzer.fieldCreation.cancel": "Cancel",
  "analyzer.fieldCreation.confirmation": "I understand this field will be available for mapping immediately after creation",
  "analyzer.fieldCreation.create": "Create Field",
  "analyzer.fieldCreation.createNew": "Create New Field",
  "analyzer.fieldCreation.description.label": "Description (Optional)",
  "analyzer.fieldCreation.description.placeholder": "Enter field description",
  "analyzer.fieldCreation.entityType.label": "Entity Type",
  "analyzer.fieldCreation.entityType.placeholder": "Select entity type",
  "analyzer.fieldCreation.error.generic": "Failed to create field",
  "analyzer.fieldCreation.error.title": "Error creating field",
  "analyzer.fieldCreation.fieldName.label": "Field Name",
  "analyzer.fieldCreation.fieldName.placeholder": "Enter field name",
  "analyzer.fieldCreation.fieldType.label": "Field Type",
  "analyzer.fieldCreation.fieldType.placeholder": "Select field type",
  "analyzer.fieldCreation.loincCode.label": "LOINC Code (Optional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Enter LOINC code",
  "analyzer.fieldCreation.modal.subtitle": "Create a new field that will be available for mapping immediately",
  "analyzer.fieldCreation.modal.title": "Create New OpenELIS Field",
  "analyzer.fieldCreation.success.message": "Field is now available for mapping",
  "analyzer.fieldCreation.success.title": "Field created successfully",
  "analyzer.fieldCreation.validation.entityType.required": "Entity type is required",
  "analyzer.fieldCreation.validation.fieldName.required": "Field name is required",
  "analyzer.fieldCreation.validation.unique": "A field with this name already exists",
  "analyzer.fieldCreation.validation.units.required": "Accepted units are required for numeric fields",
  "analyzer.fieldMapping.activationModal.activate": "Activate Changes",
  "analyzer.fieldMapping.activationModal.cancel": "Cancel",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "I understand these changes will apply to new messages only",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Mapping changes detected. Another user has modified mappings for this analyzer. Please reload the page to see latest changes.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Cannot activate: Required mappings missing",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Missing required fields: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Reload Page",
  "analyzer.fieldMapping.activationModal.subtitle": "Confirm activation of mapping changes for analyzer '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Activate Mapping Changes",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "View Pending Messages",
  "analyzer.fieldMapping.activationModal.warning": "You are about to activate mapping changes for analyzer '{name}'. These changes will apply to all new messages received after activation. Existing results will not be affected.",
  "analyzer.fieldMapping.activationModal.warningActive": "This analyzer is currently active. Activating changes may affect incoming results.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "This analyzer has {count} pending messages in the error queue. Activating mapping changes may affect how these messages are reprocessed. Consider resolving errors first.",
  "analyzer.fieldMapping.back": "Back",
  "analyzer.fieldMapping.fieldType.controlTest": "Control Test",
  "analyzer.fieldMapping.fieldType.custom": "Custom",
  "analyzer.fieldMapping.fieldType.dateTime": "Date/Time",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Melting Point",
  "analyzer.fieldMapping.fieldType.numeric": "Numeric",
  "analyzer.fieldMapping.fieldType.qualitative": "Qualitative",
  "analyzer.fieldMapping.fieldType.text": "Text",
  "analyzer.fieldMapping.page.subtitle": "Configure field mappings between analyzer and OpenELIS",
  "analyzer.fieldMapping.page.title": "Field Mappings",
  "analyzer.fieldMapping.panel.mapping.active": "Active",
  "analyzer.fieldMapping.panel.mapping.retired": "Retired",
  "analyzer.fieldMapping.panel.retire": "Retire Mapping",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Cannot retire: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} fields available",
  "analyzer.fieldMapping.panel.source.search": "Search fields...",
  "analyzer.fieldMapping.panel.source.title": "Analyzer Fields ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Mapped",
  "analyzer.fieldMapping.panel.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.panel.statusFilter.active": "Active Only",
  "analyzer.fieldMapping.panel.statusFilter.all": "All Fields",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Draft Only",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filter by Status",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Mapped Only",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Unmapped Only",
  "analyzer.fieldMapping.panel.target.cancel": "Cancel",
  "analyzer.fieldMapping.panel.target.edit": "Edit",
  "analyzer.fieldMapping.panel.target.remove": "Remove",
  "analyzer.fieldMapping.panel.target.saveActivate": "Save and Activate",
  "analyzer.fieldMapping.panel.target.saveDraft": "Save as Draft",
  "analyzer.fieldMapping.panel.target.selectField": "Select a field from the left panel to view or create mappings.",
  "analyzer.fieldMapping.panel.target.summary": "Mappings Summary",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Unmapped Field - This field has no mapping configured",
  "analyzer.fieldMapping.pendingCodes.actions": "Actions",
  "analyzer.fieldMapping.pendingCodes.code": "Analyzer Code",
  "analyzer.fieldMapping.pendingCodes.empty": "No pending unmapped analyzer codes.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Ignore",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Mark Mapped",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Seen",
  "analyzer.fieldMapping.pendingCodes.status": "Status",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Review and resolve unmapped analyzer test codes.",
  "analyzer.fieldMapping.pendingCodes.title": "Pending Unmapped Codes",
  "analyzer.fieldMapping.pluginConfig.title": "Plugin Configuration Snapshot",
  "analyzer.fieldMapping.queryAnalyzer": "Query Analyzer",
  "analyzer.fieldMapping.retirementModal.cancel": "Cancel",
  "analyzer.fieldMapping.retirementModal.confirmation": "Are you sure you want to retire this mapping? Historical messages will still reference it for audit purposes.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Cannot retire: {count} pending messages use this mapping",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Retirement Reason (Optional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Optional: Reason for retiring this mapping",
  "analyzer.fieldMapping.retirementModal.retire": "Retire Mapping",
  "analyzer.fieldMapping.retirementModal.subtitle": "Confirm retirement of field mapping",
  "analyzer.fieldMapping.retirementModal.title": "Retire Mapping",
  "analyzer.fieldMapping.save": "Save Mappings",
  "analyzer.fieldMapping.stats.pendingCodes": "Pending Codes",
  "analyzer.fieldMapping.stats.required": "Required Mappings",
  "analyzer.fieldMapping.stats.total": "Total Mappings",
  "analyzer.fieldMapping.stats.unmapped": "Unmapped Fields",
  "analyzer.fieldMapping.status.active": "Active",
  "analyzer.fieldMapping.status.draft": "Draft",
  "analyzer.fieldMapping.status.retired": "Retired",
  "analyzer.fieldMapping.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.testMapping": "Test Mapping",
  "analyzer.fieldMapping.warning.missingRequired": "Required mappings are missing",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Some required fields are not mapped. Please map all required fields before activating.",
  "analyzer.filter.lifecycleStage.all": "All Lifecycle Stages",
  "analyzer.filter.lifecycleStage.label": "Lifecycle Stage",
  "analyzer.filter.status": "Status",
  "analyzer.filter.status.all": "All Statuses",
  "analyzer.filter.status.label": "Status",
  "analyzer.filter.testUnit": "Test Unit",
  "analyzer.filter.type": "Analyzer Type",
  "analyzer.form.activeStatus": "Active Status",
  "analyzer.form.activeStatus.description": "Enable this analyzer for data collection",
  "analyzer.form.addTitle": "Add New Analyzer",
  "analyzer.form.cancel": "Cancel",
  "analyzer.form.communicationMode": "Communication Mode",
  "analyzer.form.communicationMode.analyzerInitiated": "Analyzer → LIS (analyzer connects to OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidirectional (both directions)",
  "analyzer.form.communicationMode.help": "Who initiates the connection. Most analyzers use Analyzer → LIS.",
  "analyzer.form.communicationMode.lisInitiated": "LIS → Analyzer (OpenELIS connects to analyzer)",
  "analyzer.form.createdBy": "Created By",
  "analyzer.form.createdDate": "Created Date/Time",
  "analyzer.form.defaults.error": "Failed to load default configuration",
  "analyzer.form.defaults.loaded": "Default configuration loaded",
  "analyzer.form.defaults.loaded.subtitle": "Template for {name} has been loaded. Customize as needed before saving.",
  "analyzer.form.editTitle": "Edit Analyzer",
  "analyzer.form.error.invalidCommunicationMode": "Invalid communication mode: {value}. Valid values: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Invalid protocol version: {value}. Valid values: {validValues}",
  "analyzer.form.error.save": "Failed to save analyzer",
  "analyzer.form.error.unknown": "An unknown error occurred",
  "analyzer.form.fileProtocol.description": "This analyzer imports results from files. File import settings will be configured after saving.",
  "analyzer.form.fileProtocol.title": "File Import Protocol",
  "analyzer.form.identifierPattern": "Identifier Pattern",
  "analyzer.form.identifierPattern.helperText": "Regex pattern to match incoming message identifiers for routing",
  "analyzer.form.identifierPattern.placeholder": "e.g., ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "IP Address",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Last Modified Date/Time",
  "analyzer.form.loadDefaultConfig": "Load Analyzer Profile",
  "analyzer.form.loadDefaultConfig.helperText": "Quick setup using built-in analyzer profile templates",
  "analyzer.form.loadDefaultConfig.placeholder": "Select a built-in analyzer profile",
  "analyzer.form.name": "Analyzer Name",
  "analyzer.form.name.placeholder": "e.g., Hematology Analyzer 1",
  "analyzer.form.pluginType": "Plugin Type",
  "analyzer.form.pluginType.helperText": "The analyzer plugin that will handle incoming messages",
  "analyzer.form.pluginType.placeholder": "Select plugin type...",
  "analyzer.form.port": "Port Number",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Protocol Version",
  "analyzer.form.save": "Save",
  "analyzer.form.status": "Status",
  "analyzer.form.status.helperText": "Status transitions automatically based on analyzer state. Manual override to INACTIVE, SETUP, or VALIDATION only.",
  "analyzer.form.subtitle": "Configure analyzer connection settings and test units",
  "analyzer.form.success.save": "Analyzer saved successfully",
  "analyzer.form.testConnection": "Test Connection",
  "analyzer.form.testConnection.error": "Connection Failed",
  "analyzer.form.testUnits": "Test Unit Assignment",
  "analyzer.form.testUnits.helper": "Select one or more test units for this analyzer",
  "analyzer.form.testUnits.placeholder": "Select test units...",
  "analyzer.form.type": "Analyzer Type",
  "analyzer.form.type.other": "Other",
  "analyzer.form.type.placeholder": "Select analyzer type",
  "analyzer.form.validation.ipAddress.invalid": "Invalid IP address format",
  "analyzer.form.validation.name.required": "Analyzer name is required",
  "analyzer.form.validation.type.required": "Analyzer type is required",
  "analyzer.hl7.insertError": "HL7 insert error",
  "analyzer.hl7.parseError": "HL7 parse error",
  "analyzer.hl7.unknownAnalyzer": "Unable to identify analyzer from HL7 MSH (sending application/facility)",
  "analyzer.list.subtitle": "Manage laboratory analyzers and field mappings",
  "analyzer.list.title": "Analyzers",
  "analyzer.navigation.analyzerTypes": "Analyzer Types",
  "analyzer.navigation.analyzers": "Analyzers",
  "analyzer.navigation.analyzersList": "Analyzers List",
  "analyzer.navigation.errorDashboard": "Error Dashboard",
  "analyzer.navigation.fieldMappings": "Field Mappings",
  "analyzer.navigation.qc": "Quality Control",
  "analyzer.navigation.qcDashboard": "QC Dashboard",
  "analyzer.navigation.qcAlerts": "QC Alerts & Violations",
  "analyzer.navigation.qcCorrectiveActions": "Corrective Actions",
  "analyzerType.page.title": "Analyzer Types",
  "analyzerType.column.name": "Name",
  "analyzerType.column.description": "Description",
  "analyzerType.column.protocol": "Protocol",
  "analyzerType.column.pluginClass": "Plugin Class",
  "analyzerType.column.genericPlugin": "Generic Plugin",
  "analyzerType.column.identifierPattern": "Identifier Pattern",
  "analyzerType.column.pluginLoaded": "Plugin Loaded",
  "analyzerType.column.instances": "Instances",
  "analyzerType.column.status": "Status",
  "analyzerType.search.placeholder": "Search analyzer types...",
  "analyzerType.button.create": "Create New Analyzer Type",
  "analyzerType.button.creating": "Creating...",
  "analyzerType.button.cancel": "Cancel",
  "analyzerType.modal.createTitle": "Create New Analyzer Type",
  "analyzerType.field.name": "Name",
  "analyzerType.field.description": "Description",
  "analyzerType.field.protocol": "Protocol",
  "analyzerType.field.selectProtocol": "Select protocol",
  "analyzerType.field.pluginClassName": "Plugin Class Name",
  "analyzerType.field.identifierPattern": "Identifier Pattern",
  "analyzerType.field.identifierPatternHelper": "Regex pattern for matching sample identifiers (e.g. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Generic Plugin",
  "analyzerType.field.isActive": "Active",
  "analyzerType.error.nameRequired": "Name is required",
  "analyzerType.notification.createSuccess": "Analyzer type created successfully",
  "analyzerType.notification.createError": "Failed to create analyzer type",
  "analyzer.navigation.qcControlLots": "Control Lots",
  "analyzer.navigation.qcRuleConfig": "Rule Configuration",
  "analyzer.page.addButton": "Add Analyzer",
  "analyzer.page.hierarchy.list": "Analyzer List",
  "analyzer.page.hierarchy.mappings": "Field Mappings",
  "analyzer.page.hierarchy.root": "Analyzers",
  "analyzer.page.title": "Analyzers",
  "analyzer.plugin.missing": "Plugin Missing",
  "analyzer.qc.alerts.message": "Alerts and violations features are coming soon.",
  "analyzer.qc.alerts.title": "QC Alerts & Violations",
  "analyzer.qc.corrective.message": "Corrective actions features are coming soon.",
  "analyzer.qc.corrective.title": "Corrective Actions",
  "analyzer.qc.placeholder.message": "Quality Control features are coming soon.",
  "analyzer.qc.placeholder.title": "Quality Control",
  "analyzer.qualitativeMapping.isDefault": "Default",
  "analyzer.qualitativeMapping.mappings": "Value Mappings",
  "analyzer.qualitativeMapping.noValues": "No analyzer values available for mapping",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Select OpenELIS code",
  "analyzer.qualitativeMapping.subtitle": "Map qualitative values for {fieldName}",
  "analyzer.qualitativeMapping.title": "Qualitative Value Mapping",
  "analyzer.qualitativeMapping.validation.error": "Validation Error",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.qualitativeMapping.validation.noDefault": "No Default Value",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "At least one mapping should be marked as default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS code is required",
  "analyzer.query.button": "Query Analyzer",
  "analyzer.query.cancel": "Cancel",
  "analyzer.query.modal.logs": "Connection Logs",
  "analyzer.query.modal.noLogs": "No logs yet.",
  "analyzer.query.modal.progress": "Progress",
  "analyzer.query.modal.state": "State",
  "analyzer.query.modal.subtitle": "Retrieve available fields from analyzer",
  "analyzer.query.modal.title": "Query Analyzer",
  "analyzer.query.progress": "{percent}% complete",
  "analyzer.search.label": "Search",
  "analyzer.search.placeholder": "Search analyzers...",
  "analyzer.stat.active": "Active",
  "analyzer.stat.inactive": "Inactive",
  "analyzer.stat.pluginWarnings": "Plugin Warnings",
  "analyzer.stat.total": "Total Analyzers",
  "analyzer.stats.active": "Active Analyzers",
  "analyzer.stats.inactive": "Inactive Analyzers",
  "analyzer.stats.total": "Total Analyzers",
  "analyzer.status.active": "Active",
  "analyzer.status.deleted": "Deleted",
  "analyzer.status.error_pending": "Error Pending",
  "analyzer.status.inactive": "Inactive",
  "analyzer.status.offline": "Offline",
  "analyzer.status.pending_registration": "Pending Registration",
  "analyzer.status.setup": "Setup",
  "analyzer.status.validation": "Validation",
  "analyzer.success.save": "Analyzer saved successfully",
  "analyzer.table.actions": "Actions",
  "analyzer.table.connection": "Connection",
  "analyzer.table.header.connection": "Connection",
  "analyzer.table.header.lastModified": "Last Modified",
  "analyzer.table.header.name": "Name",
  "analyzer.table.header.status": "Status",
  "analyzer.table.header.testUnits": "Test Units",
  "analyzer.table.header.type": "Type",
  "analyzer.table.lastModified": "Last Modified",
  "analyzer.table.name": "Name",
  "analyzer.table.status": "Status",
  "analyzer.table.testUnits": "Test Units",
  "analyzer.table.type": "Type",
  "analyzer.testConnection.bridge.healthCheckFailed": "Cannot reach bridge health endpoint at {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge returned HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge is not configured",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge returned an unparseable response",
  "analyzer.testConnection.bridge.unreachable": "Cannot reach bridge: {detail}",
  "analyzer.testConnection.close": "Close",
  "analyzer.testConnection.logs": "Connection Logs",
  "analyzer.testConnection.requestBuildFailed": "Failed to build request: {detail}",
  "analyzer.testConnection.success": "Connection Successful",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge is not configured, so analyzer reachability cannot be tested",
  "analyzer.testConnection.testAgain": "Test Again",
  "analyzer.testConnection.testing": "Testing connection...",
  "analyzer.testConnection.title": "Test Connection",
  "analyzer.testMapping.activeMappings": "{count} active mappings",
  "analyzer.testMapping.analyzerInfo": "Analyzer Information",
  "analyzer.testMapping.analyzerName": "Analyzer Name",
  "analyzer.testMapping.analyzerType": "Analyzer Type",
  "analyzer.testMapping.appliedMappings": "Applied Mappings",
  "analyzer.testMapping.entityPreview": "OpenELIS Entity Preview",
  "analyzer.testMapping.errors": "Errors",
  "analyzer.testMapping.loading": "Processing preview...",
  "analyzer.testMapping.messageInput": "Sample ASTM Message",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} characters",
  "analyzer.testMapping.messageInput.helper": "Enter a sample ASTM message to preview how it will be interpreted",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sample ASTM Message *",
  "analyzer.testMapping.noResults": "No preview results yet. Enter a sample ASTM message and click Preview Mapping.",
  "analyzer.testMapping.parsedFields": "Parsed Fields",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM Ref",
  "analyzer.testMapping.parsedFields.fieldName": "Field Name",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretation",
  "analyzer.testMapping.parsedFields.mappedTo": "Mapped To",
  "analyzer.testMapping.parsedFields.rawValue": "Raw Value",
  "analyzer.testMapping.pluginConfigSnapshot": "Plugin Config Snapshot",
  "analyzer.testMapping.previewOptions": "Preview Options",
  "analyzer.testMapping.previewOptions.detailedParsing": "Show detailed parsing steps",
  "analyzer.testMapping.previewOptions.validateAll": "Validate all mappings",
  "analyzer.testMapping.results": "Preview Results",
  "analyzer.testMapping.saveTestCase": "Save as Test Case",
  "analyzer.testMapping.submit": "Preview Mapping",
  "analyzer.testMapping.subtitle": "Preview how sample ASTM messages will be interpreted",
  "analyzer.testMapping.testAnother": "Test Another Message",
  "analyzer.testMapping.title": "Test Field Mappings",
  "analyzer.testMapping.validation.invalidFormat": "Invalid ASTM message format",
  "analyzer.testMapping.validation.messageRequired": "ASTM message is required",
  "analyzer.testMapping.validation.messageTooLarge": "ASTM message exceeds maximum size of 10KB",
  "analyzer.testMapping.warnings": "Warnings",
  "analyzer.unitMapping.analyzerUnit": "Source Unit (Analyzer)",
  "analyzer.unitMapping.analyzerUnit.helper": "Unit reported by the analyzer",
  "analyzer.unitMapping.conversionFactor": "Conversion Factor",
  "analyzer.unitMapping.conversionFactor.helper": "Factor to convert from {from} to {to} (e.g., 0.0555 for mg/dL to mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Target Unit (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Canonical unit used in OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Select target unit",
  "analyzer.unitMapping.rejectIfMismatch": "Reject if Units Don't Match",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Reject messages if units don't match and no conversion factor is provided",
  "analyzer.unitMapping.subtitle": "Configure unit mapping for {fieldName}",
  "analyzer.unitMapping.title": "Unit Mapping",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Source unit is required",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Conversion factor must be a positive number",
  "analyzer.unitMapping.validation.conversionFactor.required": "Conversion factor is required when units differ",
  "analyzer.unitMapping.validation.error": "Validation Error",
  "analyzer.unitMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.unitMapping.validation.openelisUnit.required": "Target unit is required",
  "analyzer.qcRules.modal.title": "QC Sample Identification Rules — {analyzerName}",
  "analyzer.qcRules.orSemantics": "Rules use OR semantics: a sample is flagged as QC if ANY active rule matches.",
  "analyzer.qcRules.addRule": "Add Rule",
  "analyzer.qcRules.deleteRule": "Delete Rule",
  "analyzer.qcRules.noRules": "No QC rules configured. Add at least one rule before activating this analyzer.",
  "analyzer.qcRules.ruleType": "Rule Type",
  "analyzer.qcRules.targetField": "Field Reference",
  "analyzer.qcRules.targetField.placeholder": "e.g., O.12, QC_TASK",
  "analyzer.qcRules.operand": "Match Value",
  "analyzer.qcRules.operand.placeholder": "e.g., Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Failed to load QC rules",
  "analyzer.qcRules.error.saveFailed": "Failed to save QC rule",
  "analyzer.qcRules.error.deleteFailed": "Failed to delete QC rule",
  "analyzerTestName.header.analyzerName": "Analyzer - Analyzer Test Name",
  "analyzerTestName.modal.add.heading": "Add Analyzer Test Name",
  "analyzerTestName.modal.update.heading": "Update Analyzer Test Name",
  "assigned.cytopathologist.label": "CytoPathologist Assigned",
  "assigned.pathologist.label": "Pathologist Assigned",
  "assigned.technician.label": "Technician Assigned",
  "audittrail.table.heading.action": "Action",
  "audittrail.table.heading.identifier": "Identifier",
  "audittrail.table.heading.item": "Item",
  "audittrail.table.heading.newvalue": "New Value",
  "audittrail.table.heading.oldvalue": "Old Value",
  "audittrail.table.heading.time": "Time",
  "audittrail.table.heading.user": "User",
  "audittrail.table.title.patientResults": "Patient Results",
  "availabletests.title": "Available Tests",
  "back.action.button": "Back",
  "banner.menu.administration": "Admin",
  "banner.menu.alerts": "Alerts",
  "banner.menu.alerts.tooltip": "Alerts and quality assurance dashboard",
  "banner.menu.aliquot": "Aliquot",
  "banner.menu.aliquot.tooltip": "Sample Aliquot",
  "banner.menu.billing": "Billing",
  "banner.menu.billing.tooltip": "Billing",
  "banner.menu.createDouble": "Double Entry",
  "banner.menu.createInitial": "Initial Entry",
  "banner.menu.eorders": "Incoming Orders",
  "banner.menu.eqa": "EQA",
  "banner.menu.eqa.distribution": "EQA Distributions",
  "banner.menu.eqa.distribution.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.management": "EQA Programs",
  "banner.menu.eqa.management.tooltip": "Create and manage EQA programs",
  "banner.menu.eqa.mgmt": "EQA Management",
  "banner.menu.eqa.mgmt.distributions": "Distributions",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.mgmt.participants": "Participants",
  "banner.menu.eqa.mgmt.participants.tooltip": "Manage organization enrollment in EQA programs",
  "banner.menu.eqa.mgmt.programs": "Programs",
  "banner.menu.eqa.mgmt.programs.tooltip": "Create and manage EQA programs",
  "banner.menu.eqa.mgmt.results": "Results & Analysis",
  "banner.menu.eqa.mgmt.results.tooltip": "EQA results collection and statistical analysis",
  "banner.menu.eqa.mgmt.tooltip": "Manage EQA programs, participants, and distributions",
  "banner.menu.eqa.tests": "EQA Tests",
  "banner.menu.eqa.tests.myPrograms": "My Programs",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Manage self-enrollment in external EQA programs",
  "banner.menu.eqa.tests.orders": "Orders",
  "banner.menu.eqa.tests.orders.tooltip": "View and manage EQA test orders",
  "banner.menu.eqa.tests.tooltip": "EQA test orders and program enrollment",
  "banner.menu.eqa.tooltip": "External Quality Assurance",
  "banner.menu.generic.sample": "Generic Sample",
  "banner.menu.generic.sample.edit": "Edit Order",
  "banner.menu.generic.sample.import": "Import Samples",
  "banner.menu.generic.sample.order": "Create Order",
  "banner.menu.generic.sample.results": "Enter Results",
  "banner.menu.help": "Help",
  "banner.menu.help.about": "Video Tutorials",
  "banner.menu.help.contact": "Release Notes",
  "banner.menu.help.documents": "Process Documentation",
  "banner.menu.help.formDBS": "DBS Form",
  "banner.menu.help.formVL": "VL Form",
  "banner.menu.help.usermanual": "User Manual",
  "banner.menu.home": "Home",
  "banner.menu.inventory": "Inventory",
  "banner.menu.inventory.catalog": "Manage Catalog",
  "banner.menu.inventory.dashboard": "Dashboard",
  "banner.menu.inventory.list": "Inventory Items",
  "banner.menu.inventory.reports": "Reports",
  "banner.menu.nonconformity": "Non-Conform",
  "banner.menu.nonconformity.correctiveActions": "Corrective actions",
  "banner.menu.nonconformity.dashboard": "All NCEs",
  "banner.menu.nonconformity.report": "Report Non-Conforming Event",
  "banner.menu.nonconformity.view": "View New Non-Conforming Events",
  "banner.menu.patient": "Patient",
  "banner.menu.patient.Create": "Study",
  "banner.menu.patient.addOrEdit": "Add/Edit Patient",
  "banner.menu.patient.merge": "Merge Patient",
  "banner.menu.patient.merge.tooltip": "Merge duplicate patient records",
  "banner.menu.patientConsult": "View",
  "banner.menu.patientEdit": "Edit",
  "banner.menu.patienthistory": "Patient History",
  "banner.menu.printBarcode": "Barcode",
  "banner.menu.referredOut": "Referred Out",
  "banner.menu.report.validation.backlog": "Delayed Validation",
  "banner.menu.reports": "Reports",
  "banner.menu.reports.routine": "Routine",
  "banner.menu.reports.study": "Study",
  "banner.menu.results": "Results",
  "banner.menu.results.CobasIntegra400": "Biochemistry: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Immunology: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Immunology: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Immunology: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biochemestry: Fully analyzer importer",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Hematology: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNLAnalyzer",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL Analyzer",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXPAnalyzer",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP Analyzer",
  "banner.menu.results.accession": "By Order",
  "banner.menu.results.analyzer": "Analyzer",
  "banner.menu.results.cobasc111analyzer": "Biochemistry: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "By Unit",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Order Programs",
  "banner.menu.results.patient": "By Patient",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "By Test, Date or Status",
  "banner.menu.results.sysmexanalyzer": "Hematology: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Hematology: Sysmex XT analyzer importer",
  "banner.menu.results.taqman48dbsanalyzer": "Virologie: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "By Test Date",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validation",
  "banner.menu.resultvalidation.bacteria": "Bacteria",
  "banner.menu.resultvalidation.bench": "By Bench",
  "banner.menu.resultvalidation.biochemistry": "Biochemistry",
  "banner.menu.resultvalidation.cytobacteriology": "Cytobacteriology",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endocrinology",
  "banner.menu.resultvalidation.genotyping": "Genotyping",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-Immunology",
  "banner.menu.resultvalidation.hematology": "Hematology",
  "banner.menu.resultvalidation.immunology": "Immunology",
  "banner.menu.resultvalidation.immunology.Haiti": "Immunology-Virology",
  "banner.menu.resultvalidation.immunologyHematology": "Immunology - Hematology",
  "banner.menu.resultvalidation.liquidBio": "Liquid Biology",
  "banner.menu.resultvalidation.malaria": "Malaria",
  "banner.menu.resultvalidation.molecularBio": "Molecular Biology",
  "banner.menu.resultvalidation.mycobacteriology": "Mycobacteriology",
  "banner.menu.resultvalidation.mycology": "Mycology",
  "banner.menu.resultvalidation.parasitology": "Parasitology",
  "banner.menu.resultvalidation.serology": "Serology",
  "banner.menu.resultvalidation.serology-immunology": "Serology-Immunology",
  "banner.menu.resultvalidation.viralload": "Viral Load",
  "banner.menu.resultvalidation.virology": "Virology",
  "banner.menu.resultvalidation_routine": "Routine",
  "banner.menu.resultvalidation_study": "Study",
  "banner.menu.sample": "Order",
  "banner.menu.sample.shipment": "Sample Shipment",
  "banner.menu.sampleAdd": "Add Order",
  "banner.menu.sampleBatchEntry": "Batch Order Entry",
  "banner.menu.sampleConsult": "View",
  "banner.menu.sampleCreate": "Study",
  "banner.menu.sampleEdit": "Edit Order",
  "banner.menu.sampleManagement": "Sample Management",
  "banner.menu.sampleManagement.tooltip": "Sample Management Menu",
  "banner.menu.storage": "Storage",
  "banner.menu.storage.tooltip": "Sample Storage Management",
  "banner.menu.study.eorders": "Electronic Orders",
  "banner.menu.workplan": "Workplan",
  "banner.menu.workplan.bench": "By Unit",
  "banner.menu.workplan.panel": "By Panel",
  "banner.menu.workplan.priority": "By Priority",
  "banner.menu.workplan.test": "By Test Type",
  "banner.menu.workplan.unit": "By Test Section",
  "barcode.additionalInvalidLevels.message": "The barcode contains levels beyond the valid portion. Only valid levels are pre-filled.",
  "barcode.additionalInvalidLevels.warning": "Additional invalid levels detected",
  "barcode.autoOpenForm": "Opening location form with valid hierarchy",
  "barcode.debounce.warning": "Please wait before scanning another barcode",
  "barcode.error": "Invalid barcode",
  "barcode.firstMissingLevel": "First missing level: {level}",
  "barcode.format": "Barcode Format",
  "barcode.header": "Barcode(s)",
  "barcode.invalidFormat": "Invalid barcode format. Expected: ROOM-DEVICE or ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "Block label",
  "barcode.label.freezer": "Freezer label",
  "barcode.label.helper.text": "Enter values in: mm",
  "barcode.label.order": "Order label",
  "barcode.label.slide": "Slide label",
  "barcode.label.specimen": "Specimen label",
  "barcode.label.info.blockCaseNumber": "Block Case Number",
  "barcode.label.info.blockId": "Block ID",
  "barcode.label.info.blockNumber": "Block Number",
  "barcode.label.info.boxid": "Box ID",
  "barcode.label.info.caseNumber": "Case Number",
  "barcode.label.info.collectedBy": "Collected By",
  "barcode.label.info.collectionDate": "Collection Date",
  "barcode.label.info.collectionDateTime": "Collection Date and Time",
  "barcode.label.info.created": "Created",
  "barcode.label.info.destination": "Destination",
  "barcode.label.info.expiryDate": "Expiry Date",
  "barcode.label.info.labNumber": "Accession number",
  "barcode.label.info.patientDobFull": "Patient Date of Birth",
  "barcode.label.info.patientId": "Patient ID",
  "barcode.label.info.patientName": "Patient Name",
  "barcode.label.info.patientSexFull": "Patient Sex",
  "barcode.label.info.samplecount": "Samples",
  "barcode.label.info.siteId": "Site ID",
  "barcode.label.info.slideId": "Slide ID",
  "barcode.label.info.slideNumber": "Slide Number",
  "barcode.label.info.specimenType": "Specimen Type",
  "barcode.label.info.stainType": "Stain Type",
  "barcode.label.info.storageLocation": "Storage Location",
  "barcode.label.info.temperature": "Temperature",
  "barcode.label.info.tests": "Tests",
  "barcode.labels.order.row": "Order labels",
  "barcode.labels.running.total": "Running total",
  "barcode.labels.sample.row": "Specimen labels sample {sampleNumber}",
  "barcode.labels.section.title": "Label quantities",
  "barcode.locationNotFound": "Location not found",
  "barcode.notification.save": "BarCode Configurations has been saved.",
  "barcode.partialMatch": "Partial match - some components valid",
  "barcode.print.button": "Print",
  "barcode.print.dialog.quantityFor": "Quantity to print for {label}",
  "barcode.print.dialog.title": "Print labels",
  "barcode.print.done": "Done",
  "barcode.print.individual.button": "Print Label",
  "barcode.print.later": "Skip — Print Later",
  "barcode.print.preprint": "Pre-Print Barcodes",
  "barcode.print.preprint.button": "Pre-Print Labels",
  "barcode.print.preprint.note": "NOTE: If a facility and/or sample and test are added, they will be printed on EVERY label",
  "barcode.print.reprint.dialog": "Reprint labels",
  "barcode.print.section.set": "Print Sets",
  "barcode.print.set.button": "Print Set",
  "barcode.print.set.instruction": "Print set of labels (2 order labels + 1 label per specimen)",
  "barcode.print.skip": "Skip",
  "barcode.print.title": "Print Bar Code Labels",
  "barcode.ready": "Ready to scan",
  "barcode.scan": "Scan barcode",
  "barcode.scan.error": "Order not found",
  "barcode.scan.placeholder": "Scan barcode or enter lab number...",
  "barcode.scan.success": "Order loaded successfully",
  "barcode.scanning": "Scanning...",
  "barcode.scanOrType": "Scan barcode or type location",
  "barcode.success": "Location found",
  "barcode.validHierarchyPrefilled": "Valid hierarchy levels pre-filled",
  "barcode.validation.altPrefix": "Input should be alphanumeric and have a maximum length of 4 characters.",
  "barcode.validationFailed": "Barcode validation failed",
  "barcodeconfiguration.browse.title": "Barcode Configuration",
  "breadcrumb.home": "Home",
  "breadcrums.admin.managment": "Admin Management",
  "calendar.management.title": "Calendar Management",
  "calendar.management.description": "Manage public holidays and weekend configuration for working time TAT calculations",
  "calendar.management.addHoliday": "Add Holiday",
  "calendar.management.editHoliday": "Edit Holiday",
  "calendar.management.deleteConfirm": "Are you sure you want to delete this holiday?",
  "calendar.management.holidayName": "Holiday Name",
  "calendar.management.date": "Date",
  "calendar.management.recurring": "Recurring",
  "calendar.management.annual": "Annual",
  "calendar.management.oneTime": "One-time",
  "calendar.management.active": "Active",
  "calendar.management.inactive": "Inactive",
  "calendar.management.weekend": "Weekend",
  "calendar.management.weekendDays": "Weekend Days (excluded from Working Time)",
  "calendar.management.weekendSaved": "Weekend configuration saved",
  "calendar.management.importCsv": "Import CSV",
  "calendar.management.exportCsv": "Export CSV",
  "calendar.management.importPreview": "Import Preview",
  "calendar.management.year": "Year",
  "calendar.management.noHolidays": "No holidays configured for {year}. Click \"Add Holiday\" to get started.",
  "calendar.management.duplicateDate": "A holiday already exists for this date",
  "calendar.management.imported": "{count} holidays imported",
  "calendar.management.skipped": "{count} holidays skipped",
  "calendar.management.holidayCount": "{count} holidays configured for {year}",
  "calendar.management.saveError": "Error saving holiday",
  "calendar.management.loadError": "Error loading holidays",
  "calendar.management.save": "Save",
  "calendar.management.cancel": "Cancel",
  "calendar.management.actions": "Actions",
  "calendar.management.status": "Status",
  "calendar.management.column.date": "Date",
  "calendar.management.column.holidayName": "Holiday Name",
  "calendar.management.column.recurring": "Recurring",
  "calendar.management.column.status": "Status",
  "calendar.management.column.actions": "Actions",
  "calendar.management.day.sun": "Sun",
  "calendar.management.day.mon": "Mon",
  "calendar.management.day.tue": "Tue",
  "calendar.management.day.wed": "Wed",
  "calendar.management.day.thu": "Thu",
  "calendar.management.day.fri": "Fri",
  "calendar.management.day.sat": "Sat",
  "calendar.management.chooseFile": "Choose CSV file",
  "calendar.management.csvColumns": "Columns: date, name, recurring (true/false)",
  "calendar.management.rowsFound": "{count} rows found",
  "calendar.management.column.csvDate": "Date",
  "calendar.management.column.csvName": "Name",
  "calendar.management.column.csvRecurring": "Recurring",
  "calendar.management.importing": "Importing...",
  "reports.tat.title": "Turn Around Time Report",
  "reports.tat.description": "Analyze laboratory turnaround times across workflow milestones",
  "reports.tat.generateReport": "Generate Report",
  "reports.tat.clearFilters": "Clear Filters",
  "reports.tat.segment.orderToCollection": "Order to Collection",
  "reports.tat.segment.collectionToReceipt": "Collection to Receipt",
  "reports.tat.segment.receiptToTesting": "Receipt to Testing Started",
  "reports.tat.segment.receiptToResult": "Receipt to Result Entry",
  "reports.tat.segment.receiptToValidation": "Receipt to Validation",
  "reports.tat.segment.resultToValidation": "Result Entry to Validation",
  "reports.tat.segment.overall": "Overall TAT",
  "reports.tat.calendarTime": "Calendar Time",
  "reports.tat.workingTime": "Working Time",
  "reports.tat.workingTimeInfo": "Working Time mode: Excluding {weekendDays} and {holidayCount} public holidays in the selected date range",
  "reports.tat.configuredWeekends": "configured weekends",
  "reports.tat.noHolidaysWarning": "No public holidays configured. Configure holidays in Admin > Calendar Management.",
  "reports.tat.manageCalendar": "Manage Calendar",
  "reports.tat.totalResults": "Total Results",
  "reports.tat.meanTat": "Mean TAT",
  "reports.tat.medianTat": "Median TAT",
  "reports.tat.percentile90": "90th Percentile",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Max TAT",
  "reports.tat.stdDeviation": "Std Deviation",
  "reports.tat.distribution": "TAT Distribution",
  "reports.tat.breakdownBy": "Breakdown by",
  "reports.tat.clickRowHint": "Click a row to view individual results",
  "reports.tat.summary": "Summary",
  "reports.tat.detailList": "Detail List",
  "reports.tat.trends": "Trends",
  "reports.tat.noResults": "No results found for the selected filters. Try adjusting the date range or filter criteria.",
  "reports.tat.insufficientData": "Insufficient data",
  "reports.tat.loadError": "Error loading report data",
  "reports.tat.dateRange": "Date Range",
  "reports.tat.labUnit": "Lab Unit",
  "reports.tat.testPanel": "Test / Panel",
  "reports.tat.priority.all": "All",
  "reports.tat.priority.routine": "Routine",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Sample Type",
  "reports.tat.orderingSite": "Ordering Site",
  "reports.tat.priority": "Priority",
  "reports.tat.includeCancelled": "Include cancelled/rejected",
  "reports.tat.export": "Export",
  "reports.tat.exportCsv": "Export CSV",
  "reports.tat.exportPdf": "Export PDF",
  "reports.tat.labNumber": "Lab Number",
  "reports.tat.patient": "Patient",
  "reports.tat.test": "Test",
  "reports.tat.orderCreated": "Order Created",
  "reports.tat.collected": "Collected",
  "reports.tat.received": "Received",
  "reports.tat.testingStarted": "Testing Started",
  "reports.tat.resultEntered": "Result Entered",
  "reports.tat.validated": "Validated",
  "reports.tat.selectedTat": "Selected TAT",
  "reports.tat.overallTat": "Overall TAT",
  "reports.tat.columns": "Columns",
  "reports.tat.rowsPerPage": "Rows per page",
  "reports.tat.showing": "Showing {from}-{to} of {total} results",
  "reports.tat.trend": "Trend",
  "reports.tat.aggregation": "Aggregation",
  "reports.tat.daily": "Daily",
  "reports.tat.weekly": "Weekly",
  "reports.tat.monthly": "Monthly",
  "reports.tat.compareBy": "Compare by",
  "reports.tat.showVolume": "Show order volume",
  "reports.tat.mean": "Mean",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Date Range (From)",
  "reports.tat.dateRangeTo": "Date Range (To)",
  "reports.tat.tatSegment": "TAT Segment",
  "reports.tat.metrics": "Metrics",
  "reports.tat.compareNone": "None",
  "reports.tat.comparePriority": "Priority",
  "reports.tat.column.labNumber": "Lab Number",
  "reports.tat.column.test": "Test",
  "reports.tat.column.labUnit": "Lab Unit",
  "reports.tat.column.priority": "Priority",
  "reports.tat.column.ordered": "Ordered",
  "reports.tat.column.collected": "Collected",
  "reports.tat.column.received": "Received",
  "reports.tat.column.started": "Started",
  "reports.tat.column.resulted": "Resulted",
  "reports.tat.column.validated": "Validated",
  "reports.tat.column.selectedTat": "Selected TAT",
  "reports.tat.column.overallTat": "Overall TAT",
  "reports.tat.column.name": "Name",
  "reports.tat.column.count": "Count",
  "reports.tat.column.mean": "Mean",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "90th %ile",
  "reports.tat.column.max": "Max",
  "reports.tat.home": "Home",
  "reports.tat.all": "All",
  "reports.tat.preset.today": "Today",
  "reports.tat.preset.7days": "Last 7 Days",
  "reports.tat.preset.30days": "Last 30 Days",
  "reports.tat.preset.90days": "Last 90 Days",
  "reports.tat.preset.thisMonth": "This Month",
  "reports.tat.preset.lastMonth": "Last Month",
  "reports.tat.preset.thisQuarter": "This Quarter",
  "button.cancel": "Cancel",
  "button.activate": "Activate",
  "button.adjust": "Adjust",
  "button.deactivate": "Deactivate",
  "button.dispose": "Dispose",
  "button.edit": "Edit",
  "button.generate": "Generate",
  "button.label.genarateReport": "Generate Report",
  "button.label.loadnext": "Load Next Bundle",
  "button.label.loadprevious": "Load Previous Bundle",
  "button.label.showHidePram": "Show/Hide Report Parameter",
  "button.record": "Record",
  "button.save": "Save",
  "button.save.draft": "Save Draft",
  "button.save.next": "Save & Next",
  "button.save.stay": "Save",
  "button.send": "Send",
  "calculatedTests": "Calculated Tests",
  "catalog.item.activate.success": "Catalog item activated successfully",
  "catalog.item.category": "Category",
  "catalog.item.compatibleAnalyzers": "Compatible Analyzers",
  "catalog.item.deactivate.confirm.button": "Deactivate",
  "catalog.item.deactivate.confirm.message": "Are you sure you want to deactivate {itemName}?",
  "catalog.item.deactivate.confirm.title": "Confirm Deactivation",
  "catalog.item.deactivate.implications.1": "This item will no longer appear in active item lists",
  "catalog.item.deactivate.implications.2": "Existing lots for this item will remain accessible",
  "catalog.item.deactivate.implications.3": "You can reactivate this item later if needed",
  "catalog.item.deactivate.implications.title": "Implications:",
  "catalog.item.deactivate.label": "Deactivate Item",
  "catalog.item.deactivate.success": "Item deactivated successfully",
  "catalog.item.form.title.add": "Add New Catalog Item",
  "catalog.item.form.title.edit": "Edit Catalog Item",
  "catalog.item.lowStockThreshold": "Low Stock Threshold",
  "catalog.item.manufacturer": "Manufacturer",
  "catalog.item.minimumStock": "Minimum Stock Level",
  "catalog.item.name": "Item Name",
  "catalog.item.reorderLevel": "Reorder Level",
  "catalog.item.reorderQuantity": "Reorder Quantity",
  "catalog.item.save.error": "Error saving catalog item",
  "catalog.item.save.success": "Catalog item saved successfully",
  "catalog.item.stabilityAfterOpening": "Stability After Opening (days)",
  "catalog.item.status": "Status",
  "catalog.item.storageRequirements": "Storage Requirements",
  "catalog.item.testTypes": "Test Types",
  "catalog.item.testsPerCartridge": "Tests Per Cartridge",
  "catalog.item.testsPerKit": "Tests Per Kit",
  "catalog.item.type": "Item Type",
  "catalog.item.units": "Units",
  "catalog.search.placeholder": "Search by item name",
  "choose.availablepanel": "Choose Available panel",
  "coldStorage.action.createSuccess": "Corrective action created successfully",
  "coldStorage.action.retractSuccess": "Corrective action retracted successfully",
  "coldStorage.action.updateSuccess": "Corrective action updated successfully",
  "coldStorage.actions": "Actions",
  "coldStorage.activated": "activated",
  "coldStorage.addDevicesMessage": "Please add devices in Device Management to configure temperature thresholds.",
  "coldStorage.addNewDevice": "Add New Device",
  "coldStorage.alert.equipment": "Equipment Failure",
  "coldStorage.alert.equipment.description": "Alerts for equipment malfunctions or connectivity issues",
  "coldStorage.alert.inventory": "Inventory Alerts",
  "coldStorage.alert.inventory.description": "Alerts for low inventory or stock management",
  "coldStorage.alert.saveFailed": "Failed to save notification preferences: ",
  "coldStorage.alert.saveSuccess": "Notification preferences saved successfully. Each alert type will use its configured notification methods.",
  "coldStorage.alert.temperature": "Temperature Alerts",
  "coldStorage.alert.temperature.description": "Alerts triggered when freezer temperature exceeds defined thresholds",
  "coldStorage.alert.type": "Alert Type",
  "coldStorage.alertConfiguration": "Alert Configuration",
  "coldStorage.autoEscalate": "Automatically escalate unresolved alerts",
  "coldStorage.bacnetUdpPort": "BACnet UDP Port",
  "coldStorage.button.delete": "Delete",
  "coldStorage.config.saveSuccess": "System configuration saved successfully",
  "coldStorage.configMoved": "Configuration Moved to Admin Panel",
  "coldStorage.configMovedDesc": "System-wide settings should be managed in the Admin UI where all global configurations are centralized. This page is read-only and will be removed in a future release.",
  "coldStorage.configuredDevices": "Configured Devices",
  "coldStorage.criticalThreshold": "Critical Threshold (°C)",
  "coldStorage.databaseVersion": "Database Version",
  "coldStorage.deactivated": "deactivated",
  "coldStorage.description": "Description",
  "coldStorage.device.activate": "Activate device",
  "coldStorage.device.activateMessage": "Activating this device will enable monitoring and data collection.",
  "coldStorage.device.changeStatus": "Change Device Status",
  "coldStorage.device.changeStatusOf": "Change the status of {name}:",
  "coldStorage.device.created": "Device created successfully",
  "coldStorage.device.createdSuccess": "Device \"{name}\" has been created successfully",
  "coldStorage.device.deactivate": "Deactivate device",
  "coldStorage.device.deactivateMessage": "Deactivating this device will stop monitoring and data collection. Historical data will be preserved.",
  "coldStorage.device.delete": "Delete Device",
  "coldStorage.device.deleteConfirm": "Are you sure you want to delete {name}?",
  "coldStorage.device.deleteWarning": "This will mark the device as inactive and remove it from active monitoring. Historical data will be preserved.",
  "coldStorage.device.deleted": "Device \"{name}\" has been deleted successfully",
  "coldStorage.device.deviceStatus": "Device Status",
  "coldStorage.device.edit": "Edit device",
  "coldStorage.device.id": "Device ID",
  "coldStorage.device.ipAddress": "IP Address",
  "coldStorage.device.port": "Port",
  "coldStorage.device.protocol": "Protocol",
  "coldStorage.device.roomFacility": "Room/Facility",
  "coldStorage.device.statusChanged": "Device \"{name}\" has been {status} successfully",
  "coldStorage.device.type": "Type",
  "coldStorage.device.updated": "Device updated successfully",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Email Notifications & SMS Notifications",
  "coldStorage.error.createAction": "Failed to create corrective action. Please try again.",
  "coldStorage.error.createDevice": "Failed to create device: ",
  "coldStorage.error.createRoom": "Failed to create room: ",
  "coldStorage.error.deleteDevice": "Failed to delete device: ",
  "coldStorage.error.loadActions": "Failed to load corrective actions. Please try again.",
  "coldStorage.error.loadConfig": "Failed to load system configuration: ",
  "coldStorage.error.loadDevices": "Failed to load devices: ",
  "coldStorage.error.loadLocations": "Failed to load locations: ",
  "coldStorage.error.loadUsers": "Failed to load user list. Please try again later.",
  "coldStorage.error.retractAction": "Failed to retract corrective action. Please try again.",
  "coldStorage.error.saveConfig": "Failed to save system configuration: ",
  "coldStorage.error.saveThreshold": "Failed to save threshold configuration: ",
  "coldStorage.error.toggleStatus": "Failed to toggle device status: ",
  "coldStorage.error.updateAction": "Failed to update corrective action. Please try again.",
  "coldStorage.error.updateDevice": "Failed to update device: ",
  "coldStorage.escalationDelay": "Escalation Delay (minutes)",
  "coldStorage.escalationDelayHelper": "Time to wait before escalating an unresolved alert",
  "coldStorage.escalationRules": "Escalation Rules",
  "coldStorage.filter.activeOnly": "Active Only",
  "coldStorage.filter.all": "All Devices",
  "coldStorage.filter.inactiveOnly": "Inactive Only",
  "coldStorage.granularNotificationControl": "Granular Notification Control",
  "coldStorage.granularNotificationControlDesc": "Configure email and SMS notifications for each alert type independently. Enable the notification methods you want for each specific alert category.",
  "coldStorage.howNotificationsWork": "How Notifications Work",
  "coldStorage.howNotificationsWorkDesc": "When an alert is triggered (temperature threshold violation, equipment failure, etc.), the system will:",
  "coldStorage.lastUpdate": "Last Update",
  "coldStorage.loadingConfig": "Loading system configuration...",
  "coldStorage.loadingDevices": "Loading devices...",
  "coldStorage.loadingPrefs": "Loading notification preferences...",
  "coldStorage.modbusTcpPort": "Modbus TCP Port",
  "coldStorage.name": "Name",
  "coldStorage.noConfigFound": "No Configuration Found",
  "coldStorage.noDevicesConfigured": "No Devices Configured",
  "coldStorage.notification.createRecord": "Create an alert record in the system (visible in Dashboard)",
  "coldStorage.notification.logAttempt": "Log the notification attempt for audit trail purposes",
  "coldStorage.notification.sendEmail": "Send EMAIL notifications if enabled (to configured recipients)",
  "coldStorage.notification.sendSms": "Send SMS notifications if enabled (to configured phone numbers)",
  "coldStorage.pollInterval": "Poll Interval (seconds)",
  "coldStorage.protocolConfiguration": "Protocol Configuration",
  "coldStorage.readOnlyMode": "Read-Only Mode",
  "coldStorage.readOnlyModeDesc": "To modify these settings, please navigate to Admin → System Configuration",
  "coldStorage.room.addNew": "Add New Room",
  "coldStorage.room.create": "Create Room",
  "coldStorage.room.created": "Room created successfully",
  "coldStorage.room.description": "Description",
  "coldStorage.room.descriptionPlaceholder": "Enter room description (optional)",
  "coldStorage.room.name": "Room Name *",
  "coldStorage.room.namePlaceholder": "Enter room name (e.g., Lab Storage Room A)",
  "coldStorage.saveNotificationPrefs": "Save Notification Preferences",
  "coldStorage.saveThresholdConfig": "Save Threshold Configuration",
  "coldStorage.saving": "Saving...",
  "coldStorage.search.placeholder": "Search by Device ID or Name",
  "coldStorage.securitySettings": "Security Settings",
  "coldStorage.sessionTimeout": "Session Timeout",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Status",
  "coldStorage.status.active": "ACTIVE",
  "coldStorage.status.inactive": "INACTIVE",
  "coldStorage.supervisorEmail": "Supervisor Email",
  "coldStorage.supervisorEmailHelper": "Email address to send escalated alerts",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.systemConfiguration": "System Configuration",
  "coldStorage.systemInformation": "System Information",
  "coldStorage.systemVersion": "System Version",
  "coldStorage.targetTemperature": "Target Temperature (°C)",
  "coldStorage.threshold.saveSuccess": "Threshold configuration saved successfully",
  "coldStorage.thresholdConfiguration": "Temperature Threshold Configuration",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Uptime",
  "coldStorage.usingDefaults": "Using default notification settings. Save to create configuration.",
  "coldStorage.validation.error": "Validation Error",
  "coldStorage.validation.retractionReason": "Please provide a reason for retraction",
  "coldStorage.validation.selectActionType": "Please select an action type",
  "coldStorage.validation.selectDevice": "Please select a device",
  "coldStorage.validation.selectRoom": "Please select a room/location for the device",
  "coldStorage.warningThreshold": "Warning Threshold (°C)",
  "collect.addSample.button": "Add Sample",
  "collect.assign.addToSample": "Add to existing sample",
  "collect.assign.button": "Assign Tests",
  "collect.assign.description": "Assign requested tests to sample tubes",
  "collect.assign.newSample": "Create new sample",
  "collect.assign.newSampleHelp": "Select sample type for the new tube",
  "collect.assign.noExisting": "No existing samples available",
  "collect.assign.title": "Test Assignment",
  "collect.multiSampleExample.description": "When multiple sample types are needed",
  "collect.multiSampleExample.result": "Creates separate tubes for each type",
  "collect.multiSampleExample.title": "Multi-Sample Collection Example",
  "collect.noSampleYet": "No samples collected yet",
  "collect.noTestsOrdered": "No tests have been ordered",
  "collect.noTestsWarning.subtitle": "Add samples with tests in Step 1 before proceeding",
  "collect.noTestsWarning.title": "No tests to collect",
  "collect.printMoreLabels.button": "Print More Labels",
  "collect.printMoreLabels.helper": "Print additional labels for this sample",
  "collect.requestedTests.info": "Tests requested for this order",
  "collect.requestedTests.title": "Requested Tests",
  "collect.sample.assignedTests": "Assigned Tests",
  "collect.sample.collectionConditions": "Collection Conditions",
  "collect.sample.collectionConditions.placeholder": "Note any special conditions...",
  "collect.sample.collectionDate": "Collection Date",
  "collect.sample.collectionDate.helper": "Date when the sample was collected",
  "collect.sample.collectionTime": "Collection Time",
  "collect.sample.collector": "Collector",
  "collect.sample.header": "Sample {number}",
  "collect.sample.nce.link": "Report Non-Conforming Event",
  "collect.sample.noTests": "No tests assigned to this sample",
  "collect.sample.printLabels": "Print Labels",
  "collect.sample.quantity": "Quantity",
  "collect.sample.receivedAtLab": "Received at Lab",
  "collect.sample.receivedAtLab.helper": "Check if sample has been received at the laboratory",
  "collect.sample.receivedDate": "Received Date",
  "collect.sample.receivedTime": "Received Time",
  "collect.sample.remove": "Remove Sample",
  "collect.samples.title": "Samples",
  "collect.table.compatibleTypes": "Compatible Sample Types",
  "collect.table.sampleAssignments": "Sample Assignments",
  "collect.table.testPanel": "Test/Panel",
  "heading.informedConsent.sectionTitle": "Informed Consent",
  "heading.informedConsent.auditRecord": "Consent Audit Record",
  "label.informedConsent.consentGiven": "Patient has provided signed consent",
  "label.informedConsent.formReference": "Consent Form Reference No.",
  "label.informedConsent.recordedBy": "Recorded by",
  "label.informedConsent.recordedAt": "Recorded on",
  "label.informedConsent.statusTag": "Consent Recorded",
  "label.informedConsent.notRecorded": "Not recorded",
  "placeholder.informedConsent.formReference": "e.g. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "e.g. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Consent form reference must be 100 characters or fewer",
  "error.informedConsent.formReferenceInvalidChars": "Only letters, numbers, hyphens, and spaces are allowed",
  "coldstorage.label.dashboard": "Cold Storage Dashboard",
  "collection.date": "Collection Date",
  "collector": "Collector",
  "collector.label": "Collector",
  "column.actions": "Actions",
  "column.name.accept": "Accept",
  "column.name.analyzerResult": "Analyzer Result",
  "column.name.currentResult": "Current Result",
  "column.name.ignore": "Ignore",
  "column.name.normalRange": "Normal Range",
  "column.name.notes": "Notes",
  "column.name.pastNotes": "Past Notes",
  "column.name.reject": "Reject",
  "column.name.result": "Result",
  "column.name.retest": "Retest",
  "column.name.sampleInfo": "Sample Info",
  "column.name.save": "Save",
  "column.name.testDate": "Test Date",
  "column.name.testId": "Test Id",
  "column.name.testName": "Test Name",
  "common.properties.title": "Common Properties",
  "configuration.batch.test.reassignment": "Batch test reassignment and cancelation",
  "configuration.method": "Manage Methods",
  "configuration.method.create": "Create New Method",
  "configuration.method.explain": "Use to create a new method, activate or deactivate a method",
  "configuration.method.rename": "Rename existing method names",
  "configuration.method.rename.explain": "Use to correct the name of existing methods",
  "configuration.panel.assign": "Test Assignment",
  "configuration.panel.assign.explain": "Select tests to re-assign to a different panel by clicking the test name; they are displayed under their currently assigned panel.",
  "configuration.panel.confirmation.explain": "This panel will not be active until at least one test has been assigned to it.",
  "configuration.panel.create": "Create New Panel",
  "configuration.panel.create.duplicate": "An existing panel type with the same name has been found. Please cancel or use a different name.",
  "configuration.panel.manage": "Manage Panels",
  "configuration.panel.manage.explain": "Use to create, set display order or assign tests to panels",
  "configuration.panel.order": "Set Panel Order",
  "configuration.panel.order.explain": "Sort panels by clicking a type and dragging it into the proper order.",
  "configuration.panel.order.explain.limits": "Only panels with tests assigned may be ordered. For new panels please assign tests before ordering.",
  "configuration.panel.rename": "Rename Existing Panels",
  "configuration.panel.rename.explain": "Use to correct the name of existing panels.",
  "configuration.sampleType.assign.explain": "Select tests to re-assign to a different sample type by clicking the test name; they are displayed under their currently assigned sample type.",
  "configuration.sampleType.assign.new.type": "Assign to sample type",
  "configuration.sampleType.confirmation.explain": "This sample type will not be active until at least one test has been assigned to it.",
  "configuration.sampleType.create": "Create New Sample Type",
  "configuration.sampleType.create.duplicate": "An existing test sample type with the same name has been found.  Please cancel or use a different name.",
  "configuration.sampleType.manage": "Manage Sample Types",
  "configuration.sampleType.manage.explain": "Use to create, set display order or assign tests to sample types",
  "configuration.sampleType.order": "Set Sample Type Order",
  "configuration.sampleType.order.explain": "Sort sample types by clicking a type and dragging it into the proper order.",
  "configuration.sampleType.order.explain.limits": "Only sample types with tests assigned may be ordered.  For new types please assign tests before ordering.",
  "configuration.selectList.add": "Add result select list",
  "configuration.selectList.add.alert": "To change spelling of current result list entries use Rename existing result list options",
  "configuration.selectList.add.explain": "use to create result select list for test results",
  "configuration.selectList.assign.description": "The new entry may be assigned to tests or it may be saved without assignment. Select one or more tests for assignment and then adjust the display order. If the new entry should be the normal range value for the selected test check the box labeled `Normal`. If it is desired that the technician should enter text with the result selection to further qualify the results then check the box labeled `Qualifiable`, For instance; if the options are a list of organisms and the last option is `Other` then the user could enter an organism not on the list.",
  "configuration.selectList.assign.header": "Assign new result selection to test",
  "configuration.selectList.assign.new": "New select list option",
  "configuration.selectList.confirmChange": "The normal value will bechanged from %oldvalue% to %newvalue%, are you sure you would like to proceed?",
  "configuration.selectList.description": "Enter both English and French for new selection option. If you don't know the translation then the entered term  will be used for both languages.",
  "configuration.selectList.header": "Create new result selection option",
  "configuration.selectList.rename": "Rename existing result list options",
  "configuration.selectList.rename.explain": "Rename existing result list options",
  "configuration.test.activate": "Activate/Deactivate tests",
  "configuration.test.activate.explain": "Use to activate or deactivate an existing test.",
  "configuration.test.add": "Add new tests",
  "configuration.test.add.explain": "Use to add new tests to the system.  Modification of existing tests should be done through the other test management links",
  "configuration.test.catalog": "View Test Catalog",
  "configuration.test.catalog.explain": "View the current test catalog",
  "configuration.test.management.ocl": "OCL Concept Import",
  "configuration.test.management.organization": "Test Organization",
  "configuration.test.management.spelling": "Spelling corrections",
  "configuration.test.modify": "Modify tests",
  "configuration.test.modify.explain": "Use to modify existing tests in the system.",
  "configuration.test.modify.tab.configuration": "Configuration",
  "configuration.test.modify.tab.compliance": "Compliance Thresholds",
  "configuration.test.modify.filter.instruction": "Select a Sample Type or Test Section to display tests.",
  "configuration.test.modify.filter.noTestsFound": "No tests found matching the selected criteria.",
  "configuration.test.modify.filter.selectToBegin": "Please select a Sample Type or Test Section to begin viewing tests.",
  "configuration.test.orderable": "Enable/disable test orderability",
  "configuration.test.orderable.explain": "Tests that are orderable can be ordered on intake. If they are not orderable then they can only be ordered as a result of a reflex",
  "configuration.test.rename": "Rename existing test names",
  "configuration.test.rename.explain": "Use to rename existing tests.  Will not change test, only how the user sees them in OpenELIS and on reports",
  "configuration.testSection.rename": "Rename Existing Test Sections",
  "configuration.testSection.rename.explain": "Use to correct the name of existing test sections.",
  "configuration.testUnit.assign.new.unit": "Assign to test section",
  "configuration.testUnit.confirmation.explain": "This test unit will not be active until at least one test has been assigned to it.",
  "configuration.testUnit.create": "Create New Test Unit",
  "configuration.testUnit.create.duplicate": "An existing test unit with the same name has been found.  Please cancel or use a different name.",
  "configuration.testUnit.manage": "Manage Test Units",
  "configuration.testUnit.manage.explain": "Use to create, set display order or assign tests to test units",
  "configuration.testUnit.order": "Set Test Unit Order",
  "configuration.testUnit.order.explain": "Sort lab units by clicking a unit and dragging it into the proper order.",
  "configuration.testUnit.order.explain.limits": "Only test sections with tests assigned may be ordered.  For new sections please assign tests before ordering.",
  "configuration.type.rename": "Rename Existing Sample Types",
  "configuration.type.rename.explain": "Use to correct the name of existing sample types.",
  "configuration.uom.create": "Create New Units of Measure",
  "configuration.uom.manage": "Manage Units of Measure",
  "configuration.uom.manage.explain": "Use to create Units of Measure",
  "configuration.uom.rename": "Rename Existing Unit of Measure Entries",
  "configuration.uom.rename.explain": "Use to correct the name of existing unit of measure entries.",
  "configure.labNumber.title": "Lab Number Management",
  "confirmation.rename": "Confirm Changes above you made.",
  "currentests.title": "Current Tests",
  "cytology.label.cellabnomality": "Epithelial Cell Abnomality",
  "cytology.label.confirmSelect": "If you select this option, all current diagnosis information  will be removed",
  "cytology.label.dashboard": "Cytology DashBoard",
  "cytology.label.glandular": "Glandular",
  "cytology.label.negative": "Negative For Intraepithelial Lesion or Malignancy",
  "cytology.label.neoplastic": "Non-neoplastic cellular variations",
  "cytology.label.organisms": "Organisms",
  "cytology.label.other": "Other Malignant Neoplasms",
  "cytology.label.otherResult": " Other Diagnosis Result",
  "cytology.label.reactive": "Reactive cellular changes",
  "cytology.label.review": "Awaiting Cytopathologist Review",
  "cytology.label.specimen": "Specimen Adequacy",
  "cytology.label.squamous": "Squamous",
  "cytology.label.title": "Cytology",
  "dashboard.avg.turn.around.label": "Average Turn Around time",
  "dashboard.avg.turn.around.reception.to.result.label": "Reception To Result Average Time",
  "dashboard.avg.turn.around.reception.to.validation.label": "Reception To Validation Average Time",
  "dashboard.avg.turn.around.result.to.validation.label": "Result To Validation Average Time",
  "dashboard.avg.turn.around.subtitle.label": "Reception to Validation",
  "dashboard.complete.orders.label": "Orders Completed Today",
  "dashboard.in.progress.label": "In Progress",
  "dashboard.in.progress.subtitle.label": "Awaiting Result Entry",
  "dashboard.partially.completed.label": "Partially Completed Today",
  "dashboard.partially.completed.subtitle.label": "Awaiting Remaining Tests",
  "dashboard.rejected.orders": "Orders Rejected Today",
  "dashboard.turn.around.label": "Delayed Turn Around",
  "dashboard.turn.around.subtitle.label": "More Than 96 hours",
  "dashboard.unprints.results.label": "UnPrinted Results Today",
  "dashboard.user.orders.label": "Orders Entered By Users Today",
  "dashboard.user.orders.today.label": "Orders Entered By User Today",
  "dashboard.validation.ready.label": "Ready For Validation",
  "dashboard.validation.ready.subtitle.label": "Awaiting Review",
  "dataexport.status.actions": "Actions",
  "dataexport.status.attempt.duration": "Duration",
  "dataexport.status.attempt.endTime": "End Time",
  "dataexport.status.attempt.startTime": "Start Time",
  "dataexport.status.attempt.status": "Status",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No FHIR subscribers are configured. Set org.openelisglobal.fhir.subscriber in common.properties and restart the server to register one.",
  "dataexport.status.endpoint": "Endpoint",
  "dataexport.status.failed24h": "Failed / Total (24h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Retry Interval",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Last Attempt",
  "dataexport.status.lastRefreshed": "Last refreshed",
  "dataexport.status.lastStatus": "Last Status",
  "dataexport.status.lastSuccess": "Last Success",
  "dataexport.status.loadingAttempts": "Loading attempt history…",
  "dataexport.status.never": "Never",
  "dataexport.status.noAttempts": "No attempts yet",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Refresh",
  "dataexport.status.retry": "Retry now",
  "dataexport.status.retryInFlight": "Triggering…",
  "dataexport.status.title": "FHIR Data Export Status",
  "datasubmission.siteid": "Site Id",
  "database.clean": "Database Cleaning",
  "database.clean.button": "Clean Database",
  "database.clean.confirm.message": "Are you sure you want to clean the database? This will remove all patient and test data.",
  "database.clean.confirm.title": "Confirm Database Cleaning",
  "database.clean.confirm.warning": "This action cannot be undone!",
  "database.clean.error": "Failed to clean the database.",
  "database.clean.not.training": "Database cleaning is only available on training installations.",
  "database.clean.success": "Database cleaned successfully.",
  "database.clean.warning": "This will permanently delete all patient data, sample data, and results from the database.",
  "date.created": "Date Created",
  "delete.error.msg": "Error while Deleting",
  "delete.success.msg": "Successfully Deleted",
  "description.active": "If the test is active it can be ordered on the order form or as part of a test algorithm. If it is not active it cannot be ordered or be part of a test algorithm",
  "description.ageRange": "If the age range (in months) matters for the given values it will be specified here.",
  "description.name": "The name of the test as it will appear within openELIS. Both English and French are shown",
  "description.normalRange": "Any numeric result within this range is what is expected in a healthy person.",
  "description.note": "n/a means not available. The value is not specified.",
  "description.orderable": "If a test is active and orderable then it can be ordered on an order form. If it is active but not orderable then it will only be done if it is reflexed from another test",
  "description.panel": "If this test is part of a test panel then the panel will be named here.",
  "description.referenceValue": "The value of a selection for a healthy person. Only given for select list results.",
  "description.reportName": "The name of the test as it will appear in reports. Both English and French are shown",
  "description.resultLimits": "The limits of normal and valid results for numeric tests. The values can depend on both the age and sex of the patient.",
  "description.resultType": "The kind of result for this test:",
  "description.resultType.alphanumeric": "A - Alphanumeric:",
  "description.resultType.alphanumericDesc": " Accepts either numeric or text in a text box. It will not be evaluated for being normal or valid.",
  "description.resultType.cascadingMultiSelectList": "C - Cascading multi-select list:",
  "description.resultType.cascadingMultiSelectListDesc": " Similar to multi-select but the user will be able to select multiple groups from the dropdown list.",
  "description.resultType.kind": "The kind of result for this test:",
  "description.resultType.multiSelectList": "M - Multi-select list:",
  "description.resultType.multiSelectListDesc": " The user will be able to select one or more values from a dropdown list. No reference value will be specified.",
  "description.resultType.numeric": "N - Numeric:",
  "description.resultType.numericDesc": " Accepts only numeric results in a text box. Results can be evaluated as to being in a normal or a valid range.",
  "description.resultType.selectList": "D - Select list:",
  "description.resultType.selectListDesc": " User will be able to select from a dropdown list. The normal value will be specified as the reference value.",
  "description.resultType.textArea": "R-Free text:",
  "description.resultType.textAreaDesc": " Accepts up to 200 characters in a text area. It will not be evaluated for being normal or valid.",
  "description.sampleType": "The type of sample on which the test can be done. If the intake technician is able to select the type of sample after they have ordered the test it will be marked as user to indicate that the user will select the type",
  "description.selectValues": "Only specified for select, multi-select or cascading multi-select results. These are the available selections shown to the user. If the selection is marked as 'qualifiable' then when the user selects that value they will be able to enter additional information in a text box.",
  "description.sex": "If the sex of the patient matters for the given values it will be specified here.",
  "description.significantDigits": "The number of significant digits for numeric results. Entered results will be rounded or padded to the correct number of digits. The normal range will also be displayed with the correct number of significant digits.",
  "description.testUnit": "Which section of the lab performs the test. This is also known as a test section.",
  "description.uom": "Unit of measure for the test. This usually only applies to numeric or alphanumeric result types.",
  "description.validRange": "Any numeric result not in this range is an indication that the test may not have been done correctly.",
  "dictionary.category.isActive": "Is Active",
  "dictionary.category.label": "Dictionary Category",
  "dictionary.category.localAbbreviation": "Local Abbreviation",
  "dictionary.category.name": "Category",
  "dictionary.dictEntry": "Dictionary Entry",
  "dictionary.label.modify": "Dictionary Menu",
  "dictionary.loincCode": "LOINC Code",
  "dictionary.loincCode.help": "Enter standard LOINC identifier",
  "dictionary.loincCode.helpText": "Standard laboratory observation identifier",
  "dictionary.loincCode.invalid": "Invalid LOINC format (expected: 12345-6 or LP12345-6)",
  "dictionary.loincCode.placeholder": "e.g. 12345-6",
  "dictionary.menu.deactivate.fail": "Dictionary Menu Deactivation Failed",
  "dictionary.menu.deactivate.success": "Dictionary Menu deactivated successfully",
  "dictionary.modal.add.heading": "Add Dictionary",
  "dictionary.modal.edit.heading": "Edit Dictionary",
  "dictionary.number.label": "Dictionary Number",
  "disposal.button": "Dispose Lot",
  "disposal.notes": "Disposal Notes",
  "disposal.notes.placeholder": "Provide details about disposal (disposal method, witness, etc.)",
  "disposal.reason": "Disposal Reason",
  "disposal.reason.select": "Select reason",
  "disposal.success": "Lot disposed successfully",
  "disposal.title": "Dispose Lot",
  "disposal.warning.message": "This action cannot be undone. The lot will be marked as disposed and removed from active inventory.",
  "disposal.warning.title": "Warning",
  "edit.add.program.title": "Add/Edit Program",
  "emergencyContactInfo.title": "Emergency Contact Info",
  "english.current": "ENGLISH current",
  "english.label": "English",
  "enterText.label": "Enter text rest",
  "eorder.allInfo": "All Info",
  "eorder.button.editOrder": "Edit Order",
  "eorder.button.enterOrder": "Enter Order",
  "eorder.buttons": " ",
  "eorder.date.end": "End Date",
  "eorder.date.start": "Start Date",
  "eorder.facility.requesting": "Requesting Facility",
  "eorder.header": "Search Incoming Test Requests",
  "eorder.id.national": "National Id",
  "eorder.id.subjectNumber": "Subject Number",
  "eorder.instructions.enter1": "Test Requests Matching Search - In the ",
  "eorder.instructions.enter2": " menu, add a lab number and select ",
  "eorder.instructions.enter3": " to accept the order as is, or select ",
  "eorder.instructions.enter4": " to make changes ",
  "eorder.labNumber": "Lab Number",
  "eorder.labnumber.referring": "Referring Lab Number",
  "eorder.name.first": "First Name",
  "eorder.name.last": "Last Name",
  "eorder.passport.number": "Passport Number",
  "eorder.priority": "Priority",
  "eorder.requestDate": "Request Date",
  "eorder.search.noresults": "No Electronic Orders",
  "eorder.search1.text": "Search by family name, national ID number, lab number from referring lab, or passport number",
  "eorder.search2.text": "Search by Date, and Status Enter the date range for test requests. This will search by the date of the referral, or the order date of the electronic request",
  "eorder.searchValue": "Search Value",
  "eorder.status": "Status",
  "eorder.test.name": "Test Name",
  "eqa.action.deactivate": "Deactivate",
  "eqa.action.edit": "Edit",
  "eqa.action.enterResults": "Enter Results",
  "eqa.action.enterViewResults": "Enter/View Results",
  "eqa.action.reactivate": "Reactivate",
  "eqa.action.viewOrder": "View Order",
  "eqa.action.viewResults": "View Results",
  "eqa.admin.addProgram": "Add Program",
  "eqa.admin.col.actions": "Actions",
  "eqa.admin.col.category": "Category",
  "eqa.admin.col.frequency": "Frequency",
  "eqa.admin.col.participants": "Enrolled Participants",
  "eqa.admin.col.programName": "Program Name",
  "eqa.admin.col.provider": "Provider",
  "eqa.admin.delete": "Delete",
  "eqa.admin.form.addHeading": "Add New EQA Program",
  "eqa.admin.form.category.placeholder": "Select category",
  "eqa.admin.form.description.placeholder": "Program description and objectives...",
  "eqa.admin.form.editHeading": "Edit EQA Program",
  "eqa.admin.form.frequency.placeholder": "Select frequency",
  "eqa.admin.form.name.placeholder": "e.g., TB Culture & Sensitivity",
  "eqa.admin.form.provider.placeholder": "Select provider",
  "eqa.admin.form.subtitle": "Enroll in a new external quality assessment program",
  "eqa.admin.programs.subtitle": "Manage enrolled EQA programs and providers",
  "eqa.admin.programs.title": "EQA Programs",
  "eqa.admin.provider.placeholder": "e.g., WHO, CDC, CAP",
  "eqa.admin.subtitle": "Manage EQA programs, users, and system settings",
  "eqa.admin.systemSettings.placeholder": "System settings coming soon.",
  "eqa.admin.tab.participants": "Participants",
  "eqa.admin.tab.programs": "EQA Programs",
  "eqa.admin.tab.systemSettings": "System Settings",
  "eqa.admin.tab.userManagement": "User Management",
  "eqa.admin.tile.acrossAllPrograms": "Across all programs",
  "eqa.admin.tile.activePrograms": "Active Programs",
  "eqa.admin.tile.canManageEqa": "Can manage EQA",
  "eqa.admin.tile.enrolledParticipants": "Enrolled Participants",
  "eqa.admin.tile.systemUsers": "System Users",
  "eqa.admin.tile.totalParticipants": "Total Participants",
  "eqa.admin.tile.totalPrograms": "{count} total programs",
  "eqa.admin.title": "Program Administration",
  "eqa.admin.userManagement.placeholder": "User management coming soon.",
  "eqa.column.actions": "Actions",
  "eqa.deadline.label": "Testing Deadline",
  "eqa.distribution.action.continue": "Continue",
  "eqa.distribution.action.ship": "Ship",
  "eqa.distribution.action.track": "Track",
  "eqa.distribution.action.viewReport": "View Report",
  "eqa.distribution.advance": "Advance Status",
  "eqa.distribution.backToDashboard": "Back to Distributions",
  "eqa.distribution.barcodes": "Generate Barcodes",
  "eqa.distribution.col.actions": "Actions",
  "eqa.distribution.col.deadline": "Deadline",
  "eqa.distribution.col.participants": "Participants",
  "eqa.distribution.col.program": "Program",
  "eqa.distribution.col.responses": "Responses",
  "eqa.distribution.col.round": "Round",
  "eqa.distribution.col.samples": "Samples",
  "eqa.distribution.col.shipmentId": "Shipment ID",
  "eqa.distribution.col.status": "Status",
  "eqa.distribution.create": "Create Distribution",
  "eqa.distribution.createError": "Failed to create distribution.",
  "eqa.distribution.createShipment": "Create New Shipment",
  "eqa.distribution.createSuccess": "Distribution created successfully.",
  "eqa.distribution.dashboard.subtitle": "Distribute EQA samples to participating laboratories",
  "eqa.distribution.dashboard.title": "EQA Distribution",
  "eqa.distribution.deadline": "Submission Deadline",
  "eqa.distribution.detail.title": "Distribution Details",
  "eqa.distribution.empty": "No distributions found",
  "eqa.distribution.filter.allShipments": "All Shipments",
  "eqa.distribution.filter.program": "Filter by Program",
  "eqa.distribution.filter.status": "Filter by Status",
  "eqa.distribution.list.title": "EQA Distributions",
  "eqa.distribution.manageParticipants": "Manage Participants",
  "eqa.distribution.name": "Distribution Name",
  "eqa.distribution.name.placeholder": "e.g., Round 1 - Chemistry 2026",
  "eqa.distribution.network.active": "Active Participants",
  "eqa.distribution.network.active.sub": "Currently enrolled",
  "eqa.distribution.network.responseRate": "Average Response Rate",
  "eqa.distribution.network.responseRate.sub": "Last 4 quarters",
  "eqa.distribution.network.subtitle": "Overview of enrolled participating laboratories",
  "eqa.distribution.network.title": "Participant Network",
  "eqa.distribution.network.total": "Total Participants",
  "eqa.distribution.network.total.sub": "Across all countries",
  "eqa.distribution.participants": "Participant Organizations",
  "eqa.distribution.participants.min": "At least 2 participant organizations are required",
  "eqa.distribution.participants.none": "No organizations are currently enrolled in the selected programme. Enrol participants before creating a distribution.",
  "eqa.distribution.participants.select": "Select organizations",
  "eqa.distribution.program": "EQA Program",
  "eqa.distribution.program.select": "Select a program",
  "eqa.distribution.responseRate": "response rate",
  "eqa.distribution.shipments.subtitle": "Track distributed EQA samples and participant responses",
  "eqa.distribution.shipments.title": "EQA Shipments",
  "eqa.distribution.shipped": "Shipped",
  "eqa.distribution.status.completed": "Completed",
  "eqa.distribution.status.draft": "Draft",
  "eqa.distribution.status.prepared": "Prepared",
  "eqa.distribution.status.shipped": "Shipped",
  "eqa.distribution.step.confirmation": "Confirmation",
  "eqa.distribution.step.details": "Program & Details",
  "eqa.distribution.step.participants": "Participants",
  "eqa.distribution.summary.completed": "Completed",
  "eqa.distribution.summary.completed.sub": "All responses received",
  "eqa.distribution.summary.draft": "Draft Shipments",
  "eqa.distribution.summary.draft.sub": "Being prepared",
  "eqa.distribution.summary.participants": "Participants",
  "eqa.distribution.summary.participants.sub": "Enrolled",
  "eqa.distribution.summary.shipped": "Shipped",
  "eqa.distribution.summary.shipped.sub": "Awaiting responses",
  "eqa.enrollment.allStatuses": "All Statuses",
  "eqa.enrollment.alreadyEnrolled": "Already Enrolled",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organization(s) already enrolled",
  "eqa.enrollment.confirmWithdraw": "Confirm Withdrawal",
  "eqa.enrollment.created.success": "Program enrollment created successfully",
  "eqa.enrollment.deactivated": "Program enrollment deactivated",
  "eqa.enrollment.description": "Description",
  "eqa.enrollment.district": "District",
  "eqa.enrollment.editing": "Editing: {name}",
  "eqa.enrollment.empty": "No enrollments found for this program",
  "eqa.enrollment.enroll": "Enroll",
  "eqa.enrollment.enrollParticipant": "Enroll Participant",
  "eqa.enrollment.enrollSelected": "Enroll Selected",
  "eqa.enrollment.enrollmentDate": "Enrollment Date",
  "eqa.enrollment.labUnits": "Lab Units",
  "eqa.enrollment.new": "New EQA Program Enrollment",
  "eqa.enrollment.organizationCode": "Organization Code",
  "eqa.enrollment.organizationName": "Organization Name",
  "eqa.enrollment.panels": "Panels",
  "eqa.enrollment.programName": "Program Name",
  "eqa.enrollment.programName.placeholder": "Enter program name",
  "eqa.enrollment.provider": "Provider",
  "eqa.enrollment.provider.placeholder": "Enter provider name",
  "eqa.enrollment.reactivate": "Reactivate",
  "eqa.enrollment.reactivated": "Program enrollment reactivated",
  "eqa.enrollment.save": "Save Enrollment",
  "eqa.enrollment.saveChanges": "Save Changes",
  "eqa.enrollment.searchOrgs": "Search organizations...",
  "eqa.enrollment.searchPlaceholder": "Search by organization name or code...",
  "eqa.enrollment.selectLabUnits": "Select lab units...",
  "eqa.enrollment.selectOrg": "Select an organization...",
  "eqa.enrollment.selectOrgsPrompt": "Select organizations to enroll",
  "eqa.enrollment.selectPanels": "Select panels...",
  "eqa.enrollment.selectProgram": "Select Program",
  "eqa.enrollment.selectProgramPrompt": "Select a program to view enrollments",
  "eqa.enrollment.selectTests": "Select tests...",
  "eqa.enrollment.selected": "selected",
  "eqa.enrollment.status": "Status",
  "eqa.enrollment.status.active": "Active",
  "eqa.enrollment.status.suspended": "Suspended",
  "eqa.enrollment.status.withdrawn": "Withdrawn",
  "eqa.enrollment.success": "Enrollment successful",
  "eqa.enrollment.suspend": "Suspend",
  "eqa.enrollment.tests": "Tests",
  "eqa.enrollment.thisLab": "This Lab",
  "eqa.enrollment.updated.success": "Program enrollment updated successfully",
  "eqa.enrollment.withdraw": "Withdraw",
  "eqa.enrollment.withdrawReason": "Reason for Withdrawal",
  "eqa.enrollment.withdrawReasonPlaceholder": "Provide a reason for withdrawing this participant...",
  "eqa.filter.allPriorities": "All Priorities",
  "eqa.filter.allPrograms": "All Programs",
  "eqa.filter.allStatuses": "All Statuses",
  "eqa.filter.eqaOnly": "EQA Samples Only",
  "eqa.filter.priority": "Priority",
  "eqa.filter.program": "Program",
  "eqa.filter.status": "Status",
  "eqa.management.action.enterResults": "Enter Results",
  "eqa.management.action.submit": "Submit",
  "eqa.management.bulkUpload": "Bulk Upload Results",
  "eqa.management.col.accession": "Accession #",
  "eqa.management.col.actions": "Actions",
  "eqa.management.col.deadline": "Deadline",
  "eqa.management.col.progress": "Progress",
  "eqa.management.col.provider": "Provider/Program",
  "eqa.management.col.sampleId": "Sample ID",
  "eqa.management.col.status": "Status",
  "eqa.management.daysLeft": "days left",
  "eqa.management.distributions.title": "Distributions",
  "eqa.management.filter.allSamples": "All Samples",
  "eqa.management.overdue": "Overdue",
  "eqa.management.participants.subtitle": "Manage organization enrollment in EQA programs",
  "eqa.management.participants.title": "Participants",
  "eqa.management.performance.onTime": "On-Time Submission",
  "eqa.management.performance.participation": "Participation Rate",
  "eqa.management.performance.participation.sub": "All programs enrolled",
  "eqa.management.performance.subtitle": "Your laboratory's EQA performance metrics",
  "eqa.management.performance.title": "Performance Summary",
  "eqa.management.performance.zScore": "Average Z-Score",
  "eqa.management.performance.zScore.sub": "Within acceptable range",
  "eqa.management.programs.subtitle": "Manage programs distributed by this laboratory",
  "eqa.management.programs.title": "EQA Programs",
  "eqa.management.results.title": "Results & Analysis",
  "eqa.management.samples.empty": "No EQA samples found",
  "eqa.management.samples.subtitle": "Manage received EQA samples and submit results",
  "eqa.management.samples.title": "EQA Samples",
  "eqa.management.status.completed": "Completed",
  "eqa.management.status.completed.sub": "Ready to submit",
  "eqa.management.status.inProgress": "In Progress",
  "eqa.management.status.inProgress.sub": "Testing in progress",
  "eqa.management.status.in_progress": "In Progress",
  "eqa.management.status.overdue": "Overdue",
  "eqa.management.status.pending": "Pending",
  "eqa.management.status.pending.sub": "Not started",
  "eqa.management.status.submitted": "Submitted",
  "eqa.management.status.submitted.sub": "Results sent",
  "eqa.management.subtitle": "Receive and manage EQA samples from external providers",
  "eqa.management.title": "EQA Management",
  "eqa.management.viewPerformance": "View Performance",
  "eqa.myProgram.helperText": "Selecting an enrollment pre-populates tests and panels",
  "eqa.myProgram.label": "My Program Enrollment",
  "eqa.myProgram.prePopulated.subtitle": "{tests} tests and {panels} panels pre-selected from enrollment",
  "eqa.myProgram.prePopulated.title": "Tests/panels pre-populated",
  "eqa.myProgram.select": "Select enrollment to pre-populate tests...",
  "eqa.myPrograms.action.deactivate": "Deactivate",
  "eqa.myPrograms.action.edit": "Edit",
  "eqa.myPrograms.action.reactivate": "Reactivate",
  "eqa.myPrograms.description": "Description",
  "eqa.myPrograms.enrollButton": "Enroll in Program",
  "eqa.myPrograms.enrollInProgram": "Enroll in Program",
  "eqa.myPrograms.labUnits": "Lab Unit(s)",
  "eqa.myPrograms.panels": "Panels",
  "eqa.myPrograms.programName": "Program Name",
  "eqa.myPrograms.provider": "Provider",
  "eqa.myPrograms.search.placeholder": "Search programs...",
  "eqa.myPrograms.status": "Status",
  "eqa.myPrograms.status.active": "Active",
  "eqa.myPrograms.status.inactive": "Inactive",
  "eqa.myPrograms.subtitle": "Programs this laboratory participates in",
  "eqa.myPrograms.testMapping": "Test Mapping (Optional)",
  "eqa.myPrograms.testMappingHint": "Select tests and panels to pre-populate Order Entry when this program is selected",
  "eqa.myPrograms.tests": "Tests",
  "eqa.myPrograms.title": "My EQA Programs",
  "eqa.order.deadline": "Result Deadline",
  "eqa.order.form.title": "EQA Sample Information",
  "eqa.order.participantId": "Participant ID",
  "eqa.order.priority": "EQA Priority",
  "eqa.order.programme": "Programme",
  "eqa.order.provider": "Provider",
  "eqa.order.providerSampleId": "Provider Sample ID",
  "eqa.orders.completedThisMonth": "Completed This Month",
  "eqa.orders.enterNewTest": "Enter New EQA Test",
  "eqa.orders.inProgress": "In Progress",
  "eqa.orders.overdue": "Overdue",
  "eqa.orders.pending": "Pending",
  "eqa.orders.search.placeholder": "Search by lab number or program...",
  "eqa.participant.id": "Participant ID",
  "eqa.priority.critical": "Critical",
  "eqa.priority.label": "Priority",
  "eqa.priority.standard": "Standard",
  "eqa.priority.urgent": "Urgent",
  "eqa.program.activate": "Activate",
  "eqa.program.active": "Active",
  "eqa.program.addProgram": "Add Program",
  "eqa.program.cancel": "Cancel",
  "eqa.program.create": "Create Program",
  "eqa.program.createTitle": "Create EQA Program",
  "eqa.program.deactivate": "Deactivate",
  "eqa.program.description": "Description",
  "eqa.program.description.placeholder": "Describe the EQA program...",
  "eqa.program.edit": "Edit Program",
  "eqa.program.editTitle": "Edit EQA Program",
  "eqa.program.empty": "No EQA programs found",
  "eqa.program.inactive": "Inactive",
  "eqa.program.label": "EQA Program",
  "eqa.program.management.title": "EQA Program Management",
  "eqa.program.name": "Program Name",
  "eqa.program.name.placeholder": "e.g., Chemistry Proficiency Testing",
  "eqa.program.name.required": "Program name is required",
  "eqa.program.provider.required": "Provider is required",
  "eqa.program.participantCount": "Enrolled Participants",
  "eqa.program.provider": "Provider",
  "eqa.program.required": "EQA Program is required when registering an EQA sample",
  "eqa.program.save": "Save Program",
  "eqa.program.select": "Select EQA Program",
  "eqa.program.status": "Status",
  "eqa.program.tests": "Assigned Tests",
  "eqa.program.tests.assign": "Assign Tests",
  "eqa.program.tests.select": "Select tests to assign",
  "eqa.provider.label": "EQA Provider Organization",
  "eqa.provider.sampleId": "Provider Sample ID",
  "eqa.provider.select": "Select EQA Provider",
  "eqa.results.acceptable": "Acceptable",
  "eqa.results.batch.import": "Batch Import",
  "eqa.results.col.deadline": "Deadline",
  "eqa.results.col.labNumber": "Lab Number",
  "eqa.results.col.priority": "Priority",
  "eqa.results.col.programme": "Programme",
  "eqa.results.col.provider": "Provider",
  "eqa.results.col.status": "Status",
  "eqa.results.import.confirm": "Confirm Import",
  "eqa.results.import.errors": "{count} rows had errors",
  "eqa.results.import.success": "{count} results imported successfully",
  "eqa.results.import.upload": "Upload CSV File",
  "eqa.results.manual.entry": "Manual Result Entry",
  "eqa.results.mean": "Mean",
  "eqa.results.minimum.participants": "Minimum 5 participants required for statistical analysis",
  "eqa.results.noResults": "No EQA test results found.",
  "eqa.results.organization": "Organization",
  "eqa.results.organization.select": "Select organization",
  "eqa.results.participant.count": "Participant Count",
  "eqa.results.performance": "Performance",
  "eqa.results.questionable": "Questionable",
  "eqa.results.report.downloading": "Downloading report...",
  "eqa.results.report.generate": "Generate Report",
  "eqa.results.search.placeholder": "Search by lab number, programme, or provider...",
  "eqa.results.standardDeviation": "Standard Deviation",
  "eqa.results.statistics": "Statistics",
  "eqa.results.submit": "Submit Result",
  "eqa.results.test": "Test",
  "eqa.results.test.select": "Select test",
  "eqa.results.title": "EQA Results & Analysis",
  "eqa.results.unacceptable": "Unacceptable",
  "eqa.results.value": "Result Value",
  "eqa.results.zscore": "Z-Score",
  "eqa.sample.badge": "EQA",
  "eqa.sample.checkbox": "EQA Sample",
  "eqa.sample.checkbox.helper": "Check if this is an External Quality Assurance sample",
  "eqa.sample.demographics.disabled": "Demographics disabled for EQA samples",
  "eqa.sample.patient.readonly.body": "Patient demographic fields are automatically set for EQA samples and cannot be edited.",
  "eqa.sample.patient.readonly.title": "EQA Sample — Patient Info Locked",
  "eqa.section.title": "EQA Sample Details",
  "eqa.settings.integration.apiKey": "API Key",
  "eqa.settings.integration.apiUrl": "API Base URL",
  "eqa.settings.integration.fhir": "FHIR API Integration",
  "eqa.settings.integration.fhir.desc": "Enable FHIR R4 API for external EQA data exchange",
  "eqa.settings.integration.subtitle": "Configure external system integrations",
  "eqa.settings.integration.title": "Integration Settings",
  "eqa.settings.loading": "Loading settings...",
  "eqa.settings.notifications.email": "Email Notifications",
  "eqa.settings.notifications.email.desc": "Send email notifications for critical alerts and deadlines",
  "eqa.settings.notifications.eqaDeadline": "EQA Deadline Alerts",
  "eqa.settings.notifications.eqaDeadline.desc": "Receive alerts when EQA submission deadlines are approaching",
  "eqa.settings.notifications.stat": "STAT Order Alerts",
  "eqa.settings.notifications.stat.desc": "Alert when STAT orders are overdue",
  "eqa.settings.notifications.subtitle": "Configure alert and notification preferences",
  "eqa.settings.notifications.threshold": "Alert Threshold (days before deadline)",
  "eqa.settings.notifications.title": "Notification Settings",
  "eqa.settings.performance.autoZScore": "Automatic Z-Score Calculation",
  "eqa.settings.performance.autoZScore.desc": "Automatically calculate Z-Scores when results are submitted",
  "eqa.settings.performance.generateReports": "Generate Performance Reports",
  "eqa.settings.performance.generateReports.desc": "Automatically generate performance reports after each round",
  "eqa.settings.performance.subtitle": "Configure EQA performance analysis parameters",
  "eqa.settings.performance.title": "Performance Analysis",
  "eqa.settings.performance.zScoreMax": "Maximum Acceptable Z-Score",
  "eqa.settings.performance.zScoreMin": "Minimum Acceptable Z-Score",
  "eqa.settings.saveError": "Failed to save settings",
  "eqa.settings.saveSuccess": "Settings saved successfully",
  "eqa.settings.saving": "Saving...",
  "eqa.status.active": "Active",
  "eqa.status.completed": "Completed",
  "eqa.status.inProgress": "In Progress",
  "eqa.status.inactive": "Inactive",
  "eqa.status.inprogress": "In Progress",
  "eqa.status.overdue": "Overdue",
  "eqa.status.pending": "Pending",
  "eqa.submission.audit": "Submission Audit Trail",
  "eqa.submission.date": "Submission Date",
  "eqa.submission.error": "Submission failed",
  "eqa.submission.fhir": "Submit via FHIR",
  "eqa.submission.fhir.description": "Submit results to external EQA provider via FHIR R4",
  "eqa.submission.late.approve": "Approve Late Submission",
  "eqa.submission.late.justification": "Justification for Late Submission",
  "eqa.submission.late.justification.placeholder": "Provide reason for late submission...",
  "eqa.submission.late.supervisor": "Supervisor User ID",
  "eqa.submission.late.warning": "Submission deadline has passed. Supervisor approval is required.",
  "eqa.submission.method": "Submission Method",
  "eqa.submission.success": "Results submitted successfully",
  "eqa.submission.title": "Result Submission",
  "eqa.tests.action.enterResults": "Enter Results",
  "eqa.tests.action.viewOrder": "View Order",
  "eqa.tests.action.viewResults": "View Results",
  "eqa.tests.dateEntered": "Date Entered",
  "eqa.tests.deadline": "Deadline",
  "eqa.tests.enterNew": "Enter New EQA Test",
  "eqa.tests.labNumber": "Lab Number",
  "eqa.tests.orders.subtitle": "Proficiency testing orders for this laboratory",
  "eqa.tests.orders.title": "EQA Orders",
  "eqa.tests.priority": "Priority",
  "eqa.tests.program": "EQA Program",
  "eqa.tests.provider": "Provider",
  "eqa.tests.searchPlaceholder": "Search by accession #, program, or provider...",
  "eqa.tests.status": "Status",
  "eqa.tests.status.completed": "Completed",
  "eqa.tests.status.inProgress": "In Progress",
  "eqa.tests.status.overdue": "Overdue",
  "eqa.tests.status.pending": "Pending",
  "eqa.tests.summary.completedThisMonth": "Completed This Month",
  "eqa.tests.summary.inProgress": "In Progress",
  "eqa.tests.summary.overdue": "Overdue",
  "eqa.tests.summary.pending": "Pending",
  "eqa.validation.deadline.required": "Testing Deadline is required",
  "eqa.validation.program.required": "EQA Program is required",
  "eqa.validation.provider.required": "EQA Provider Organization is required",
  "error.add.edited.msg": "Error while Editing/Adding",
  "error.barcode.dimension.positive": "Label dimension must be a positive number",
  "error.barcode.labelcount.default.lte.max": "Default label count must not exceed maximum for this label type",
  "error.delete.msg": "Error while Deleting",
  "error.duplicate.calculationname": "Duplicate Calculation Name or Error while saving",
  "error.fetch.boxDetails": "Failed to fetch box details",
  "error.fetch.boxes": "Failed to fetch shipping boxes",
  "error.fetch.facilities": "Failed to fetch facilities",
  "error.fetch.unassignedSamples": "Failed to fetch unassigned samples",
  "error.field.required": "This field is required",
  "error.import.patient": "Error While Importing Patient into OpenELIS",
  "error.invalid.email": "Invalid Email",
  "error.invalidcredentials": "Username or Password are incorrect",
  "error.locale.format": "Invalid format. Use: en, fr, es, or en-US, fr-CA, etc.",
  "error.no.patient.data": "No Patient Data to Import",
  "error.nonconform.report": "Please Enter Value",
  "error.report.csv.date": "Please select date type.",
  "error.report.csv.study": "Please select study type.",
  "error.report.status": "Error while Generating Report",
  "error.required.destination": "Destination facility is required",
  "error.save.failed": "Failed to save",
  "error.save.msg": "Error While saving",
  "error.save.order": "Error while saving order",
  "error.save.patient": "Error While Saving Patient",
  "error.title": "Error",
  "errorBoundary.reload": "Reload",
  "errorBoundary.route.patientResultsViewer.message": "Something went wrong while showing this patient's results. Reload to try again.",
  "errorBoundary.route.patientResultsViewer.title": "Patient results could not be loaded",
  "errorBoundary.route.resultsSearch.message": "Something went wrong on the results page. Reload to try again.",
  "errorBoundary.route.resultsSearch.title": "Results could not be loaded",
  "errorBoundary.route.samplePatientEntry.message": "Something went wrong on the sample entry page. Reload to try again.",
  "errorBoundary.route.samplePatientEntry.title": "Sample entry could not be loaded",
  "errorBoundary.route.storage.message": "Something went wrong on this page. Reload to try again, or use the menu to go elsewhere.",
  "errorBoundary.route.storage.title": "Storage could not be loaded",
  "errorBoundary.route.analyzers.message": "Something went wrong loading this page. Reload to try again.",
  "errorBoundary.route.analyzers.title": "Analyzer module could not be loaded",
  "errorBoundary.route.analyzerResults.message": "Something went wrong loading results. Reload to try again.",
  "errorBoundary.route.analyzerResults.title": "Analyzer results could not be loaded",
  "esig.button.certify": "Certify & Continue",
  "esig.button.reject": "Reject",
  "esig.button.saveAndSign": "Save",
  "esig.button.sign": "Sign",
  "esig.button.validate": "Validate",
  "esig.certification.acknowledge": "I have read and understand the above statement",
  "esig.certification.intro": "Before you can use electronic signatures, you must certify that your electronic signature is the legally binding equivalent of your handwritten signature.",
  "esig.error.disabled": "Electronic signatures are not enabled",
  "esig.error.generic": "An error occurred",
  "esig.error.invalidCredentials": "Invalid credentials",
  "esig.error.keycloakNotSupported": "Keycloak authentication is not yet supported for electronic signatures",
  "esig.error.loadingStatus": "Failed to load signature status",
  "esig.error.mustAcknowledge": "You must acknowledge the certification statement",
  "esig.error.passwordRequired": "Password is required",
  "esig.error.rejectionReasonRequired": "Rejection reason is required",
  "esig.error.title": "Error",
  "esig.error.usernameRequired": "Username is required",
  "esig.info.fullAuth": "This is your first signature in this session. Please enter your username and password to authenticate.",
  "esig.info.legalBinding": "By entering your credentials, you are creating a legally binding electronic signature per 21 CFR Part 11.",
  "esig.info.passwordOnly": "You have an active signing session. Enter your password to continue.",
  "esig.label.context": "Action:",
  "esig.label.meaning": "Signature Meaning:",
  "esig.label.password": "Password",
  "esig.label.rejectionReason": "Rejection Reason",
  "esig.label.signingAs": "Signing as: {userName}",
  "esig.label.username": "Username",
  "esig.meaning.authored": "Authored",
  "esig.meaning.rejected": "Rejected",
  "esig.meaning.validatedAndReleased": "Validated and Released",
  "esig.placeholder.password": "Enter your password to confirm",
  "esig.placeholder.rejectionReason": "Enter the reason for rejection",
  "esig.placeholder.username": "Enter your username",
  "esig.title.certification": "Electronic Signature Certification",
  "esig.title.signature": "Electronic Signature",
  "example": "Example",
  "external.id": "External ID",
  "external.referrals.report": "External Referrals Report",
  "externalReferredOutTests.title": "External Referrals Report",
  "externalconnections.active": "Active",
  "externalconnections.add.title": "Add External Connection",
  "externalconnections.authtype": "Authentication Type",
  "externalconnections.authtype.basic.password": "Password",
  "externalconnections.authtype.basic.username": "Username",
  "externalconnections.browse.title": "External Connections",
  "externalconnections.deactivate.success": "External connection(s) deactivated successfully.",
  "externalconnections.description": "Description",
  "externalconnections.edit.title": "Edit External Connection",
  "externalconnections.name": "Name",
  "externalconnections.name.placeholder": "Enter connection name",
  "externalconnections.programmedconnection": "Connection Type",
  "externalconnections.save.success": "External connection saved successfully.",
  "externalconnections.search": "Search external connections",
  "externalconnections.search.placeholder": "Search by name or type",
  "externalconnections.select": "Select",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "e.g. https://server:port",
  "false.label": "False",
  "field.active": "Active/Not Active",
  "field.ageRange": "Age range",
  "field.dictionaryValues": "Dictionary Values",
  "field.loinc": "Loinc",
  "field.name": "Name",
  "field.normalRange": "Normal range",
  "field.note": "Note",
  "field.orderable": "Orderable/Not orderable",
  "field.panel": "Panel",
  "field.referenceValue": "Reference value",
  "field.reportName": "Report Name",
  "field.resultLimits": "Result limits",
  "field.resultType": "Result type",
  "field.sampleType": "Sample Type",
  "field.select.testSection": "Select Test Section",
  "field.selectValues": "Select values",
  "field.sex": "Sex",
  "field.significantDigits": "Significant digits",
  "field.testSection": "Test Section",
  "field.testUnit": "Test Unit",
  "field.uom": "Unit of measure",
  "field.validRange": "Valid range",
  "file.import.configuration.active": "Active",
  "file.import.configuration.analyzer": "Analyzer",
  "file.import.configuration.analyzer.emptyState": "No file import plugins installed",
  "file.import.configuration.analyzer.placeholder": "Select analyzer",
  "file.import.configuration.cancel": "Cancel",
  "file.import.configuration.columnMappings": "Column Mappings",
  "file.import.configuration.columnMappings.helperText": "JSON mapping of CSV columns to OpenELIS fields (e.g., {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Delimiter",
  "file.import.configuration.delimiter.helperText": "CSV delimiter character (default: comma)",
  "file.import.configuration.error.save": "Failed to save file import configuration",
  "file.import.configuration.error.unknown": "An unknown error occurred",
  "file.import.configuration.fileFormat": "File Format",
  "file.import.configuration.fileFormat.placeholder": "Select file format",
  "file.import.configuration.filePattern": "File Pattern",
  "file.import.configuration.filePattern.helperText": "Glob pattern for matching files (e.g., *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Has Header Row",
  "file.import.configuration.importDirectory": "Import Directory",
  "file.import.configuration.importDirectory.helperText": "Directory to watch for new files",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Save",
  "file.import.configuration.success.created": "File import configuration created successfully",
  "file.import.configuration.success.updated": "File import configuration updated successfully",
  "file.import.configuration.title.add": "Add File Import Configuration",
  "file.import.configuration.title.edit": "Edit File Import Configuration",
  "file.import.configuration.validation.analyzerId.required": "Analyzer is required",
  "file.import.configuration.validation.columnMappings.invalid": "Invalid JSON format for column mappings",
  "file.import.configuration.validation.importDirectory.required": "Import directory is required",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filters",
  "freezer.nav.corrective": "Corrective Actions",
  "freezer.nav.corrective.tooltip": "Manage corrective actions",
  "freezer.nav.dashboard": "Dashboard",
  "freezer.nav.dashboard.tooltip": "View cold storage monitoring dashboard",
  "freezer.nav.reports": "Reports",
  "freezer.nav.reports.tooltip": "Generate cold storage reports",
  "freezer.nav.settings": "Settings",
  "freezer.nav.settings.tooltip": "Configure cold storage settings",
  "freezer.nav.trends": "Historical Trends",
  "freezer.nav.trends.tooltip": "View temperature trends over time",
  "french.current": "FRENCH current",
  "french.label": "French",
  "from.title": "From",
  "genericSample.edit.success": "Sample updated successfully",
  "genericSample.edit.title": "Edit Sample",
  "genericSample.field.by": "By",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Date",
  "genericSample.field.from": "From",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Lab person received",
  "genericSample.field.project": "Project",
  "genericSample.field.storageLocation": "Storage freezer # & location",
  "genericSample.field.type": "Type",
  "genericSample.notebook.selection.title": "Notebook Selection (Optional)",
  "genericSample.order.error.labNoRequired": "Please generate a Lab Number before saving.",
  "genericSample.order.generateLabNo": "Generate Lab Number",
  "genericSample.order.labNo.placeholder": "Click 'Generate Lab Number' to create",
  "genericSample.order.success.details": "Sample Details",
  "genericSample.order.success.message": "Sample order created successfully with accession number: {accessionNumber}",
  "genericSample.order.title": "Receive Sample",
  "gps.accuracy.display": "±{accuracy}m accuracy",
  "gps.accuracy.warning.message": "GPS accuracy is {accuracy}m, which exceeds the required {required}m threshold. Consider capturing the location again in a better position.",
  "gps.accuracy.warning.title": "GPS Accuracy Warning",
  "gps.button.clear": "Clear",
  "gps.button.getting.location": "Getting Location...",
  "gps.button.location.captured": "Location Captured",
  "gps.button.use.my.location": "Use My Location",
  "gps.collapse": "Collapse GPS section",
  "gps.config.accuracy.helper": "Maximum acceptable GPS accuracy in meters. Set to 0 to disable accuracy checking.",
  "gps.config.accuracy.label": "Required Accuracy (meters)",
  "gps.config.enabled.description": "When enabled, GPS coordinate fields will appear in the Order Entry workflow to capture sample collection locations.",
  "gps.config.enabled.label": "Enable GPS Coordinates",
  "gps.config.error.load": "Failed to load GPS configuration",
  "gps.config.save.error": "Failed to save GPS configuration",
  "gps.config.save.success": "GPS configuration saved successfully",
  "gps.config.saving": "Saving...",
  "gps.config.section.general": "GPS Settings",
  "gps.config.timeout.helper": "Maximum time to wait for GPS location in seconds.",
  "gps.config.timeout.label": "Timeout (seconds)",
  "gps.config.title": "GPS Coordinates Configuration",
  "gps.config.unsaved.changes": "You have unsaved changes. Are you sure you want to leave?",
  "gps.config.unsaved.subtitle": "Remember to save your changes before navigating away.",
  "gps.config.unsaved.title": "Unsaved Changes",
  "gps.config.validation.accuracy.negative": "Required accuracy cannot be negative",
  "gps.config.validation.accuracy.too.high": "Required accuracy cannot exceed 10,000 meters",
  "gps.config.validation.timeout.too.high": "Timeout cannot exceed 120 seconds",
  "gps.config.validation.timeout.too.low": "Timeout must be at least 1 second",
  "gps.coordinates.captured.via": "Captured via {method}",
  "gps.coordinates.current": "Current coordinates",
  "gps.error.not.supported": "GPS is not supported by this browser",
  "gps.error.permission.denied": "GPS access was denied. Please enable location permissions and try again.",
  "gps.error.position.unavailable": "GPS position is unavailable. Please check your device's location settings.",
  "gps.error.timeout": "GPS request timed out. Please try again.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "An unknown GPS error occurred. Please try again.",
  "gps.info.description": "GPS coordinates record the geographic location where the sample was collected. This supports epidemiological surveillance and disease mapping.",
  "gps.info.title": "GPS Coordinates",
  "gps.latitude.helper": "Degrees North (+) or South (-), between -90 and 90",
  "gps.latitude.invalid": "Latitude must be between -90 and 90 degrees",
  "gps.latitude.label": "Latitude",
  "gps.latitude.placeholder": "e.g., -1.286389",
  "gps.longitude.helper": "Degrees East (+) or West (-), between -180 and 180",
  "gps.longitude.invalid": "Longitude must be between -180 and 180 degrees",
  "gps.longitude.label": "Longitude",
  "gps.longitude.placeholder": "e.g., 36.817223",
  "gps.manual.entry.off": "Off",
  "gps.manual.entry.on": "On",
  "gps.manual.entry.title": "Enter coordinates manually",
  "gps.manual.entry.toggle": "Manual coordinate entry",
  "gps.not.captured": "Not captured",
  "gps.section.description": "Capture the geographic location where this sample was collected for epidemiological tracking",
  "gps.section.title": "Collection Location (GPS)",
  "gps.status.captured": "Captured",
  "gps.status.optional": "Optional",
  "gps.tile.collapse": "Collapse GPS section",
  "gps.tile.expand": "Expand to add GPS coordinates",
  "gps.warning.partial.coordinates": "Both latitude and longitude should be provided for a valid location.",
  "header.ID": "ID",
  "header.assign": "Assign",
  "header.cancel.test": "Cancel Test",
  "header.formname": "FormName",
  "header.label.ARV": "ARV-initial",
  "header.label.EID": "Diagnostic for children with DBS-PCR",
  "header.label.changeLab": "Select Lab",
  "header.label.followup": "ARV-Follow-up",
  "header.label.intialFollowup": "ARV -->Initial-FollowUp-VL",
  "header.label.logout": "Logout",
  "header.label.nonconformityByDate": "Non-conformity Report By Date",
  "header.label.selectLab": "Select Lab",
  "header.label.selectlocale": "Select Locale",
  "header.label.specialRequest": "Special Request",
  "header.label.study.ciexport": "Export a CSV File by Date",
  "header.label.study.vlloadtrends": "Viral Load Data Export Report",
  "header.label.version": "Version:",
  "header.reject": "Reject",
  "header.rejection.reason": "Reject Reason",
  "header.results.recorded": "Results Recorded",
  "hide.aliquoting": "Hide Aliquoting",
  "holder.choose.availabletest": "Choose Available Test",
  "home.label": "Home",
  "immunohistochemistry.label.addreport": "Add Report",
  "immunohistochemistry.label.averageChrom": "Average Chromozome 17 Sinals per nucleus",
  "immunohistochemistry.label.averageHer2": "Average HER2 per nucleus",
  "immunohistochemistry.label.cellIntensity": "intensity . Allred score",
  "immunohistochemistry.label.cellPercent": "% of cell show nuclear staining with",
  "immunohistochemistry.label.dashboard": "Immunohistochemistry DashBoard",
  "immunohistochemistry.label.her2Assesment": "HER 2 protein assesment is",
  "immunohistochemistry.label.her2Pattern": "CerbB2/HER 2 staining pattern",
  "immunohistochemistry.label.her2ScoreOf": "with a Score of",
  "immunohistochemistry.label.historicalDiagnosis": "Histological Diagnosis",
  "immunohistochemistry.label.ihcRatio": "Ratio of Her2/neu Signals to Chromozome 17",
  "immunohistochemistry.label.ihcScore": "IHC (Cerb2 Score)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Proliferative Index): ",
  "immunohistochemistry.label.molecularType": " Molecular SubType",
  "immunohistochemistry.label.numberOfCancer": "Number of Cancer nuclei",
  "immunohistochemistry.label.outOf8": "out of 8",
  "immunohistochemistry.label.report": "Report",
  "immunohistochemistry.label.reports": "Reports",
  "immunohistochemistry.label.review": "Awaiting Immunohistochemistry Review",
  "immunohistochemistry.label.title": "Immunohistochemistry",
  "immunohistochemistry.label.tumorCells": "of tumor cells positive (cut off 20%)",
  "import.autoGenerated": "Auto-generated",
  "import.created": "Created",
  "import.error.failed": "Import failed",
  "import.error.importFile": "Failed to import file",
  "import.error.selectFile": "Please select a file first",
  "import.error.validateFile": "Failed to validate file",
  "import.error.validateFirst": "Please validate the file first and fix any errors",
  "import.error.validationFailed": "Validation failed. Please check the errors below.",
  "import.failed": "Import Failed",
  "import.failedCount": "Failed",
  "import.header.collectionDate": "Collection Date",
  "import.header.errorMessage": "Error Message",
  "import.header.field": "Field",
  "import.header.from": "From",
  "import.header.labNo": "Lab No",
  "import.header.quantity": "Quantity",
  "import.header.row": "Row",
  "import.header.sampleType": "Sample Type",
  "import.header.samplesToCreate": "Samples to Create",
  "import.importing": "Importing...",
  "import.invalidRows": "Invalid Rows",
  "import.selectFile": "Select file",
  "import.status.invalid": "Invalid",
  "import.status.valid": "Valid",
  "import.success": "Import Successful",
  "import.totalRows": "Total Rows",
  "import.totalSamplesToCreate": "Total Samples to Create",
  "import.uploadFile": "Upload File",
  "import.uploadFileDesc": "Upload CSV or Excel file ({types})",
  "import.validRows": "Valid Rows",
  "import.validating": "Validating...",
  "import.validationStatus": "Validation Status",
  "input.error.same.panel.type": "An existing panel type with the same name has been found.  Please cancel or use a different name.",
  "input.placeholder.labNo": "Enter Lab Number",
  "input.placeholder.patientFirstName": "Enter Patient's First Name",
  "input.placeholder.patientId": "Enter Patient Id",
  "input.placeholder.patientLastName": "Enter Patient's Last Name",
  "input.placeholder.prevLabNumber": "Enter Previous Lab Number",
  "input.placeholder.providerEmail": "Enter Requester's Email",
  "input.placeholder.providerFax": "Enter Requester's Fax Number",
  "input.placeholder.providerWorkPhone": "Enter Requester's Phone Number",
  "input.placeholder.provisionalClinicalDiagnosis": "Enter Provisional Clinical Diagnosis",
  "input.placeholder.requesterFirstName": "Enter Requester's First Name",
  "input.placeholder.requesterLastName": "Enter Requester's Last Name",
  "input.placeholder.searchTestName": "Search testName Here",
  "input.placeholder.selectPanel": "Select Panel Type",
  "input.placeholder.selectPriority": "Select Priority",
  "input.placeholder.selectTest": "Select Test Type",
  "input.placeholder.selectTestSection": "Select Unit Type",
  "instructions.copy.labnum": "Copy Lab Number",
  "instructions.order.entry.eqa.enabled": "When enabled, a checkbox will appear on the Order Entry screen allowing staff to mark a sample as an EQA (External Quality Assurance) sample. Patient demographics will be auto-populated with N/A and locked.",
  "instructions.test.activation": "Active Tests: a checked box indicates an already active test. To activate a test, check the box; to deactivate, uncheck the box. Any sample types without an existing active test are deactivated and appear at the bottom, under 'Inactive Sample Types'. If one of the tests is activated, the sample type will be activated.",
  "instructions.test.activation.confirm": "Verify that these are the changes you want to make. If correct then save. If not correct use the back button to make the correct changes",
  "instructions.test.activation.sort": "Display Order: Lists of sample types which have newly activated tests. Sort the tests to indicate how they will be displayed in the order entry screen. Sorting can be done by dragging items to the desired position.",
  "instructions.test.order": "Test with checks are orderable, those without checks are not orderable.  Change checks to change status.  For a test to be able to be ordered on intake it must be both active and orderable.  Tests which are active but not orderable may be requested as part of a test reflex.",
  "invalid.json": "JSON is invalid",
  "inventory.add.button": "Add New Lot",
  "inventory.addItem.button": "Add Catalog Item",
  "inventory.dashboard.title": "Inventory Dashboard",
  "inventory.export.button": "Export",
  "inventory.filter.all": "All",
  "inventory.filter.status": "Filter by Status",
  "inventory.filter.type": "Filter by Type",
  "inventory.list.title": "Inventory Items",
  "inventory.metrics.expired": "Expired",
  "inventory.metrics.expiringSoon": "Expiring Soon",
  "inventory.metrics.lowStock": "Low Stock",
  "inventory.metrics.totalLots": "Total Lots",
  "inventory.search.placeholder": "Search by item name or lot number",
  "inventory.tab.catalog": "Catalog",
  "inventory.tab.dashboard": "Dashboard",
  "inventory.tab.reports": "Reports",
  "inventory.title": "Inventory Management",
  "label.action": "Action",
  "labNumber.format.current": "Current Format",
  "labNumber.format.new": "New Format",
  "labNumber.prefix": "Prefix",
  "labNumber.type": "Lab Number Type",
  "labNumber.usePrefix": "Use Prefix",
  "label.actions": "Actions",
  "label.active": "Active",
  "label.actualTestName": "Actual Test Name",
  "label.add": "Add",
  "label.add.notification": "Add pop up notification to user",
  "label.all": "All",
  "label.analysisNotStarted": "Analysis not started",
  "label.any": "Any",
  "label.audittrail": "Lab No",
  "label.audittrail.Reports": "Audit Trail Reports",
  "label.audittrail.labNo.invalidaccessionnumber": "Invalid Accession Number",
  "label.audittrail.labNo.missing": "Lab No is required!",
  "label.audittrailreport.nextvisitdate": "Next Visit Date",
  "label.audittrailreport.priority": "Priority",
  "label.audittrailreport.program": "Program",
  "label.audittrailreport.receiveddate": "Received Date",
  "label.audittrailreport.requestdate": "Request Date",
  "label.audittrailreport.requester": "Requester",
  "label.audittrailreport.requester.firstname": "Requester's First Name",
  "label.audittrailreport.requester.lastname": "Requester's Last Name",
  "label.audittrailreport.sitename": "Site Name",
  "label.autoFilledFromServer": "Auto-filled from server",
  "label.barcode": "Barcode",
  "label.barcode.labelsets": "Number of label sets",
  "label.barcode.orderlabel": "Number of order labels per set",
  "label.barcode.specimenlabel": "Number of specimen labels per set",
  "label.barcode.totallabel": "Total Labels to Print",
  "label.button.add": "Add",
  "label.button.add.question": "Add new Question",
  "label.button.cancel": "Cancel",
  "label.button.close": "Close",
  "label.button.changepassword": "Change Password",
  "label.button.clear": "Clear",
  "label.button.confirm": "Confirm",
  "label.button.confirmAction": "Confirm Action",
  "label.button.confirmDelete": "Confirm Delete",
  "label.button.confirmTitle": "Are You Sure ?",
  "label.button.delete": "Delete",
  "label.button.descritpion": "Description",
  "label.button.edit": "Edit",
  "label.button.exit": "Exit",
  "label.button.externalsearch": "External Search",
  "label.button.field": "Field",
  "label.button.finish": "Finish",
  "label.button.finished": "Finished",
  "label.button.generatePrintableVersion": "Generate Printable Version",
  "label.button.import": "Import",
  "label.button.login": "Login",
  "label.button.login.sso": "Single Sign On",
  "label.button.newEntry": "New Entry",
  "label.button.ok": "Ok",
  "label.button.previous": "Previous",
  "label.button.range": "Range",
  "label.button.remove": "Remove",
  "label.button.remove.block": "Remove Block",
  "label.button.remove.report": "Remove Report",
  "label.button.remove.slide": "Remove Slide",
  "label.button.reset": "Reset",
  "label.button.sample": "Sample",
  "label.button.save": "Save",
  "label.button.search": "Search",
  "label.button.select": "Select",
  "label.button.select.pathologist": "Select Pathologist",
  "label.button.select.status": "Select Status",
  "label.button.select.technician": "Select Technician",
  "label.button.select.test": "Select Test",
  "label.button.start": "Start",
  "label.button.submit": "Submit",
  "label.button.update": "Update",
  "label.button.uploadfile": "Upload file",
  "label.button.validate": "Validate",
  "label.button.viewReport": "View Report",
  "label.cancel": "Cancel",
  "label.cancel.test.no.replace": "Cancel test for lab numbers selected, do not assign a new test",
  "label.checkedWillBeModified": "Checked lab no. will be modified",
  "label.clear": "Clear Filters",
  "label.content": "Label Content",
  "label.confirm": "Confirm",
  "label.created.samples": "Created Samples",
  "label.critical.range": "Critical range",
  "label.currentTest": "Current test",
  "label.days": "days",
  "label.default.result": "Default result",
  "label.delete": "Delete",
  "label.description": "Description",
  "label.edit": "Edit",
  "label.electronic.orders": "Electronic Orders",
  "label.equals": "equals",
  "label.error": "Error",
  "label.existing.methods": "Existing Methods",
  "label.existing.test.sets": "Existing test sets",
  "label.filters.mycases": "My cases",
  "label.filters.status": "Status",
  "label.field.required": "This field is required",
  "label.form.searchby": "Search By",
  "label.id": "ID",
  "label.import.errors": "Import Errors",
  "label.inactive": "Inactive",
  "label.inactive.methods": "Inactive Methods. Assign tests to activate.",
  "label.includeInactiveTests": "Include inactive tests",
  "label.inside.normalrange": "is inside the normal range",
  "label.lastPrinted": "Last printed: {date} {time} by {user}",
  "label.loading": "Loading...",
  "label.loinc": "LOINC",
  "label.management.title": "Label Management",
  "label.no": "No",
  "label.no.options.available": "No options available",
  "label.none": "None (no filter)",
  "label.notValidated": "Not validated",
  "label.notequals": "does not equal",
  "label.order.scan.text": "Scan OR Enter Manually OR",
  "label.orderable": "Orderable",
  "label.outside.normalrange": "is outside the normal range",
  "label.page.patientHistory": "Patient History",
  "label.preview.data": "Preview Data",
  "label.print": "Print Label",
  "label.print.error": "Error generating label. Please try again.",
  "label.print.error.popupBlocked": "Popup blocked. Please allow popups for this site to print labels.",
  "label.print.generating": "Generating...",
  "label.print.success": "Label printed successfully",
  "label.print.description": "Print labels for orders and samples",
  "label.print.helper": "Select the type and quantity of labels to print",
  "label.print.success.count": "{count} labels printed successfully",
  "label.print.title": "Print Labels",
  "label.printAll": "Print All Labels",
  "label.printAll.success": "All labels printed successfully",
  "label.printConfirmation.message": "Print label for {name}{code}?",
  "label.printConfirmation.title": "Print Label",
  "label.printHistory": "Print History",
  "label.printHistory.byUser": "By {user}",
  "label.printHistory.count": "{count} labels",
  "label.printHistory.loading": "Loading print history...",
  "label.printHistory.never": "Never printed",
  "label.printHistory.unknownUser": "Unknown",
  "label.printHistory.viewAll": "View History",
  "label.printLabel": "Print Label",
  "label.program": "Program",
  "label.qualifiers": "Qualifiers",
  "label.quantity": "Quantity",
  "label.readonly": "Read Only",
  "label.reference.value": "Reference value",
  "label.refertest.referencelab": "Refer test to a reference lab",
  "label.rejectedByBiologist": "Rejected by biologist",
  "label.rejectedByTechnician": "Rejected by technician",
  "label.remove": "Remove",
  "label.replaceWith": "Replace with",
  "label.report.byNationalId": "By National ID / Unique Health ID number",
  "label.reporting.range": "Reporting range",
  "label.result.order": "Result order",
  "label.resultSelectList": "Result select list",
  "label.routine.Reports": "Routine Reports",
  "label.sample.types.activate": "The following sample types will be activated:",
  "label.sample.types.deactivate": "The following sample types will be deactivated because they have no tests:",
  "label.save": "Save",
  "label.saving": "Saving...",
  "label.search.available.targetest": "Search Available Tests",
  "label.search.availablepanel": "Search Available panel",
  "label.search.labno.family": "Search by LabNo or Family Name",
  "label.search.patient": "Search Patient",
  "label.select": "Select",
  "label.select.dateRange": "Select the Date Range you want the Report For",
  "label.select.list.options": "Select list options",
  "label.selectTestSectionCatalog": "Select test section to view catalog for that section",
  "label.sex.dependent": "Sex dependent",
  "label.shortCode": "Short Code",
  "label.shortCode.error.invalidChars": "Short code can only contain letters, numbers, hyphens, and underscores",
  "label.shortCode.error.maxLength": "Short code must be 10 characters or less",
  "label.shortCode.error.network": "Could not verify uniqueness. Please check manually.",
  "label.shortCode.error.save": "Error saving short code: {error}",
  "label.shortCode.error.startChar": "Short code must start with a letter or number",
  "label.shortCode.helper": "Max 10 characters, alphanumeric, hyphen, underscore",
  "label.shortCode.optional.helper": "Optional (code will be used if ≤10 chars). Max 10 characters, alphanumeric with hyphens/underscores",
  "label.shortCode.required.helper": "Required when code > 10 characters. Max 10 characters, alphanumeric with hyphens/underscores",
  "label.shortCode.update.success": "Short code updated successfully",
  "label.shortCodeRequired": "Short code is required for label printing. Please set short code in Edit form first.",
  "label.shortCodeWarning": "Changing short code will invalidate existing labels",
  "label.showChildren": "Show Child Elements",
  "label.study.Reports": "Study Reports",
  "label.test.activate": "The following tests will be activated:",
  "label.test.add": "Add test to order",
  "label.test.batch.cancel.finish": "This is non-reversible.",
  "label.test.batch.cancel.start": "You have selected to cancel the test",
  "label.test.batch.no.change.finish": "tests will not be changed.",
  "label.test.batch.replace.start": "The following",
  "label.test.deactivate": "The following tests will be deactivated:",
  "label.test.display.order": "Test display order",
  "label.test.order.confirm": "Verify: Enable/disable test orderability",
  "label.test.orderable": "The following tests will be orderable from the order form.",
  "label.test.results": "Test Results",
  "label.test.resultsData": "Test results data",
  "label.test.unorderable": "The following tests will not be orderable on order form.  They will only be orderable as a reflexed test.",
  "label.testActivate": "Test Activation",
  "label.testName": "Test names",
  "label.text.generate": "generate",
  "label.total.tests": "Total Tests",
  "label.type": "Label Type",
  "label.type.order": "Order Label",
  "label.type.sample": "Sample Label",
  "label.unit": "Unit",
  "label.user.notestsection": "Current User has no Assined Lab Unit . Please Contact admin",
  "label.validation.errors": "Validation Errors",
  "label.validation.results": "Validation Results",
  "label.view": "View",
  "label.viewtestCatalog": "Test Catalog",
  "label.warning": "Warning",
  "label.yes": "Yes",
  "labno.alt.prefix.instruction": "Prefix for pre-printed barcode labels (4 characters) :",
  "labno.alt.prefix.note": "NOTE: If this prefix has already been used, the numbering will continue from the last number generated.",
  "labno.alt.prefix.use": "Use the same accession number format and pool of available numbers as Order Entry Generation.",
  "language.select.label": "English",
  "legend.search.availabletests": "Search through the available tests",
  "loading": "Loading...",
  "loading.boxes": "Loading boxes...",
  "loading.description": "Loading...",
  "location.collection.title": "Collection Location",
  "location.environmentalConditions": "Environmental Conditions",
  "location.environmentalConditions.placeholder": "e.g. 25°C, clear weather",
  "location.gps.error": "Unable to get location",
  "location.gps.getCurrent": "Get Current Location",
  "location.gps.getting": "Getting location...",
  "location.gps.latitude": "GPS Latitude",
  "location.gps.longitude": "GPS Longitude",
  "location.gps.notSupported": "Geolocation is not supported by your browser",
  "location.gps.permissionDenied": "Location permission denied",
  "location.gps.timeout": "Location request timed out",
  "location.gps.unavailable": "Location information unavailable",
  "location.helper": "Location hierarchy (Region / District / Town-Village) uses the existing system of Location structure. Environmental workflow profiles allow some rows to be unlabeled to provide simpler or shorter row sets for setup as required.",
  "location.requesterReference": "Requester Reference",
  "location.requesterReference.placeholder": "e.g. EPA Method 524.2",
  "location.select.placeholder": "Select {levelName}...",
  "location.siteDescription": "Collection Site Description",
  "location.siteDescription.placeholder": "e.g. Municipal water supply intake point",
  "locale.active": "Active",
  "locale.add": "Add Language",
  "locale.add.title": "Add Language",
  "locale.code": "Locale Code",
  "locale.code.helper": "e.g., en, fr, es, pt",
  "locale.create.success": "Language created successfully",
  "locale.delete.confirm.message": "Are you sure you want to delete this language? This action cannot be undone.",
  "locale.delete.confirm.title": "Delete Language",
  "locale.delete.error": "Failed to delete language",
  "locale.delete.fallback.error": "Cannot delete the fallback language. Set another language as fallback first.",
  "locale.delete.success": "Language deleted successfully",
  "locale.displayName": "Display Name",
  "locale.displayName.helper": "e.g., English, Français, Español",
  "locale.edit.title": "Edit Language",
  "locale.fallback": "Fallback",
  "locale.fallback.error": "Failed to set fallback language",
  "locale.fallback.success": "Fallback language updated",
  "locale.management.description": "Manage supported languages for metadata translations.",
  "locale.management.title": "Language Management",
  "locale.setFallback": "Set as Fallback",
  "locale.sortOrder": "Sort Order",
  "locale.status": "Status",
  "locale.update.success": "Language updated successfully",
  "log.submitting.aliquot.data": "Submitting aliquot data:",
  "log.submitting.aliquot.data2": "Submitting aliquot data (JSON):",
  "logging.management.apply": "Apply Log Level",
  "logging.management.description": "Change the backend logging level at runtime. This is useful for debugging issues without restarting the server. Changes take effect immediately but do not persist across server restarts.",
  "logging.management.label": "Logging Configuration",
  "logging.management.level": "Log Level",
  "logging.management.logger": "Logger Name",
  "logging.management.logger.helper": "e.g., org.openelisglobal, root",
  "logging.management.success": "Log level set to {level} for {logger}",
  "login.account.disabled": "Account Disabled",
  "login.account.locked": "Account Locked",
  "login.complexity.message": "Password must : ",
  "login.complexity.message.1": "Must Be at least 7 characters",
  "login.complexity.message.2": "May contain upper and lower case letters or numbers",
  "login.complexity.message.3": "Must contain at least one of the following characters: *, $, #, !",
  "login.complexity.message.4": "Must not contain any other characters",
  "login.complexity.new.message": "New Password must : ",
  "login.complexity.new.message.1": "Must not be the same as the current password",
  "login.login.": "Repeat Password",
  "login.login.current.password": "Current Password",
  "login.login.first": "First Name",
  "login.login.last": "Last Name",
  "login.login.name": "Login Name",
  "login.login.new.password": "New Password",
  "login.login.password": "Password",
  "login.login.repeat.password": "Repeat Password",
  "login.msg.password": "Password",
  "login.msg.password.missing": "A password is required",
  "login.msg.username": "Username",
  "login.msg.username.missing": "A username is required",
  "login.notice.message": "Notice: Access to this service is for authorized personnel only. If you do not have the expressed authorization of the administrator, you must exit now. This organization prohibits unauthorized access, disclosure, duplication, modification, diversion, destruction, loss, misuse, or theft of its information.",
  "login.password.expired.date": "Password Expiration Date",
  "login.password.expired.date.placeholder": "(dd/mm/yyyy)",
  "login.redirecting.sso": "Redirecting to single sign-on...",
  "login.subtitle": "Login",
  "login.timeout": "User Time Out (minutes)",
  "login.timeout.placeholder": "Enter in ms",
  "login.title": "Login",
  "lot.barcode": "Barcode",
  "lot.calculatedExpiry": "Calculated Expiry",
  "lot.currentQuantity": "Current Quantity",
  "lot.dateOpened": "Date Opened",
  "lot.details.no.transactions": "No transactions recorded for this lot",
  "lot.details.no.usage": "No usage history for this lot",
  "lot.details.section.basic": "Basic Information",
  "lot.details.section.dates": "Important Dates",
  "lot.details.section.quantities": "Quantities",
  "lot.details.section.storage": "Storage Location",
  "lot.details.section.transactions": "Transaction History",
  "lot.details.section.usage": "Usage History",
  "lot.details.tab.info": "Information",
  "lot.details.tab.transactions": "Transactions",
  "lot.details.tab.usage": "Usage History",
  "lot.details.title": "Lot Details",
  "lot.details.view": "View Details",
  "lot.expirationDate": "Expiration Date",
  "lot.form.title.add": "Receive New Inventory Lot",
  "lot.form.title.edit": "Edit Inventory Lot",
  "lot.initialQuantity": "Initial Quantity",
  "lot.number": "Lot Number",
  "lot.qcStatus": "QC Status",
  "lot.receiptDate": "Receipt Date",
  "lot.save.error": "Error saving lot",
  "lot.save.success": "Lot saved successfully",
  "lot.selectItem": "Select Catalog Item",
  "lot.selectLocation": "Select Storage Location",
  "lot.status": "Status",
  "lot.storageLocation": "Storage Location",
  "manage.testing.algorithms.add.reflex.tests": "Manage Testing Algorithms and Reflex tests",
  "master.lists.page": "Master Lists Page",
  "master.lists.page.analyzer": "Analyzer TestName Menu",
  "master.lists.page.barcode": "Barcode Configuration",
  "master.lists.page.batchtest": "Batch test reassignment and cancelation",
  "master.lists.page.external.connections": "External Connections Menu",
  "master.lists.page.field": "Field Validation Configuration ",
  "master.lists.page.list": "List Plugins",
  "master.lists.page.menu": "Menu Configuration",
  "master.lists.page.notification": "Test Notification Configuration",
  "master.lists.page.order.entry": "Order Entry Configuration",
  "master.lists.page.org": "Organization Menu",
  "master.lists.page.patient": "Patient Entry Configuration",
  "master.lists.page.printed": "Printed Reports Configuration",
  "master.lists.page.provider": "Provider",
  "master.lists.page.report.result": "Result Reporting Configuration",
  "master.lists.page.result": "Result Entry Configuration",
  "master.lists.page.site": "Site Information",
  "master.lists.page.test.management": "Test Management",
  "master.lists.page.user": "User Management",
  "master.lists.page.work.plan": "Workplan Configuration ",
  "menu.accession.validation": "By Order",
  "menu.accession.validation.range": "By Range of Order Numbers",
  "menu.billing.active": "Billing Menu Active",
  "menu.billing.address": "Billing URL",
  "menu.billing.title": "Billing Menu Management",
  "menu.genericSample": "Generic Sample",
  "menu.genericSample.edit": "Edit Order",
  "menu.genericSample.import": "Import",
  "menu.genericSample.order": "Order",
  "menu.global.title": "Global Menu Management",
  "menu.label.filter": "Filters : ",
  "menu.label.filter.active": "Only Active",
  "menu.label.filter.admin": "Only Administrator",
  "menu.label.filter.role": "By Lab Unit Roles",
  "menu.nonconform.active": "Non-Conformity Menu Active",
  "menu.nonconform.title": "Non-Conformity Menu Management",
  "menu.patient.active": "Patient Menu Active",
  "menu.patient.title": "Patient Menu Management",
  "menu.results.range": "By Range of Order numbers",
  "menu.sidenav.active": "Side Nav Active",
  "menu.study.active": "Study Menu Active",
  "menu.study.title": "Study Menu Configuration",
  "menu.validation.date": "By Date",
  "message.method.activation": "This method unit will not be active until at least one test has been assigned to it.",
  "message.noPluginFound": "No plugins Found",
  "message.propertiesupdate.success": "Properties updated successfully",
  "method.browse.title": "Method Section",
  "method.methodName": "Method Name",
  "method.modal.add.heading": "Add New Method",
  "modal.add.method": "Add New Method",
  "move.back": "Move Back",
  "move.to.aliquot": "Move to Aliquot",
  "new.patient.label": "New Patient",
  "new.program.label": "New Program",
  "next.action.button": "Next",
  "nextLabel.action.button": "Next Label",
  "no.aliquots": "No aliquots available",
  "no.analysis.found": "No analyses found",
  "no.data.found": "No Data Found",
  "no.option": "No",
  "noTestsFound.matching": "No test found matching",
  "nonconform.add.new.date": "Add new date",
  "nonconform.corrective.action": "Planned or recommended corrective action:",
  "nonconform.corrective.actionType": "Action Type",
  "nonconform.corrective.comment": "Comments",
  "nonconform.corrective.control": "Planned or recommended corrective preventive action or concurrent controls:",
  "nonconform.corrective.title": "Nonconforming Events Corrective Action",
  "nonconform.date.completed": "Date Completed",
  "nonconform.date.discussion.nce": "Date of discussion with NCE Staff",
  "nonconform.date.event": "Date of Event",
  "nonconform.description.nce": "Description of NCE",
  "nonconform.field.date": "NCE Date",
  "nonconform.field.reporting.data": "Reporting Date",
  "nonconform.goToNceForm": "Go to NCE Reporting Form",
  "nonconform.lab.componenet.nce": "Laboratory Component where NCE took place",
  "nonconform.label.highseverity": "9 = very high severity-- immediate action is required",
  "nonconform.label.lowseverity": "1 = very low severity-- no immediate action is required",
  "nonconform.label.prescibernamesite": "Prescriber Name and Site",
  "nonconform.label.proposed.action": "Proposed Action",
  "nonconform.label.reportingunit": "Reporting Unit",
  "nonconform.label.suspected.cause.nce": "Suspected Cause of NCE",
  "nonconform.nce.concurrent.control.action": "concurrent control action",
  "nonconform.nce.number": "NCE Number",
  "nonconform.nce.preventive.action": "preventive action",
  "nonconform.nce.resolution": "NCE Resolution",
  "nonconform.nce.resolution.description": "Were the corrective actions and preventive/concurrentcontrols effective in solving the nonconforming event and preventing it from recurring?",
  "nonconform.nce.turnaround.time": "Turnaround Time",
  "nonconform.order.save.fail": "Save failed",
  "nonconform.order.save.success": "Save was successful",
  "nonconform.person.reporting.different": "Name of person reporting NCE (if different)",
  "nonconform.person.responsible": "Person responsible",
  "nonconform.report": "Report Non-Conforming Event (NCE)",
  "nonconform.report.field.date": "Report Date",
  "nonconform.severity.score": "Severity Score",
  "nonconform.view.comments": "Comments",
  "nonconform.view.corrective.action.description": "Description of corrective action to take",
  "nonconform.view.event.date": "Date of Event",
  "nonconform.view.event.description": "Description of Event",
  "nonconform.view.lab.component": "Laboratory Component",
  "nonconform.view.nce.category": "NCE Category",
  "nonconform.view.nce.likely.occur": "How likely is the NCE to recur?",
  "nonconform.view.nce.severity": "Severity",
  "nonconform.view.nce.type": "NCE Type",
  "nonconform.view.preventive.description": "If applicable, description of preventive or concurrent control action",
  "nonconform.view.report": "View New Non Conform Event",
  "nonconform.view.reporting.person": "Reporting Person",
  "nonconform.view.severe.consequences": "How severe are the consequences or impact of the NCE?",
  "nonconform.view.specimen": "Specimen(s)",
  "nce.attachment.dropzone": "Drag and drop files here or click to upload",
  "nce.attachment.error.maxFiles": "Maximum {maxFiles} files allowed",
  "nce.attachment.error.size": "File size exceeds maximum of {maxSize}",
  "nce.attachment.error.type": "File type not allowed. Accepted types: {types}",
  "nce.attachment.error.upload": "Error uploading file",
  "nce.attachment.files": "files",
  "nce.attachment.hint": "(Optional - max {maxFiles} files, 10MB each)",
  "nce.attachment.uploading": "Uploading...",
  "nce.category.administrative": "Administrative",
  "nce.category.analytical": "Analytical",
  "nce.category.postanalytical": "Post-analytical",
  "nce.category.preanalytical": "Pre-analytical",
  "nce.field.attachments": "Attachments",
  "nce.field.notes": "Notes",
  "nce.field.description.placeholder": "Describe what happened, when it was detected, and any relevant context...",
  "nce.field.immediateAction": "Immediate Action Taken",
  "nce.field.immediateAction.placeholder": "What corrective steps were taken immediately...",
  "nce.field.linkedItems": "Linked Samples/Results",
  "nce.field.severity": "Severity",
  "nce.field.title": "Title",
  "nce.field.title.placeholder": "Brief description of the event...",
  "nce.severity.critical": "Critical",
  "nce.severity.critical.description": "Patient safety risk, regulatory violation",
  "nce.severity.major": "Major",
  "nce.severity.major.description": "Significant quality or operational impact",
  "nce.severity.minor": "Minor",
  "nce.severity.minor.description": "Limited impact, easily corrected",
  "nce.severity.low": "Low",
  "nce.severity.low.description": "Minimal impact, no corrective action required",
  "nce.status.open": "Open",
  "nce.status.underInvestigation": "Under Investigation",
  "nce.status.correctiveAction": "Corrective Action",
  "nce.status.closed": "Closed",
  "nce.tree.empty": "No orders found. Search for a lab number to begin.",
  "nce.tree.loading": "Loading orders...",
  "nce.tree.order": "Order",
  "nce.tree.search": "Filter by test or sample...",
  "nce.tree.selected": "{sampleCount} samples, {resultCount} results selected",
  "nce.trigger.order_cancellation": "Order cancellation may require NCE documentation",
  "nce.trigger.partial_sample_rejection": "Partial sample rejection requires NCE documentation",
  "nce.trigger.pathology_rejection": "Pathology case rejection may require NCE documentation",
  "nce.trigger.premature_disposal": "Premature disposal may require NCE documentation",
  "nce.trigger.qc_invalidation": "QC invalidation requires NCE documentation",
  "nce.trigger.referral_rejection": "Referral rejection requires NCE documentation",
  "nce.trigger.result_rejection_no_retest": "Result rejection without retest requires NCE documentation",
  "nce.trigger.result_rejection_retest": "Result rejection with retest may require NCE documentation",
  "nce.trigger.sample_rejection": "Sample rejection requires NCE documentation",
  "nce.trigger.test_cancel_no_results": "Test cancellation may require NCE documentation",
  "nce.trigger.test_cancel_with_results": "Test cancellation with results requires NCE documentation",
  "nce.type.calibration_failure": "Calibration failure",
  "nce.type.communication_failure": "Communication failure",
  "nce.type.contamination": "Contamination",
  "nce.type.documentation_error": "Documentation error",
  "nce.type.equipment_malfunction": "Equipment malfunction",
  "nce.type.labeling_error": "Labeling error",
  "nce.type.patient_id_mismatch": "Patient ID mismatch",
  "nce.type.policy_violation": "Policy violation",
  "nce.type.procedure_deviation": "Procedure deviation",
  "nce.type.qc_failure": "QC failure",
  "nce.type.reagent_issue": "Reagent issue",
  "nce.type.report_delay": "Report delay",
  "nce.type.report_distribution_error": "Report distribution error",
  "nce.type.requisition_incomplete": "Requisition incomplete",
  "nce.type.resource_shortage": "Resource shortage",
  "nce.type.result_interpretation_error": "Result interpretation error",
  "nce.type.sample_collection_error": "Sample collection error",
  "nce.type.staff_competency_issue": "Staff competency issue",
  "nce.type.storage_error": "Storage error",
  "nce.type.system_error": "System error",
  "nce.type.training_gap": "Training gap",
  "nce.type.transcription_error": "Transcription error",
  "nce.type.transport_issue": "Transport issue",
  "nce.type.request_form_error": "Request form error",
  "nce.type.equipment_failure": "Equipment failure",
  "nce.type.procedure_error": "Procedure error",
  "nce.type.calibration_error": "Calibration error",
  "nce.type.cross_contamination": "Cross-contamination",
  "nce.type.result_transcription_error": "Result transcription error",
  "nce.type.report_delivery_error": "Report delivery error",
  "nce.type.critical_value_not_reported": "Critical value not reported",
  "nce.type.delayed_result": "Delayed result",
  "nce.type.result_amendment": "Result amendment",
  "nce.type.training_issue": "Training issue",
  "nce.button.createNce": "Create NCE",
  "nce.button.skip": "Skip",
  "nce.creating": "Creating NCE...",
  "nce.description.placeholder": "Describe the non-conforming event...",
  "nce.error.create.failed": "Failed to create NCE",
  "nce.error.severity.required": "Severity is required",
  "nce.trigger.mandatory.message": "You must create an NCE before proceeding with this action.",
  "nce.trigger.mandatory.title": "NCE Required",
  "nce.trigger.order_cancellation.message": "Order cancellation may require documentation of a non-conforming event.",
  "nce.trigger.order_cancellation.title": "Order Cancellation - NCE",
  "nce.trigger.partial_sample_rejection.message": "Partial sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.partial_sample_rejection.title": "Partial Sample Rejection - NCE Required",
  "nce.trigger.pathology_rejection.message": "Pathology case rejection may require documentation of a non-conforming event.",
  "nce.trigger.pathology_rejection.title": "Pathology Rejection - NCE",
  "nce.trigger.premature_disposal.message": "Premature disposal may require documentation of a non-conforming event.",
  "nce.trigger.premature_disposal.title": "Premature Disposal - NCE",
  "nce.trigger.qc_invalidation.message": "QC invalidation requires documentation of a non-conforming event.",
  "nce.trigger.qc_invalidation.title": "QC Invalidation - NCE Required",
  "nce.trigger.referral_rejection.message": "Referral rejection requires documentation of a non-conforming event.",
  "nce.trigger.referral_rejection.title": "Referral Rejection - NCE Required",
  "nce.trigger.result_rejection_no_retest.message": "Result rejection without retest requires documentation of a non-conforming event.",
  "nce.trigger.result_rejection_no_retest.title": "Result Rejection - NCE Required",
  "nce.trigger.result_rejection_retest.message": "Result rejection with retest may require documentation of a non-conforming event.",
  "nce.trigger.result_rejection_retest.title": "Result Rejection - NCE",
  "nce.trigger.sample_rejection.message": "Sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.sample_rejection.title": "Sample Rejection - NCE Required",
  "nce.trigger.test_cancel_no_results.message": "Test cancellation may require documentation of a non-conforming event.",
  "nce.trigger.test_cancel_no_results.title": "Test Cancellation - NCE",
  "nce.trigger.test_cancel_with_results.message": "Test cancellation with existing results requires documentation of a non-conforming event.",
  "nce.trigger.test_cancel_with_results.title": "Test Cancellation - NCE Required",
  "nce.admin.trigger.config.title": "NCE Trigger Configuration",
  "nce.admin.trigger.config.description": "Configure when Non-Conforming Events are automatically created or prompted.",
  "nce.admin.trigger.behaviors.title": "Trigger Behaviors",
  "nce.admin.rejection.mappings.title": "Rejection Reason Mappings",
  "nce.admin.rejection.mappings.description": "Map rejection reasons to NCE categories for automatic population.",
  "nce.trigger.behavior.mandatory": "Mandatory",
  "nce.trigger.behavior.prompted": "Prompted",
  "nce.trigger.behavior.disabled": "Disabled",
  "nce.trigger.column.type": "Trigger Type",
  "nce.trigger.column.description": "Description",
  "nce.trigger.column.behavior": "Behavior",
  "nce.trigger.column.active": "Active",
  "nce.trigger.type.sampleRejection": "Sample Rejection",
  "nce.trigger.type.resultRejection": "Result Rejection",
  "nce.trigger.type.qaEvent": "QA Event",
  "nce.trigger.type.manual": "Manual",
  "nce.trigger.update.success": "Trigger configuration updated",
  "nce.trigger.update.error": "Failed to update trigger configuration",
  "nce.mapping.add": "Add Mapping",
  "nce.mapping.edit": "Edit Mapping",
  "nce.mapping.column.rejectionReason": "Rejection Reason",
  "nce.mapping.column.category": "NCE Category",
  "nce.mapping.column.type": "NCE Type",
  "nce.mapping.column.severity": "Default Severity",
  "nce.mapping.column.active": "Active",
  "nce.mapping.noData": "No rejection mappings configured",
  "nce.mapping.validation.error": "Rejection reason and category are required",
  "nce.mapping.save.success": "Mapping saved successfully",
  "nce.mapping.active": "Active",
  "nce.field.category": "Category",
  "nce.field.type": "Type",
  "nce.select.category": "Select a category",
  "nce.select.type": "Select a type",
  "nce.error.dateOfEvent.required": "Date of event is required",
  "nce.error.reportingUnit.required": "Reporting unit is required",
  "nce.error.description.required": "Description is required",
  "nce.error.suspectedCauses.required": "Suspected causes are required",
  "nce.error.proposedAction.required": "Proposed action is required",
  "nce.error.category.required": "Category is required",
  "nce.attachment.saveFirst": "Save the NCE event to enable file attachments",
  "nce.attachment.error.noEvent": "Please save the NCE event first before uploading attachments",
  "nce.attachment.download": "Download",
  "nce.attachment.delete": "Delete",
  "sidenav.label.admin.nceTriggerConfig": "Trigger Configuration",
  "sidenav.label.admin.nceCategoryType": "Categories & Types",
  "sidenav.label.admin.nceConfig": "NCE Configuration",
  "nce.admin.categorytype.title": "NCE Categories & Types Configuration",
  "nce.admin.categorytype.description": "Manage the categories and types available for Non-Conforming Events.",
  "nce.admin.tab.categories": "Categories",
  "nce.admin.tab.types": "Types",
  "nce.admin.category.add": "Add Category",
  "nce.admin.category.edit": "Edit Category",
  "nce.admin.category.name.required": "Category name is required",
  "nce.admin.category.save.success": "Category saved successfully",
  "nce.admin.category.save.error": "Failed to save category",
  "nce.admin.type.add": "Add Type",
  "nce.admin.type.edit": "Edit Type",
  "nce.admin.type.validation.error": "Type name and category are required",
  "nce.admin.type.save.success": "Type saved successfully",
  "nce.admin.type.save.error": "Failed to save type",
  "nce.admin.column.name": "Name",
  "nce.admin.column.displayKey": "Display Key",
  "nce.admin.column.typesCount": "Types Count",
  "nce.admin.column.category": "Category",
  "nce.admin.column.actions": "Actions",
  "nce.admin.field.name": "Name",
  "nce.admin.field.displayKey": "Display Key (for i18n)",
  "nce.admin.field.displayKey.helper": "Optional. Used for translations.",
  "nce.admin.field.category": "Category",
  "nce.admin.delete.confirm.title": "Confirm Delete",
  "nce.admin.delete.confirm.message": "Are you sure you want to delete '{name}'? This action cannot be undone.",
  "nce.admin.delete.success": "Deleted successfully",
  "nce.inline.title": "Report Non-Conformity Event",
  "nce.inline.context": "CONTEXT (Auto-populated)",
  "nce.dashboard.title": "All NCEs",
  "nce.dashboard.subtitle": "All open NCEs across the laboratory",
  "nce.button.reportNce": "Report NCE",
  "nce.search.placeholder": "Search NCEs...",
  "nce.filter.allStatus": "All Status",
  "nce.filter.allCategories": "All Categories",
  "nce.filter.allSeverities": "All Severities",
  "nce.filter.clearAll": "Clear All",
  "nce.summary.critical": "Critical",
  "nce.summary.major": "Major",
  "nce.summary.minor": "Minor",
  "nce.summary.overdue": "Overdue",
  "nce.tag.overdue": "Overdue",
  "nce.tab.eventDetails": "Event Details",
  "nce.tab.investigation": "Investigation",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "History",
  "nce.field.suspectedCauses": "Suspected Causes",
  "nce.field.proposedAction": "Proposed Action",
  "nce.field.trigger": "Trigger",
  "nce.capa.noItems": "No corrective/preventive actions recorded yet.",
  "nce.history.noItems": "No history available.",
  "nce.history.system": "System",
  "nce.action.acknowledge": "Acknowledge",
  "nce.action.assignTo": "Assign To",
  "nce.action.addNote": "Add Note",
  "nce.link.duplicate.warning": "These specimens are already linked to this NCE",
  "nce.list.empty": "No NCEs found matching your criteria.",
  "nce.modal.addNote": "Add Note",
  "nce.modal.addNoteDescription": "Add a note to NCE {nceNumber}",
  "nce.modal.notePlaceholder": "Enter your note...",
  "nce.modal.assign": "Assign NCE",
  "nce.modal.assignDescription": "Assign NCE {nceNumber} to a user",
  "nce.modal.selectUser": "Select User",
  "nce.modal.searchUser": "Search for a user...",
  "nce.assign.selectUser": "Please select a user to assign",
  "nce.assign.success": "NCE assigned successfully",
  "nce.assign.error": "Failed to assign NCE",
  "nce.acknowledge.success": "NCE acknowledged successfully",
  "nce.acknowledge.error": "Failed to acknowledge NCE",
  "nce.note.empty": "Please enter a note",
  "nce.note.success": "Note added successfully",
  "nce.note.error": "Failed to add note",
  "nce.attachment.downloadError": "Failed to download attachment",
  "nce.attachment.viewError": "Failed to view attachment",
  "not.available": "Not available",
  "not.specified": "Not specified",
  "notAuthenticated": "Not Authenticated",
  "notebook.attachments.title": "Attachments",
  "notebook.attachments.uploadPrompt": "click to upload files",
  "notebook.auditTrail.action.archived": "Archived",
  "notebook.auditTrail.action.created": "Created",
  "notebook.auditTrail.action.finalized": "Finalized",
  "notebook.auditTrail.action.locked": "Locked",
  "notebook.auditTrail.action.submitted": "Submitted",
  "notebook.auditTrail.action.updated": "Updated",
  "notebook.auditTrail.comingSoon": "Audit trail functionality will be available soon.",
  "notebook.auditTrail.none.subtitle": "No audit trail entries found for this notebook.",
  "notebook.auditTrail.none.title": "No Audit Trail Available",
  "notebook.auditTrail.title": "Audit Trail",
  "notebook.button.edit": "Edit",
  "notebook.button.editResults": "Edit Results",
  "notebook.button.enterResults": "Enter Results",
  "notebook.button.newLabNotebook": "Project",
  "notebook.button.view": "View",
  "notebook.comments.add.button": "Add Comment",
  "notebook.comments.add.label": "Add a comment",
  "notebook.comments.none.subtitle": "No comments have been added yet.",
  "notebook.comments.none.title": "No Comments",
  "notebook.comments.title": "Comments",
  "notebook.error.notAssigned": "You are not assigned to this project",
  "notebook.heading.allEntries": "All Entries",
  "notebook.heading.notebooks": "Projects",
  "notebook.icon.edit": "Edit",
  "notebook.instruments.title": "Instruments",
  "notebook.label.addpage": "Add Page",
  "notebook.label.author": "Author",
  "notebook.label.basicinfo": "Basic Information",
  "notebook.label.content": "Main Content",
  "notebook.label.dashboard": "Notebook Dashboard",
  "notebook.label.drafts": "Drafts",
  "notebook.label.entryFiles": "Entry Files",
  "notebook.label.entryTags": "Entry Tags",
  "notebook.label.experimentDoc": "Experiment Documentation",
  "notebook.label.experimentType": "Experiment Type",
  "notebook.label.filter.types": "Experiment Types",
  "notebook.label.finalized": "Finalized This Week",
  "notebook.label.formEntry": "NoteBook Form Entry",
  "notebook.label.objective": "Objective",
  "notebook.label.pages": "WorkFlow Pages",
  "notebook.label.pending": "Pending Review",
  "notebook.label.project": "Project",
  "notebook.label.project.title": "Project Title",
  "notebook.label.projectFiles": "Project Files",
  "notebook.label.projectTags": "Project Tags",
  "notebook.label.protocol": "Protocol ID",
  "notebook.label.questionnaire": "Questionnaire",
  "notebook.label.sampleManagement": "Sample Management",
  "notebook.label.status": "Status",
  "notebook.label.technician": "Technician",
  "notebook.label.title": "Entry Title",
  "notebook.label.total": "Total Entries",
  "notebook.page.completed": "Completed",
  "notebook.page.content": "Content:",
  "notebook.page.instructions": "Instructions:",
  "notebook.page.markComplete": "Mark as Complete",
  "notebook.page.modal.add.errorRequired": "Title and Content are required.",
  "notebook.page.modal.add.title": "Add New Page",
  "notebook.page.modal.content.label": "Content",
  "notebook.page.modal.edit.title": "Edit Page",
  "notebook.page.modal.instructions.label": "Instructions",
  "notebook.page.modal.title.label": "Title",
  "notebook.page.title": "Notebook",
  "notebook.pages.none.subtitle": "Click to add Pages",
  "notebook.pages.none.title": "No Pages Added",
  "notebook.project.definition.form.title": "Project Definition Form",
  "notebook.project.entry.form.title": "Project Entry Form",
  "notebook.results.modal.title": "Results for {accession}",
  "notebook.results.noAccession": "No accession number available for this sample",
  "notebook.results.none.subtitle": "No results found for the provided accession number.",
  "notebook.results.none.title": "No Results Found",
  "notebook.results.title": "Results",
  "notebook.sample.result.dateCreated": "Date Created",
  "notebook.samples.available": "Available Samples",
  "notebook.samples.none.subtitle": "Search Samples By Patient or Accession Number",
  "notebook.samples.none.subtitle.selected": "Click to add samples",
  "notebook.samples.none.title": "No samples Available",
  "notebook.samples.none.title.selected": "No Samples Selected",
  "notebook.samples.resultsRecorded": "Results Recorded:",
  "notebook.samples.selected": "Selected Samples",
  "notebook.search.byAccession": "Search By Accession",
  "notebook.search.byPatient": "Search By Patient",
  "notebook.select.label": "Select Notebook",
  "notebook.status.archived": "Archive Entry",
  "notebook.status.assignment.title": "Status and Assignment",
  "notebook.status.draft": "Save Draft",
  "notebook.status.finalized": "Finalize Entry",
  "notebook.status.locked": "Lock Entry",
  "notebook.status.metadata.title": "Status & Metadata",
  "notebook.status.submitted": "Submit for Review",
  "notebook.tab.attachments": "Attachments",
  "notebook.tab.auditTrail": "Audit Trail",
  "notebook.tab.comments": "Comments",
  "notebook.tab.content": "Content",
  "notebook.tab.entryDetails": "Entry Details",
  "notebook.tab.metadata": "MetaData",
  "notebook.tab.results": "Results",
  "notebook.tab.samples": "Samples",
  "notebook.tab.workflow": "Workflow",
  "notebook.table.header.entries": "Entries",
  "notebook.tag.placeholder": "Enter Tags",
  "notebook.tags.add": "Add Tag",
  "notebook.tags.modal.add.errorRequired": "Tag is required.",
  "notebook.tags.modal.add.label": "Tag",
  "notebook.tags.modal.add.title": "Add New Tag",
  "notebook.tags.title": "Tags",
  "notebook.validation.content.required": "Main Content is required.",
  "notebook.validation.objective.required": "Objective is required.",
  "notebook.validation.project.required": "Project is required.",
  "notebook.validation.protocol.required": "Protocol ID is required.",
  "notebook.validation.title.required": "Title is required.",
  "notebook.validation.type.required": "Experiment Type is required.",
  "notification.error": "Error",
  "notification.info": "Information",
  "notification.invalid.confirm.password": "Your entered password is not same as above password.",
  "notification.invalid.loginName": "Please enter AlphaNumeric values without spaces only.",
  "notification.invalid.name": "Please enter Alphanumeric values only.",
  "notification.invalid.password": "Please enter password according to instructions.",
  "notification.login.generic.error": "Error while attempting login",
  "notification.login.syntax.error": "Error while attempting login - Could not parse response to JSON",
  "notification.organization.post.delete.success": "Organization Deactivated Succesfully.",
  "notification.organization.post.internetAddress": "Enter a valid Organization Url.",
  "notification.organization.post.save.success": "Organization Information Added Succesfully.",
  "notification.organization.post.success": "Organization Information Updated Succesfully.",
  "notification.password.change.fail": "Password change failed",
  "notification.password.change.success": "Password changed successfully",
  "notification.response.syntax.error": "Error - Could not parse response to JSON",
  "notification.slideover.button.hideread": "Hide read",
  "notification.slideover.button.markallasread": "Mark all as Read",
  "notification.slideover.button.markasread": "Mark as Read",
  "notification.slideover.button.reload": "Reload",
  "notification.slideover.button.showread": "Show read",
  "notification.slideover.button.subscribe": "Subscribe on this Device",
  "notification.slideover.button.subscribe.fail": "Subscribe failed",
  "notification.slideover.button.subscribe.success": "Subscribed successfully",
  "notification.slideover.button.unsubscribe": "Unsubscribe",
  "notification.slideover.button.unsubscribe.fail": "Unsubscribe failed",
  "notification.slideover.button.unsubscribe.success": "Unsubscribed successfully",
  "notification.slideover.empty.header": "You're all caught up",
  "notification.sliderover.empty.message": "You don't have any notifications at this time.",
  "notification.title": "Notification Message",
  "notification.user.post.delete.success": "User Deactivated Succesfully.",
  "notification.user.post.save.success": "User Information Added Succesfully.",
  "notify.error": "User and Message are required",
  "notify.main.title": "Notify User",
  "notify.message": "Message",
  "notify.user.by": "User to be notified",
  "notify.user.success.notification": "Notification sent successfully",
  "of": "of",
  "openreports.activity.title": "Activity Reports",
  "openreports.aggregate.title": "Aggregate Reports",
  "openreports.all.test.summary.title": "Test Report Summary",
  "openreports.all.tests.aggregate": "Summary of All Tests",
  "openreports.hiv.aggregate": "HIV Test Summary",
  "openreports.management.title": "Management Reports",
  "openreports.mgt.nonconformity.date": "Non ConformityReport by Date",
  "openreports.mgt.nonconformity.section": "Non Conformity Report by Unit and Reason",
  "openreports.mgt.rejection": "Rejection Report",
  "openreports.patient.EID.version1": "EID Version 1",
  "openreports.patient.EID.version2": "EID Version 2",
  "openreports.patient.VL.version1": "VL Version Nationale",
  "openreports.patientTestStatus": "Patient Status Report",
  "openreports.patientreports.title": "Patient Status Report",
  "openreports.stat.aggregate": "Statistics Report",
  "order.accept": "Accept",
  "order.accept.error": "Failed to accept order",
  "order.additionalInfo": "Additional Information",
  "order.additionalInfo.helper": "Optional notes about this order",
  "order.clinicalInfo": "Clinical Information",
  "order.continue": "Continue",
  "order.current.time": "Current Time (hh:mm)",
  "order.dashboard.empty": "No orders found",
  "order.dashboard.title": "Order Dashboard",
  "order.department.label": "ward/dept/unit:",
  "order.diagnosis.placeholder": "Enter diagnosis or clinical notes",
  "order.entry.setup": "Batch Order Entry Setup",
  "order.external": "External",
  "order.facility": "Facility",
  "order.filter.priority": "Filter by Priority",
  "order.filter.status": "Filter by Status",
  "order.fixIssue": "Fix Issue",
  "order.form.label": "Form:",
  "order.form.select": "Select Form",
  "order.generate.barcode": "Generate Barcode and Save",
  "order.generate.barcode.history": "Previously used Accession Number",
  "order.if.other.label": "if Other specify:",
  "order.invalid.requester.name.label": "invalid requester name",
  "order.invalid.site.name": "Invalid Site name",
  "order.labNumber": "Lab Number",
  "order.labNumber.generate": "Generate Lab Number",
  "order.labNumber.helper": "Unique identifier for this order",
  "order.attachment.action.delete": "Delete attachment",
  "order.attachment.action.download": "Download attachment",
  "order.attachment.action.view": "View attachment",
  "order.attachment.column.actions": "Actions",
  "order.attachment.column.fileName": "File name",
  "order.attachment.column.fileSize": "Size",
  "order.attachment.column.fileType": "Type",
  "order.attachment.column.uploadedAt": "Uploaded at",
  "order.attachment.delete.confirm.body": "Are you sure you want to delete \"{fileName}\"? This cannot be undone.",
  "order.attachment.delete.confirm.title": "Delete attachment",
  "order.attachment.delete.failed": "Could not delete the attachment. Please try again.",
  "order.attachment.dropzone": "Drag and drop files here, or click to browse",
  "order.attachment.empty": "No attachments yet.",
  "order.attachment.error.maxFiles": "You can attach at most {maxFiles} files.",
  "order.attachment.error.size": "Each file must be {maxSize} or smaller.",
  "order.attachment.error.type": "Allowed file types: {types}",
  "order.attachment.heading": "Attachments",
  "order.attachment.hint": "Optional. Up to {maxFiles} files, 10MB each. Allowed: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "One or more attachments could not be uploaded.",
  "order.labNumber.placeholder": "Enter or generate lab number",
  "order.label.add": "Add Order",
  "order.label.modify": "Modify Order",
  "order.legend.EDTATube": "EDTA Tube",
  "order.legend.commonFields": "Common Fields",
  "order.legend.configureBarcode": "Configure Barcode Entry",
  "order.legend.dryBloodSpot": "Dry Blood Spot",
  "order.legend.dryTube": "Dry Tube",
  "order.legend.facility": "Facility",
  "order.legend.onDemand": "On Demand",
  "order.legend.optionalFields": "Optional Fields",
  "order.legend.patient": "Patient Info",
  "order.legend.preDemand": "Pre-Printed",
  "order.legend.sample": "Sample",
  "order.legend.selectMethod": "Select Method",
  "order.legend.siteName": "Site Name",
  "order.legend.specimen.collected": "Specimen Collected",
  "order.legend.tests": "Tests",
  "order.legend.viralLoadTest": "Viral Load Test",
  "order.lastUpdated": "Last Updated",
  "order.load.error": "Failed to load order",
  "order.location": "Location",
  "order.new": "New Order",
  "order.payment.status.label": "Patient payment status:",
  "order.paymentStatus": "Payment Status",
  "order.previousLabNumber": "Previous Lab Number",
  "order.previousLabNumber.placeholder": "Enter previous lab number if applicable",
  "order.printLabels": "Print Labels",
  "order.printLabels.info": "Print barcodes for this order",
  "order.priority": "Priority",
  "order.progress": "Progress",
  "order.provisionalDiagnosis": "Provisional Diagnosis",
  "order.received.time": "Received Time (hh:mm)",
  "order.reception.time": "Reception Time (hh:mm) :",
  "order.remember.site.and.requester.label": "Remember site and requester",
  "order.readonly.message": "This order is in read-only mode",
  "order.requester": "Requester",
  "order.requester.email.label": "Requester's Email:",
  "order.requester.fax.label": "Requester's Fax Number:",
  "order.requester.firstName.label": "Requester's FirstName:",
  "order.requester.lastName.label": "Requester's LastName:",
  "order.requester.phone.label": "Requester Phone:",
  "order.requester.provisionalDiagnosis.label": "Provisional Clinical Diagnosis:",
  "order.result.reporting.heading": "RESULT REPORTING",
  "order.sampleCategory": "Sample Category",
  "order.sampleCategory.helper": "Select the category of sample to collect",
  "order.sampling.performed.label": "Sampling performed for analysis:",
  "order.search.requester.label": "Search Requester",
  "order.saveStatus.error": "Save failed",
  "order.saveStatus.saved": "Saved",
  "order.saveStatus.saving": "Saving...",
  "order.saveStatus.unsaved": "Unsaved changes",
  "order.save.incomplete": "Please add a patient (or sampling site) and at least one sample type before saving.",
  "order.saved.draft": "Draft saved",
  "order.search.placeholder": "Search orders...",
  "order.search.site.name": "Search Site Name",
  "order.send.toAnalyzer": "Send to analyzer",
  "order.send.modal.title": "Send order to analyzer",
  "order.send.modal.confirm": "Send",
  "order.send.modal.cancel": "Cancel",
  "order.send.modal.analyzerLabel": "Target analyzer",
  "order.send.modal.accession": "Order accession: {accession}",
  "order.send.modal.noAnalyzers": "No analyzers are configured for LIS-initiated dispatch.",
  "order.send.success": "Order dispatched",
  "order.send.error": "Failed to dispatch order",
  "order.send.unknownError": "Unknown bridge error",
  "order.send.missingAccession": "Order has no accession number to correlate the result.",
  "order.site.name": "Site Name:",
  "order.step.collect": "Collect",
  "order.step.enter": "Enter Order",
  "order.step.label": "Label & Store",
  "order.step.patient.info": "Patient Info",
  "order.step.program.selection": "Program Selection",
  "order.step.qa": "QA Review",
  "order.start.new": "Start New Order",
  "order.submit.labNumber": "Submit with Lab Number",
  "order.submit.success": "Order submitted successfully",
  "order.submitted.success.msg": "Order has been submitted successfully",
  "order.summary.accessionNumber": "Accession Number",
  "order.summary.collectionDate": "Collection Date",
  "order.summary.patientName": "Patient Name",
  "order.summary.sampleType": "Sample Type",
  "order.summary.title": "Order Summary",
  "order.test.request.heading": "Test Request",
  "order.title": "ORDER",
  "ordertests.title": "Order Tests",
  "organization.add.placeholder": "AlphaNumeric Values",
  "organization.add.placeholder.active": "Y or N",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Parent Organization",
  "organization.add.title": "Add Organization",
  "organization.city": "City",
  "organization.clia.number": "CLIA Number",
  "organization.edit.title": "Edit Organization",
  "organization.internetaddress": "Internet Address",
  "organization.isActive": "Is Active",
  "organization.main.title": "Organization Management",
  "organization.next": "Next Page",
  "organization.organizationName": "Org Name",
  "organization.parent": "Parent Org",
  "organization.previous": "Previous Page",
  "organization.search.byorgname": "Search By Org Name",
  "organization.search.parent.name": "Parent Organization Names",
  "organization.search.placeHolder": "Search By Org Name...",
  "organization.select": "Select",
  "organization.short.CI": "Org prefix",
  "organization.streetAddress": "Street Address",
  "organization.type.CI": "Type of Activity",
  "organization.type.CI.description": "Type of Activity : Description",
  "organization.type.CI.name": "Type of Activity : Name",
  "organization.type.CI.select": "Type of Activity : Select",
  "otherMalignant.placeholder": "Other Malignant",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Back",
  "pagination.backward": "Previous Page",
  "pagination.forward": "Next Page",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} of {total} items",
  "pagination.items-per-page": "Items per page",
  "pagination.itemsPerPage": "Items per page:",
  "pagination.nextPage": "Next page",
  "pagination.page": "page {page}",
  "pagination.page-number": "Page Number",
  "pagination.page-range": "of {total} {total, plural, one {page} other {pages}}",
  "pagination.previousPage": "Previous page",
  "panel.existing": "Existing Panels",
  "panel.existing.inactive": "Inactive Panels (Assign tests to activate)",
  "panel.new": "New Panel",
  "panel.panelName": "Panel Name",
  "pathology.label.addblock": "Add Block(s)",
  "pathology.label.addslide": "Add Slide(s)",
  "pathology.label.block": "Block",
  "pathology.label.block.add.number": "Number of Blocks to add",
  "pathology.label.block.number": "Block number",
  "pathology.label.blocks": "Blocks",
  "pathology.label.casesInProgress": "Cases in Progress",
  "pathology.label.complete": "Complete",
  "pathology.label.conclusion": "Conclusion",
  "pathology.label.dashboard": "Pathology DashBoard",
  "pathology.label.grossexam": "Gross Exam",
  "pathology.label.location": "Location",
  "pathology.label.microexam": "Microscopy Exam",
  "pathology.label.printlabel": "Print Label",
  "pathology.label.refer": "Refer to ImmunoHistoChemistry",
  "pathology.label.release": "Ready For release",
  "pathology.label.report": "Pathology Report",
  "pathology.label.request": "Requests",
  "pathology.label.requests": "Additional Pathology Requests",
  "pathology.label.review": "Awaiting Pathology Review",
  "pathology.label.slide": "Slide",
  "pathology.label.slide.add.number": "Number of Slides to add",
  "pathology.label.slide.number": "slide number",
  "pathology.label.slides": "Slides",
  "pathology.label.stage": "Stage",
  "pathology.label.techniques": "Techniques Used",
  "pathology.label.textconclusion": "Text Conclusion",
  "pathology.label.title": "Pathology",
  "pathology.label.view": "View File",
  "patient.address.camp": "Camp/Commune",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "District",
  "patient.address.healthregion": "Region",
  "patient.address.province": "Province",
  "patient.address.street": "Street",
  "patient.address.town": "Town",
  "patient.age.days": "Days",
  "patient.age.months": "Months",
  "patient.age.years": "Age/Years",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Data Source Name",
  "patient.dob": "Date of Birth",
  "patient.eduction": "Education",
  "patient.emergency.additional.camp": "Enter Camp/Commune",
  "patient.emergency.additional.district": "Enter District",
  "patient.emergency.additional.education": "Enter Education",
  "patient.emergency.additional.maritalstatus": "Enter Martial Status",
  "patient.emergency.additional.nationnality": "Enter Nationality",
  "patient.emergency.additional.othernationality": "Enter Other Nationality",
  "patient.emergency.additional.region": "Enter Region",
  "patient.emergency.additional.street": "Enter Street",
  "patient.emergency.additional.town": "Enter Town",
  "patient.emergency.email": "Enter Emergency Contact Email",
  "patient.emergency.firstname": "Enter Emergency Contact First Name",
  "patient.emergency.lastname": "Enter Emergency Contact Last Name",
  "patient.emergency.phone": "Enter Emergency Contact Phone Number",
  "patient.externalId": "National ID",
  "patient.female": "Female",
  "patient.first.name": "First Name",
  "patient.gender": "Gender",
  "patient.gps.latitude": "GPS Latitude",
  "patient.gps.latitude.placeholder": "e.g., -18.879190 (range -90 to 90)",
  "patient.gps.longitude": "GPS Longitude",
  "patient.gps.longitude.placeholder": "e.g., 47.507905 (range -180 to 180)",
  "patient.id": "Patient Id",
  "patient.information.age": "Enter Age",
  "patient.information.days": "Enter Days",
  "patient.information.email": "Enter Patient Email",
  "patient.information.firstname": "Enter Patient First Name",
  "patient.information.healthid": "Enter Unique Health Identifier",
  "patient.information.lastname": "Enter Patient Last Name",
  "patient.information.months": "Enter Months",
  "patient.information.nationalid": "Enter Nationality Identifier",
  "patient.information.primaryphone": "Enter Patient Primary Number",
  "patient.label": "Patient",
  "patient.label.additionalInfo": "Additional Information",
  "patient.label.age": "Age",
  "patient.label.customNotes": "Custom Notes",
  "patient.label.diseaseProgramme": "Target Disease Programme",
  "patient.label.occupation": "Occupation",
  "patient.label.contactphone": "Contact Phone:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Patient Information",
  "patient.label.modify": "Add Or Modify Patient",
  "patient.label.name": "Name",
  "patient.label.nopatientid": "No Patient Information Available",
  "patient.label.primaryphone": "Primary phone:{PHONE_FORMAT}",
  "patient.label.sex": "Sex",
  "patient.last.name": "Last Name",
  "phone.format.international.label": "International",
  "phone.format.local.label": "Local",
  "patient.male": "Male",
  "patient.maritalstatus": "Marital Status",
  "patient.merge.activeOrders": "Active Orders",
  "patient.merge.address": "Address",
  "patient.merge.addressesDiffer": "Address differs: {primary} vs {secondary}",
  "patient.merge.auditEntries": "Audit Entries (will retain original patient)",
  "patient.merge.back": "Back",
  "patient.merge.cancelButton": "Cancel",
  "patient.merge.clinicalSummary": "Clinical Summary",
  "patient.merge.confirmButton": "Confirm Merge",
  "patient.merge.confirmCheckbox": "I understand this action cannot be undone and have verified the correct patients are being merged",
  "patient.merge.confirmMerge": "Confirm Patient Merge",
  "patient.merge.conflictNote": "(Primary patient demographics will be used)",
  "patient.merge.conflictingInfo": "Conflicting Information Detected",
  "patient.merge.contactInfo": "Contact Information",
  "patient.merge.county": "County/State",
  "patient.merge.dataToConsolidate": "Data to be Consolidated",
  "patient.merge.demographics": "Demographics",
  "patient.merge.dob": "DOB",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email differs: {primary} vs {secondary}",
  "patient.merge.error.alreadyMerged": "Patient has already been merged",
  "patient.merge.error.executionFailed": "Merge execution failed",
  "patient.merge.error.noPermission": "Only Global Administrators can merge patients",
  "patient.merge.error.patientNotFound": "Patient not found",
  "patient.merge.error.samePatient": "Cannot merge a patient with itself",
  "patient.merge.error.selectBoth": "Please select both patients to continue",
  "patient.merge.error.selectPrimary": "Please select which patient should be the primary record",
  "patient.merge.error.validationFailed": "Merge validation failed",
  "patient.merge.externalIds": "External IDs",
  "patient.merge.gender": "Gender",
  "patient.merge.identifiers": "Identifiers",
  "patient.merge.identifiersToPreserve": "Identifiers to Preserve (both patients)",
  "patient.merge.mergeSummary": "Merge Summary",
  "patient.merge.mergingFrom": "Merging From",
  "patient.merge.mergingLabel": "Merging",
  "patient.merge.name": "Name",
  "patient.merge.nationalId": "National ID",
  "patient.merge.nationalIds": "National IDs",
  "patient.merge.nextStep": "Next Step",
  "patient.merge.noIdentifiers": "No identifiers recorded",
  "patient.merge.noPatientSelected": "No patient selected",
  "patient.merge.notRecorded": "Not recorded",
  "patient.merge.orders": "Orders",
  "patient.merge.ordersCount": "{count} ({active} active)",
  "patient.merge.patientId": "Patient ID",
  "patient.merge.patientIds": "Patient IDs",
  "patient.merge.patientResults": "Patient Results",
  "patient.merge.phone": "Phone",
  "patient.merge.phonesDiffer": "Phone Numbers differ: {primary} vs {secondary}",
  "patient.merge.postalCode": "Postal Code",
  "patient.merge.primaryLabel": "Primary",
  "patient.merge.primaryPatient": "Primary Patient",
  "patient.merge.reason": "Reason for Merge (required)",
  "patient.merge.reasonPlaceholder": "Enter reason for merging these patient records...",
  "patient.merge.recordsReassigned": "{count} records reassigned",
  "patient.merge.samples": "Samples",
  "patient.merge.searchDifferent": "Search for different patient",
  "patient.merge.selectFirstPatient": "Select First Patient",
  "patient.merge.selectPrimaryDescription": "Which patient should become the primary record?",
  "patient.merge.selectPrimaryRecord": "Select Primary Patient Record",
  "patient.merge.selectSecondPatient": "Select Second Patient",
  "patient.merge.step.compare": "Select Primary",
  "patient.merge.step.confirm": "Confirm Merge",
  "patient.merge.step.select": "Select Patients",
  "patient.merge.streetAddress": "Street Address",
  "patient.merge.success": "Patient merge completed successfully",
  "patient.merge.successMessage": "Patient {mergedId} has been merged into patient {primaryId}. Audit ID: {auditId}",
  "patient.merge.testResults": "Test Results",
  "patient.merge.title": "Merge Patient Records",
  "patient.merge.totalContacts": "Contacts",
  "patient.merge.totalRelations": "Relations",
  "patient.merge.totalResults": "Total Results",
  "patient.merge.totalSamples": "Samples",
  "patient.merge.town": "Town/City",
  "patient.merge.tryDifferentSearch": "Try adjusting your search criteria or using different patient identifiers.",
  "patient.merge.warning.dataLink": "All future data will be linked to the primary patient. The non-selected patient will be marked as merged and inactive.",
  "patient.merge.warning.irreversible": "This action CANNOT be undone. All data will be permanently consolidated.",
  "patient.merge.warning.samePatient": "Same patient selected",
  "patient.merge.warning.samePatientDescription": "You have selected the same patient for both records. Please select two different patients to merge.",
  "patient.natioanalid": "National ID",
  "patient.nationalid": "National ID",
  "patient.nationality": "Nationality",
  "patient.nationality.other": "Specify Other nationality",
  "patient.photo.active.camera": "Click to activate camera",
  "patient.photo.add": "Add Photo",
  "patient.photo.browse": "Click to browse files",
  "patient.photo.camera.permission.denied": "Camera permission denied. Please check your browser settings.",
  "patient.photo.cancel": "Cancel",
  "patient.photo.capture": "Capture Photo",
  "patient.photo.captured": "Captured Photo:",
  "patient.photo.change": "Change Image",
  "patient.photo.confirm": "Confirm",
  "patient.photo.dragndrop": "Drag and drop an image here",
  "patient.photo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "patient.photo.formats": "Formats: JPG, PNG (max 2MB)",
  "patient.photo.import": "Import",
  "patient.photo.label": "Patient Photo",
  "patient.photo.modal.heading": "Select Patient Photo",
  "patient.photo.modal.options": "Image Selection Options",
  "patient.photo.preview": "Preview:",
  "patient.photo.preview.alt": "Patient photo preview",
  "patient.photo.preview.captured.alt": "Captured patient photo",
  "patient.photo.retake": "Retake",
  "patient.photo.start.camera": "Start Camera",
  "patient.photo.take": "Take Photo",
  "patient.photo.view": "View Photo",
  "patient.idDoc.title": "Identification Documents",
  "patient.idDoc.addDocument": "Add Document",
  "patient.idDoc.selectImage": "Select Image",
  "patient.idDoc.documentType": "Document Type",
  "patient.idDoc.description": "Description",
  "patient.idDoc.description.placeholder": "Enter document description",
  "patient.idDoc.category.nationalId": "National ID",
  "patient.idDoc.category.insuranceCard": "Insurance Card",
  "patient.idDoc.category.other": "Other",
  "patient.idDoc.view": "View",
  "patient.idDoc.edit": "Edit",
  "patient.idDoc.delete": "Delete",
  "patient.idDoc.remove": "Remove",
  "patient.idDoc.pending": "Unsaved",
  "patient.idDoc.empty": "No identification documents uploaded",
  "patient.idDoc.viewDocument": "View Document",
  "patient.idDoc.editDocument": "Edit Document",
  "patient.idDoc.confirmDelete": "Delete Document",
  "patient.idDoc.deleteWarning": "Are you sure you want to delete this document? This action cannot be undone.",
  "patient.idDoc.upload": "Upload",
  "patient.idDoc.dragndrop": "Drag and drop a file here",
  "patient.idDoc.browse": "or click to browse files",
  "patient.idDoc.formats": "Formats: JPEG, PNG, PDF (max 10MB)",
  "patient.idDoc.useCamera": "Use Camera",
  "patient.idDoc.pdfSelected": "PDF document selected",
  "patient.idDoc.error.invalidFormat": "Invalid file format. Accepted formats: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File is too large. Maximum size is 10MB.",
  "patient.prev.lab.no": "Previous Lab Number",
  "patient.report.associated.name": "Associated Patient Report",
  "patient.report.collection.name": "Collected ARV Patient Report",
  "patient.search.nopatient": "No patients found matching search terms",
  "patient.st.number": "ST Number",
  "patient.subject.number": "Unique Health ID number",
  "patient.yrs": "yrs",
  "patientcontact.person.email": "Contact Email",
  "patientcontact.person.firstname": "Contact first name",
  "patientcontact.person.lastname": "Contact last name",
  "placeholder.accession.number": "Enter Accession No.",
  "plugin.files": "Plugin Files",
  "plugin.name": "Plugin Name",
  "print.barcode": "Print Barcode",
  "process.testAdd.pressNext.ageRangeSelectiong": "Press Next button Age Range Selection step is not required !",
  "process.testAdd.pressNext.selectGroupDictionary": "Press Next button Selecting Group Dictionary List step is not required !",
  "program.name.label": "Program Name",
  "program.name.code": "Program Code",
  "project.ARVFollowupStudy.name": "Follow-up ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "Initial ARV",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indeterminate",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Recency Testing",
  "project.SequencingStudy.name": "Sequencing",
  "project.SpecialRequestStudy.name": "Special Request",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Add Project",
  "project.add.title": "Add Project",
  "project.browse.title": "Project",
  "project.completedDate": "Completed Date",
  "project.desc.short": "Project Descr.",
  "project.description": "Project Description",
  "project.edit.subtitle": "Edit Project",
  "project.edit.title": "Edit Project",
  "project.external.reference": "External Reference",
  "provider.browse.title": "Provider Management",
  "provider.email": "Email",
  "provider.fax": "Fax",
  "provider.isActive": "Is Active",
  "provider.modal.add.heading": "Add Provider",
  "provider.modal.update.heading": "Update Provider",
  "provider.providerFirstName": "Provider Firstname",
  "provider.providerLastName": "Provider Lastname",
  "provider.search": "Provider Search",
  "provider.search.placeholder": "Search Provider Name...",
  "provider.select": "Select Provider",
  "provider.telephone": "Telephone",
  "qa.checklist.incomplete": "QA checklist is incomplete",
  "qa.checklist.instructions": "Complete all required checks before submitting",
  "qa.checklist.samplingSiteCorrect": "Sampling site information is correct",
  "qa.checklist.title": "QA Checklist",
  "qa.summary.noSamples": "No samples to review",
  "qa.summary.noTests": "No tests selected",
  "qa.summary.order": "Order Details",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Patient Information",
  "qa.summary.samples": "Sample Summary",
  "qa.summary.samplingSite": "Sampling Site",
  "qa.summary.siteCode": "Site Code",
  "qa.summary.siteName": "Site Name",
  "qc.comments.add": "Add Comment",
  "qc.comments.empty": "No comments yet",
  "qc.comments.placeholder": "Enter QC comment...",
  "qc.comments.title": "QC Comments",
  "qc.frequency.compliance": "Compliance Metrics",
  "qc.frequency.config": "QC Frequency Configuration",
  "qc.frequency.daily": "Daily Startup",
  "qc.frequency.everyHours": "Every N Hours",
  "qc.frequency.everySamples": "Every N Samples",
  "qc.frequency.manual": "Manual Trigger Only",
  "qc.frequency.notConfigured": "Not configured",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "Save Configuration",
  "qc.frequency.type": "Frequency Type",
  "qc.frequency.value": "Frequency Value",
  "qc.leveyJennings.mean": "Mean",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "No QC data available",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Levey-Jennings Control Chart",
  "qc.notes": "QC Notes",
  "qc.notes.placeholder": "Enter QC notes and observations",
  "qc.signature.comment": "Comment (optional)",
  "qc.signature.comment.placeholder": "Add a comment...",
  "qc.signature.ipAddress": "IP Address",
  "qc.signature.noSignatures": "No signatures yet",
  "qc.signature.sign": "Sign Report",
  "qc.signature.signedAt": "Signed At",
  "qc.signature.success": "Report signed successfully",
  "qc.signature.title": "Electronic Signatures",
  "qc.signature.userId": "User ID",
  "qc.status": "QC Status",
  "qc.status.failed": "Failed",
  "qc.status.notRequired": "Not Required",
  "qc.status.passed": "Passed",
  "qc.status.pending": "Pending QC",
  "qc.status.select": "Select QC status",
  "qc.status.update.button": "Update QC Status",
  "qc.status.update.success": "QC status updated successfully",
  "qc.status.update.title": "Update QC Status",
  "qc.status.warning.message": "Marking this lot as 'Failed' will prevent it from being used until QC status is updated.",
  "qc.status.warning.title": "QC Failure Warning",
  "qc.westgard.noViolations": "No violations detected",
  "qc.westgard.rule.disabled": "Disabled",
  "qc.westgard.rule.enabled": "Enabled",
  "qc.westgard.rules": "Westgard Rules",
  "qc.westgard.rules.description": "Configure Westgard multi-rule QC evaluation",
  "qc.westgard.violations": "Violations",
  "quantity": "Quantity",
  "quantity.balanced": "Quantity balanced",
  "quantity.not.balanced": "Quantity not balanced",
  "quick.entry.accession.number": "Accession Number",
  "referTest.referralLabel": "Refer test to a reference lab",
  "referral.button.labSearch": "Search Referrals By Lab Number",
  "referral.button.patientSearch": "Search Patient",
  "referral.button.unitTestSearch": "Search Referrals By Unit(s) & Test(s)",
  "referral.date.end": "End Date (dd/mm/yyyy)",
  "referral.date.start": "Start Date (dd/mm/yyyy)",
  "referral.error": "No Referrals matching criteria",
  "referral.input": "Scan OR Enter Manually",
  "referral.label.institute": "Institute",
  "referral.label.reason": "Referral Reason",
  "referral.label.referredOutTests": "ReferredOutTests",
  "referral.label.sentdate": "Sent Date",
  "referral.label.testmethod": "Methods",
  "referral.label.testtoperform": "Test to Perform",
  "referral.main.button": "Search Referrals By Patient",
  "referral.matching.search": "Referred Tests Matching Search",
  "referral.out.head": "Referrals",
  "referral.out.note": "Note if searching by result date, only tests with results will appear.",
  "referral.out.request": "Results By Date / Test / Unit Date Type :",
  "referral.print.selected.patient.reports": "Print Selected Patient Reports",
  "referral.print.selected.patient.reports.selectall.button": "Select All",
  "referral.print.selected.patient.reports.selectnone.button": "Select None",
  "referral.result.labNumber": "Results By Lab Number",
  "referral.search": "Search",
  "referral.search.column.analysisId": "AnalysisId",
  "referral.search.column.referenceLab": "Reference Lab",
  "referral.search.column.resultDate": "Result Date",
  "referral.search.column.sentDate": "Sent Date",
  "referral.test": "Test(s)",
  "referral.testresult.pastnote": "Past Notes",
  "referral.units": "Unit(s)",
  "referrer.label": "referrer",
  "reflexTests": "Reflex Tests",
  "reject.action.button": "Reject",
  "reject.order.sample.notification": "You are rejecting a sample. This sample will be rejected and not appear in workplans once saved,no results can be entered for this order.",
  "remaining.quantity": "Remaining Quantity:",
  "remove.aliquot": "Remove Aliquot",
  "report.enter.labNumber.headline": "Generate a report or range of reports by Order Number / Lab Number",
  "report.enter.patient.headline": "Generate All Reports for a Client",
  "report.enter.patient.headline.description": "Search for the patient via previous lab number, Patient ID (which can be either Unique Health ID number or national ID) or other fields.",
  "report.enter.site.headline": "Generate Reports By Site",
  "report.labe.byLabNumber": "Report By Lab Number",
  "report.labe.byPatient": "Report By Patient",
  "report.labe.date": "Report By Date",
  "report.labe.site": "Report By Site",
  "report.label.site.dateType": "Date Type",
  "report.label.site.onlyResults": "Only Reports with results",
  "report.patient.site.description": "Generate reports by result date or by order date. Result date will show only reports with results.If you select only resports with results, all reports where all tests are in progress will not be generated.",
  "report.select.site": "Select Site",
  "report.select.studttype": "Select Study Type",
  "reporting.label.testName": "Reporting Test Name",
  "reports.auditTrail": "Audit Trail",
  "reports.systemAuditTrail": "System Audit Trail",
  "reports.button": "Generate Report",
  "reports.dateRange": "Date Range",
  "reports.endDate": "End Date",
  "reports.error.dateRangeRequired": "Date range is required for this report type",
  "reports.error.generationFailed": "Failed to generate report. Please try again.",
  "reports.error.invalidDateRange": "End date must be after start date",
  "reports.export": "Export",
  "reports.export.byDate": "Export By Date",
  "reports.export.byDate_routine": "Routine CSV Report",
  "reports.export.general": "General export",
  "reports.export.specific": "Viral Load Data Export",
  "reports.export.valid": "Valid",
  "reports.export.whonet": "WHONET Report",
  "reports.followupRequired.byLocation": "Follow-up Required",
  "reports.format": "Export Format",
  "reports.format.select": "Select format",
  "reports.generate.title": "Generate Inventory Report",
  "reports.generating": "Generating...",
  "reports.generation.success": "Report generated and downloaded successfully",
  "reports.groupByLocation": "Group by storage location",
  "reports.groupByType": "Group by item type",
  "reports.grouping": "Grouping Options",
  "reports.help.description": "Use these reports to analyze your inventory data:",
  "reports.help.tip1": "Use date ranges for trend analysis",
  "reports.help.tip2": "Group by type or location for better insights",
  "reports.help.tip3": "Export to Excel for further analysis",
  "reports.help.title": "Report Tips",
  "reports.includeExpired": "Include expired lots",
  "reports.includeInactive": "Include inactive items",
  "reports.info.message": "Select report type and options below. Reports may take a few moments to generate.",
  "reports.info.title": "Report Generation",
  "reports.label.cistudyexport": "General Report",
  "reports.label.indicator": "Indicator",
  "reports.label.indicator.performance": "Section Performance",
  "reports.label.referred.out": "Referred Out Tests Report",
  "reports.label.trends": "Trends",
  "reports.menu.covid": "Covid Report",
  "reports.nonConformity.byDate.report": "By Date",
  "reports.nonConformity.byLabno.report": "By Labno",
  "reports.nonConformity.bySectionReason.report": "By Unit and Reason",
  "reports.nonConformity.bySectionReason.title": "Non Conformity Report by Unit and Reason",
  "reports.nonConformity.menu": "Non Conformity Reports",
  "reports.nonConformity.notification.report": "Non-conformity notification",
  "reports.nonConformity.notification.report.instructions": "If a service is selected then any non-conformity notifications which have not yet been printed will be printed. If there are no services listed then all notifications have already been printed. Entering a laboratory number will print a notification even if it has already been printed. A service does not have to be chosen.",
  "reports.options": "Filter Options",
  "reports.patient.ARV.version1": "ARV-Version",
  "reports.patient.ARV.version1 ": "ARV-Version 1",
  "reports.patient.ARVFollowup.version1": "ARV Follow-up Version 1",
  "reports.patient.ARVFollowup.version2": "ARV Follow-up Version 2",
  "reports.patient.ARVInitial.version1": "ARV Initial Version 1",
  "reports.patient.ARVInitial.version2": "ARV Initial Version 2",
  "reports.patient.Indeterminate.location": "Indeterminate by Service",
  "reports.patient.Indeterminate.version1": "Indeterminate Version 1",
  "reports.patient.Indeterminate.version2": "Indeterminate Version 2",
  "reports.startDate": "Start Date",
  "reports.type": "Report Type",
  "reports.type.expirationForecast": "Expiration Forecast",
  "reports.type.expirationForecast.description": "Items expiring within specified date range",
  "reports.type.lotTraceability": "Lot Traceability",
  "reports.type.lotTraceability.description": "Complete traceability of lot movements and usage",
  "reports.type.lowStock": "Low Stock Alert",
  "reports.type.lowStock.description": "Items currently below minimum stock level",
  "reports.type.select": "Select report type",
  "reports.type.stockLevels": "Stock Levels Report",
  "reports.type.stockLevels.description": "Current stock levels for all inventory items",
  "reports.type.transactionHistory": "Transaction History",
  "reports.type.transactionHistory.description": "All transactions within date range",
  "reports.type.usageTrends": "Usage Trends",
  "reports.type.usageTrends.description": "Usage patterns and consumption trends over time",
  "request.samesite.order": "Place same site order",
  "requester.label": "Requester",
  "required.invalidtext": "This field is required",
  "result.acceptasis.warning": "Checking this box will indicate that you accept the results unconditionally.\nExpected uses:\n1. The test has been redone and the result is the same.\n2. There is no result for the test but you do not want to cancel it.\n3. The result was changed and the technician wants to give the biologist the option to add a note during the validation step explaining the reason of the change.\nIn  either case, leave a note explaining why you are taking this action.\n",
  "result.acceptasis.trigger": "Accept",
  "result.acceptasis.reason.label": "Reason for unconditional acceptance",
  "result.acceptasis.reason.placeholder": "Required — e.g. retested twice with same result, or no result available",
  "result.acceptasis.confirm": "Confirm acceptance",
  "result.acceptasis.cancel": "Cancel",
  "result.acceptasis.committed": "Accepted",
  "result.acceptasis.undo": "Undo",
  "result.entry.error.accessionRequired": "Please enter an accession number",
  "result.entry.error.title": "Error",
  "result.entry.info.title": "Information",
  "result.entry.label": "Result Entry",
  "result.entry.noResults": "No sample found for accession number {accessionNumber}",
  "result.entry.noTestsFound": "No tests with pending results found for accession number {accessionNumber}",
  "result.entry.results.accessionNumber": "Accession Number",
  "result.entry.results.sampleCount": "Samples",
  "result.entry.results.testCount": "Tests",
  "result.entry.results.title": "Tests Pending Results",
  "result.entry.saveSuccess": "Result saved for {testName}",
  "result.entry.search.accessionLabel": "Accession Number",
  "result.entry.search.accessionPlaceholder": "Enter accession number...",
  "result.entry.search.button": "Search",
  "result.entry.search.searching": "Searching...",
  "result.entry.search.title": "Search by Accession Number",
  "result.entry.success.title": "Success",
  "result.entry.table.action": "Action",
  "result.entry.table.header.sampleId": "Sample ID",
  "result.entry.table.header.sampleType": "Sample Type",
  "result.entry.table.header.testCount": "Tests",
  "result.entry.table.noSamples": "No samples with tests found",
  "result.entry.table.noTests": "No tests for this sample",
  "result.entry.table.result": "Result",
  "result.entry.table.resultPlaceholder": "Enter result",
  "result.entry.table.save": "Save",
  "result.entry.table.saving": "Saving...",
  "result.entry.table.status": "Status",
  "result.entry.table.testName": "Test Name",
  "result.entry.table.testsTitle": "Tests ({count})",
  "result.entry.title": "Result Entry",
  "result.noTestsFound": "No appropriate tests were found.",
  "result.nonconforming.item": "Sample or order is nonconforming OR test has been rejected",
  "result.outOfValidRange.msg": "The value you entered (red field) is outside the range of allowable values for that record. Please check the value",
  "result.reject.warning": "Rejecting the result will permanently delete test results \nThe results will no longer be available.",
  "result.report.queue.size": "Queue Size :",
  "result.search.noresult": "No results found",
  "resultreporting.browse.title": "Result Reporting Configuration",
  "resultreporting.config.url": "URL for site to which the results will be sent. For example http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Refer test to a reference lab",
  "routine.reports": "Routine Reports",
  "rulebuilder.error.invalidNumeric": "Invalid Numeric Value",
  "rulebuilder.error.invalidTest": "Invalid Test",
  "rulebuilder.label.add.externaltrigger": "Add External `triggered by` message",
  "rulebuilder.label.add.internaltrigger": "Add Internal `triggered by` message",
  "rulebuilder.label.addAction": "Add Action",
  "rulebuilder.label.addCondition": "Add Condition",
  "rulebuilder.label.addExternalNote": "Add External Note",
  "rulebuilder.label.addInternalNote": "Add Internal Note",
  "rulebuilder.label.addPopup": "Add Pop Up",
  "rulebuilder.label.addRule": "Add Rule",
  "rulebuilder.label.addRuleConditions": "Add Reflex Rule Conditions",
  "rulebuilder.label.confirmDelete": "Are you sure you want to deactivate this Rule?",
  "rulebuilder.label.dictValue": "Dictionaly Value",
  "rulebuilder.label.noSuggestions": "No suggestions available",
  "rulebuilder.label.numericValue": "Numeric value",
  "rulebuilder.label.numericValue2": "Numeric value 2",
  "rulebuilder.label.overallOptions": "Over All Option",
  "rulebuilder.label.perfomActions": "Perform the following actions",
  "rulebuilder.label.relation": "Relation",
  "rulebuilder.label.removeAction": "Remove Action",
  "rulebuilder.label.removeCondition": "Remove Condition",
  "rulebuilder.label.removeRule": "Deactivate Rule",
  "rulebuilder.label.rule": "Rule",
  "rulebuilder.label.ruleDetails": "View Rule",
  "rulebuilder.label.ruleName": "Rule Name",
  "rulebuilder.label.searchTest": "Search Test",
  "rulebuilder.label.selectSample": "Select Sample",
  "rulebuilder.label.textValue": "Text value",
  "rulebuilder.label.toggleRule": "Activate / Deactivate",
  "sample.accession.number": "Sample Accession",
  "sample.add.action": "Add Sample",
  "sample.collection.date": "Collection Date",
  "sample.collection.method": "Collection Method",
  "sample.collection.method.placeholder": "e.g., venipuncture, capillary, tubing",
  "sample.collection.time": "Collection Time",
  "sample.currentDate": "Current Date",
  "sample.specimen.origin": "Specimen Origin (referent lab)",
  "sample.specimen.origin.placeholder": "Referring laboratory name",
  "sample.temperature": "Sample Temperature",
  "sample.temperature.placeholder": "e.g., room temp, iced, refrigerated",
  "sample.entry.available.tests": "Available Tests",
  "sample.entry.nextVisit.date": "Date of next visit",
  "sample.entry.panels": "Panels",
  "sample.entry.project.patient.and.testName": "Name/Code of patient {br} Test Name",
  "sample.entry.project.testName": "Test Name",
  "sample.entry.search.barcode": "Print Barcodes for Existing Orders",
  "sample.id": "Sample ID",
  "sample.item.info": "Sample Information",
  "sample.items.for.accession": "Sample items for accession number:",
  "sample.label.accessionNumber": "Accession Number",
  "sample.label.collectionDate": "Collection Date",
  "sample.label.dept": "Ward/Dept/Unit",
  "sample.label.facility": "Referring Facility",
  "sample.label.labnumber": "Lab Number",
  "sample.label.labnumber.generate": "Generate",
  "sample.label.labnumber.new": "New Lab Number",
  "sample.label.noorder": "Order Doesn't Exist",
  "sample.label.orderdate": "Order Date",
  "sample.label.orderpanel": "Order Panels",
  "sample.label.requester": "Requester",
  "sample.label.search.Order": "Search Order",
  "sample.label.search.labnumber": "Search By Accession Number",
  "sample.label.search.patient": "Search By Patient",
  "sample.label.typeOfSample": "Sample Type",
  "sample.label.types": "Sample Types",
  "sample.management.action.clearSelection": "Clear Selection",
  "sample.management.action.createAliquot": "Create Aliquot",
  "sample.management.action.selectAllAliquots": "Select All Aliquots",
  "sample.management.action.selectAllParents": "Select All Parents",
  "sample.management.addTests.button": "Add Tests",
  "sample.management.addTests.error.addFailed": "Failed to add tests. Please try again.",
  "sample.management.addTests.error.loadSampleTypes": "Error loading sample types",
  "sample.management.addTests.error.loadTests": "Error loading available tests",
  "sample.management.addTests.error.noEligibleSamples": "Cannot add tests: all selected samples have been fully dispensed",
  "sample.management.addTests.error.noTests": "Please select at least one test",
  "sample.management.addTests.modal.add": "Add Tests",
  "sample.management.addTests.modal.addCount": "Add {count} Test(s)",
  "sample.management.addTests.modal.adding": "Adding...",
  "sample.management.addTests.modal.aliquotsIncluded": "aliquot(s) included",
  "sample.management.addTests.modal.bulkAliquotNote": "Tests will be added to all selected samples including aliquots.",
  "sample.management.addTests.modal.cancel": "Cancel",
  "sample.management.addTests.modal.noEligibleSamples": "No Eligible Samples",
  "sample.management.addTests.modal.noTestsAvailable": "No tests available for this sample type.",
  "sample.management.addTests.modal.noTestsSelected": "No tests selected",
  "sample.management.addTests.modal.panels": "Panels",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Search tests...",
  "sample.management.addTests.modal.selectSampleType": "Sample Type",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Please select a sample type to view available panels and tests.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Select a sample type...",
  "sample.management.addTests.modal.selectTests": "Select Tests",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Search and select tests...",
  "sample.management.addTests.modal.selectedTests": "Selected Tests",
  "sample.management.addTests.modal.subtitle": "Add tests to {count} selected sample(s)",
  "sample.management.addTests.modal.tests": "Tests",
  "sample.management.addTests.modal.title": "Add Tests to Sample",
  "sample.management.addTests.resultItem": "{sampleId}: {added} added",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} added, {skipped} skipped",
  "sample.management.addTests.success": "{count} test(s) added successfully",
  "sample.management.addTests.successDetailed": "{count} test(s) added to {samples} sample(s): {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} test(s) added to {samples} sample(s), {skipped} skipped: {details}",
  "sample.management.addTests.successWithSkipped": "{added} test(s) added, {skipped} skipped (already ordered)",
  "sample.management.addTests.title": "Add Tests",
  "sample.management.addTests.warning.dispensedSamples": "{count} sample(s) have no remaining volume and will be skipped. Tests will be added to {eligible} eligible sample(s).",
  "sample.management.addTests.warning.dispensedSamples.title": "Dispensed Samples Excluded",
  "sample.management.aliquot.error.createFailed": "Failed to create aliquot. Please try again.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Number of aliquots must be between 1 and 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Requested quantity ({requested}) exceeds remaining quantity ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Quantity per aliquot ({quantityPerAliquot}) would be less than minimum (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Quantity must be greater than 0",
  "sample.management.aliquot.error.quantityRequired": "Quantity is required",
  "sample.management.aliquot.error.title": "Error",
  "sample.management.aliquot.modal.cancel": "Cancel",
  "sample.management.aliquot.modal.create": "Create Aliquot",
  "sample.management.aliquot.modal.createMultiple": "Create {count} Aliquots",
  "sample.management.aliquot.modal.creating": "Creating...",
  "sample.management.aliquot.modal.notesLabel": "Notes (Optional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Add any notes about this aliquot...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Enter how many equal-volume aliquots to create (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Number of Aliquots",
  "sample.management.aliquot.modal.parentInfo": "Parent Sample Information",
  "sample.management.aliquot.modal.preview": "Preview",
  "sample.management.aliquot.modal.previewText": "Creating {count} aliquots with {quantityEach} {unit} each",
  "sample.management.aliquot.modal.quantityHelper": "Enter the quantity to transfer in {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Quantity to Transfer",
  "sample.management.aliquot.modal.quantityPlaceholder": "Enter quantity",
  "sample.management.aliquot.modal.subtitle": "Create aliquot from sample {externalId}",
  "sample.management.aliquot.modal.title": "Create Aliquot",
  "sample.management.aliquot.modal.totalQuantityHelper": "Enter the total quantity to divide among all aliquots in {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Total Quantity to Transfer",
  "sample.management.aliquot.success": "Aliquot {externalId} created successfully. Please search again to see the updated results.",
  "sample.management.aliquot.successMultiple": "{count} aliquots created successfully ({externalIds}). Please search again to see the updated results.",
  "sample.management.breadcrumb.title": "Sample Management",
  "sample.management.cancelTest.error": "Failed to cancel test. Please try again.",
  "sample.management.cancelTest.success": "Test \"{testName}\" cancelled successfully",
  "sample.management.description": "Search and manage sample items, create aliquots, and add tests",
  "sample.management.error.title": "Error",
  "sample.management.hierarchy.aliquotOf": "Aliquot of {parent}",
  "sample.management.hierarchy.aliquots": "aliquots",
  "sample.management.noResults.subtitle": "No sample items found for accession number: {accessionNumber}",
  "sample.management.noResults.title": "No Results Found",
  "sample.management.results.accessionNumber": "Accession Number",
  "sample.management.results.aliquots": "aliquots",
  "sample.management.results.aliquotsSelected": "aliquots",
  "sample.management.results.item": "item",
  "sample.management.results.items": "items",
  "sample.management.results.selected": "Selected",
  "sample.management.results.title": "Sample Items",
  "sample.management.results.totalCount": "Total Samples",
  "sample.management.search.error.general": "Error loading sample results. Please try again.",
  "sample.management.search.label": "Search Samples",
  "sample.management.search.loading": "Searching...",
  "sample.management.search.placeholder": "Enter accession number to search...",
  "sample.management.search.title": "Search Samples",
  "sample.management.status.allVolumeDispensed": "All Volume Dispensed",
  "sample.management.status.available": "Available",
  "sample.management.status.consumed": "Consumed",
  "sample.management.status.inUse": "In Use",
  "sample.management.status.unknown": "Unknown",
  "sample.management.success.title": "Success",
  "sample.management.table.cancelTest": "Cancel Test",
  "sample.management.table.cancelling": "Cancelling...",
  "sample.management.table.header.externalId": "Sample ID",
  "sample.management.table.header.hierarchy": "Hierarchy",
  "sample.management.table.header.originalQuantity": "Original Quantity",
  "sample.management.table.header.quantity": "Original Quantity",
  "sample.management.table.header.remainingQuantity": "Remaining Quantity",
  "sample.management.table.header.sampleType": "Sample Type",
  "sample.management.table.header.status": "Status",
  "sample.management.table.header.tests": "Tests",
  "sample.management.table.noResults": "No sample items to display. Use the search above to find samples.",
  "sample.management.table.noTests": "No tests ordered for this sample",
  "sample.management.table.orderedDate": "Ordered",
  "sample.management.table.orderedTests": "Ordered Tests ({count})",
  "sample.management.title": "Sample Management",
  "sample.panel.label.text": "Search Available panel",
  "sample.panel.placeholder": "Choose Available panel",
  "sample.panel.search.error.msg": "No panel found matching",
  "sample.quantity.label": "Quantity",
  "sample.receivedDate": "Received Date",
  "sample.reject.label": "Reject Sample",
  "sample.remove.action": "Remove Sample",
  "sample.requestDate": "Request Date",
  "sample.search.nosample": "No sample found for the provided accession number.",
  "sample.search.panel.legend.text": "Search through the available panels",
  "sample.search.scanner.instructions": "Scan or Enter Manually. For a single report, leave the box at the right empty",
  "sample.search.scanner.instructions.highaccession": "For a single report, leave the box at the right empty",
  "sample.search.scanner.instructions2": "Scan or Enter Manually.",
  "sample.search.title": "Search Sample",
  "sample.select.type": "Select sample type",
  "sample.type": "Sample Type",
  "sample.type.and.test.sort.order": "Sample type and test sort order",
  "sample.uom.label": "Sample Unit Of Measure",
  "sample.voided.title": "Sample is voided",
  "sampleManagement.actions": "Actions",
  "sampleManagement.addTests.button": "Add Tests",
  "sampleManagement.addTests.cancel": "Cancel",
  "sampleManagement.addTests.duplicate": "Test already ordered for {sampleId}",
  "sampleManagement.addTests.error": "Error adding tests",
  "sampleManagement.addTests.incompatible": "Test not compatible with sample type ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Select sample(s) to add tests",
  "sampleManagement.addTests.selectTests": "Select test(s) to add",
  "sampleManagement.addTests.skipped": "Skipped {count} duplicate(s)",
  "sampleManagement.addTests.submit": "Add Tests",
  "sampleManagement.addTests.success": "{count} test(s) added successfully",
  "sampleManagement.addTests.title": "Add Tests to Samples",
  "sampleManagement.aliquot.button": "Create Aliquot",
  "sampleManagement.aliquot.cancel": "Cancel",
  "sampleManagement.aliquot.error": "Error creating aliquot",
  "sampleManagement.aliquot.error.concurrentModification": "Another user modified this sample. Please refresh and try again.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Cannot aliquot: requested {requested} exceeds remaining {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "All volume dispensed: no remaining quantity available for aliquoting",
  "sampleManagement.aliquot.notes": "Notes (optional)",
  "sampleManagement.aliquot.notesPlaceholder": "Add notes about this aliquot...",
  "sampleManagement.aliquot.parentExternalId": "Parent External ID",
  "sampleManagement.aliquot.parentLabel": "Parent Sample",
  "sampleManagement.aliquot.quantityPlaceholder": "Enter quantity...",
  "sampleManagement.aliquot.quantityToTransfer": "Quantity to Transfer",
  "sampleManagement.aliquot.remainingQuantity": "Remaining Quantity",
  "sampleManagement.aliquot.submit": "Create Aliquot",
  "sampleManagement.aliquot.success": "Aliquot {externalId} created successfully",
  "sampleManagement.aliquot.title": "Create Aliquot",
  "sampleManagement.aliquot.unit": "Unit",
  "sampleManagement.aliquot.validation.exceeds": "Quantity exceeds remaining quantity",
  "sampleManagement.aliquot.validation.min": "Quantity must be at least 0.001",
  "sampleManagement.aliquot.validation.required": "Quantity to transfer is required",
  "sampleManagement.clearSelection": "Clear selection",
  "sampleManagement.hierarchy.children": "Aliquots:",
  "sampleManagement.hierarchy.collapse": "Collapse hierarchy",
  "sampleManagement.hierarchy.expand": "Expand hierarchy",
  "sampleManagement.hierarchy.level": "Level {level}",
  "sampleManagement.hierarchy.parent": "Parent:",
  "sampleManagement.notification.refreshResults": "Results have been refreshed",
  "sampleManagement.results.children": "Aliquots",
  "sampleManagement.results.collectionDate": "Collection Date",
  "sampleManagement.results.count": "{count} sample(s) found",
  "sampleManagement.results.externalId": "External ID",
  "sampleManagement.results.originalQuantity": "Original Quantity",
  "sampleManagement.results.parent": "Parent",
  "sampleManagement.results.remainingQuantity": "Remaining Quantity",
  "sampleManagement.results.sampleType": "Sample Type",
  "sampleManagement.results.status": "Status",
  "sampleManagement.results.tests": "Tests",
  "sampleManagement.results.title": "Search Results",
  "sampleManagement.search.button": "Search",
  "sampleManagement.search.error": "Error searching for samples",
  "sampleManagement.search.label": "Search by Accession Number",
  "sampleManagement.search.loading": "Searching...",
  "sampleManagement.search.noResults": "No samples found with this accession number",
  "sampleManagement.search.placeholder": "Enter accession number...",
  "sampleManagement.selectSamples": "Select sample(s)",
  "sampleManagement.selectedCount": "{count} selected",
  "sampleManagement.test.name": "Test Name",
  "sampleManagement.test.orderedDate": "Ordered Date",
  "sampleManagement.test.status": "Status",
  "sampleManagement.test.status.CANCELLED": "Cancelled",
  "sampleManagement.test.status.COMPLETED": "Completed",
  "sampleManagement.test.status.IN_PROGRESS": "In Progress",
  "sampleManagement.test.status.ORDERED": "Ordered",
  "sampleManagement.title": "Sample Management",
  "sampleManagement.validation.accessionNumberRequired": "Accession number is required",
  "sampleManagement.validation.parentSampleRequired": "Parent sample item is required",
  "sampleManagement.validation.samplesRequired": "At least one sample must be selected",
  "sampleManagement.validation.testsRequired": "At least one test must be selected",
  "sampleType.existing": "Existing Sample Types",
  "sampleType.existing.inactive": "Inactive Sample Types.  Assign tests to activate.",
  "sampleType.new": "New Sample Type",
  "sampleType.typeName": "Sample Type Name",
  "save.aliquot.changes": "Save Aliquot Changes",
  "save.config.success.msg": "Configuration Updated Succesfully",
  "save.order.success.msg": "Sample Order Entry has been saved successfully",
  "save.success": "Successfully saved",
  "saving": "Saving...",
  "search.by.dictionary.entry": "Search By Dictionary Entry",
  "search.label": "Search",
  "search.label.accession": "Enter Accession Number",
  "search.label.analysis": "Select Analysis Status",
  "search.label.collectiondate": "Enter Collection Date",
  "search.label.fromaccession": "From Accession Number",
  "search.label.loadnext": "Load Next 99 Records Starting at Lab Number",
  "search.label.receiveddate": "Enter Received Date",
  "search.label.sample": "Select Sample Status",
  "search.label.test": "Select Test Name",
  "search.label.testdate": "Enter Test Date",
  "search.label.testunit": "Select Test Unit",
  "search.label.toaccession": "To Accession Number",
  "search.patient.label": "Search for Patient",
  "search.placeholder": "Search...",
  "searchTests.label": "Search Available Test",
  "searchTests.legend": "Search through the available tests",
  "searchindexmanagement.description": "The search index updates automatically when data is added or modified. If you need to manually update the search index, click the Start Reindexing button. This may take some time.",
  "searchindexmanagement.label": "Search Index Management",
  "searchindexmanagement.reindex": "Start Reindexing",
  "searchindexmanagement.reindex.error": "Reindexing failed",
  "searchindexmanagement.reindex.success": "Reindexing completed successfully",
  "select.aliquot": "Select Aliquot",
  "select.datarange.label": "Date range is for when the referrals were made",
  "select.dateRange": "Select the Date Range for the Test Report Summary",
  "select.default.option.label": "Choose an option",
  "select.end.date.referredTests": "End Date (dd/mm/yyyy)",
  "select.labUnits": "Select the lab unit(s) you would like to create the test for, you may select as many as you would like",
  "select.label.analyser": "Select Analyzer",
  "select.priority.tests": "Select the priority of the tests you would like to show",
  "select.program": "Program",
  "select.referral.centre": "Referral Center or Laboratory",
  "select.referral.centre.is.required": " Referral center or labratory is required",
  "select.start.date.referredTests": "Start Date (dd/mm/yyyy)",
  "select.timeFrame": "Select time frames you would like to generate the reports for",
  "select.timeFrame.Note": "NOTE: all dates and times are based on reception time. EG: a test received on Jan 31 at 11:59 pm and resulted Feb 1 at 9:30am would show as out of normal hours in January",
  "select.year.report": "Select the year you would like to generate the reports for",
  "selectListRenameEntry.selectList": "Select List Rename Entry",
  "selectListRenameEntry.selectListEdit": "Select List Rename Entry Edit",
  "selectReportValues.title": "Select Report Values",
  "selectResult.title": "Select Result",
  "serial.config.active.label": "Active",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Connect",
  "serial.config.connect.error": "Error connecting serial port",
  "serial.config.connect.success": "Serial port connected successfully",
  "serial.config.create.title": "Create Serial Port Configuration",
  "serial.config.dataBits.label": "Data Bits",
  "serial.config.disconnect.button": "Disconnect",
  "serial.config.disconnect.error": "Error disconnecting serial port",
  "serial.config.disconnect.success": "Serial port disconnected successfully",
  "serial.config.edit.title": "Edit Serial Port Configuration",
  "serial.config.flowControl.label": "Flow Control",
  "serial.config.flowControl.none": "None",
  "serial.config.form.legend": "Serial Port Settings",
  "serial.config.parity.even": "Even",
  "serial.config.parity.label": "Parity",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "None",
  "serial.config.parity.odd": "Odd",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Port Name",
  "serial.config.save.error": "Error saving serial port configuration",
  "serial.config.save.success": "Serial port configuration saved successfully",
  "serial.config.status.label": "Connection Status",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "Analyzer ID is required",
  "serial.config.validation.baudRate.invalid": "Baud rate must be between 9600 and 115200",
  "serial.config.validation.dataBits.invalid": "Data bits must be 7 or 8",
  "serial.config.validation.portName.required": "Port name is required",
  "server.error.msg": "Oops, Server error please contact administrator",
  "show.aliquoting": "Show Aliquoting",
  "showing": "Showing",
  "sidenav.label.addorder": "Add Order",
  "sidenav.label.admin": "Admin",
  "sidenav.label.admin.analyzerTest": "Analyzer Test Name",
  "sidenav.label.admin.backToMainMenu": "Back to main menu",
  "sidenav.label.admin.labelPresets": "Label Presets",
  "sidenav.label.admin.commonproperties": "Application Properties",
  "sidenav.label.admin.eqaProgram": "EQA Program Management",
  "sidenav.label.admin.formEntry.menustatementconfig": "MenuStatement Configuration",
  "sidenav.label.admin.formEntry.nonconformityconfig": "NonConformity Configuration",
  "sidenav.label.admin.formEntry.patientconfig": "Patient Entry Configuration",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Printed Report Configuration",
  "sidenav.label.admin.formEntry.resultConfig": "Result Entry Configuration",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Order Entry Configuration",
  "sidenav.label.admin.formEntry.siteBranding": "Site Branding",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Site Information",
  "sidenav.label.admin.formEntry.validationconfig": "Validation Configuration",
  "sidenav.label.admin.formEntry.Workplanconfig": "WorkPlan Configuration",
  "sidenav.label.admin.labNumber": "Lab Number Management",
  "sidenav.label.admin.Listplugin": "List Plugins",
  "sidenav.label.admin.localization": "Localization",
  "sidenav.label.admin.menu": "Menu Configuration",
  "sidenav.label.admin.menu.billing": "Billing Menu Configuration",
  "sidenav.label.admin.menu.global": "Global Menu Configuration",
  "sidenav.label.admin.menu.nonconform": "Non-Conform Menu Configuration",
  "sidenav.label.admin.menu.patient": "Patient Menu Configuration",
  "sidenav.label.admin.menu.study": "Study Menu Configuration",
  "sidenav.label.admin.organizationmgt": "Organization Management",
  "sidenav.label.admin.pluginFile": "Plugin Files",
  "sidenav.label.admin.program": "Program Entry",
  "sidenav.label.admin.testmgt": "Reflex Tests Configuration",
  "sidenav.label.admin.testmgt.calculated": "Calculated Value Tests Management",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Test Catalog Editor",
  "sidenav.label.admin.testCatalog": "Test Catalog Management",
  "sidenav.label.admin.testCatalog.backToList": "← All Tests",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Select a test to edit its sections",
  "sidenav.label.admin.testCatalog.editing": "Editing: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Editing test",
  "label.testCatalog.editor": "Test Catalog Editor",
  "label.testCatalog.editor.empty": "No test selected",
  "label.testCatalog.editor.empty.helper": "Open a test from the Test Catalog list to edit it.",
  "label.testCatalog.editor.loadError": "Unable to load this test. Please try again.",
  "label.testCatalog.editor.saveAsNew": "Save as new test…",
  "label.testCatalog.editor.save.pending": "Saving is available once the section editors ship.",
  "label.testCatalog.editor.clone.pending": "Save as new test is available once the editor sections ship.",
  "label.testCatalog.section.pending": "This section's editor ships in a later milestone.",
  "label.testCatalog.section.basic-info": "Basic Info",
  "label.testCatalog.section.sample-results": "Sample & Results",
  "label.testCatalog.section.methods": "Methods",
  "label.testCatalog.section.ranges": "Ranges",
  "label.testCatalog.section.storage": "Sample Storage",
  "label.testCatalog.section.panels": "Panels",
  "label.testCatalog.section.terminology": "Terminology",
  "label.testCatalog.section.analyzers": "Analyzers",
  "label.testCatalog.section.display-order": "Display Order",
  "label.testCatalog.basicInfo.name": "Name",
  "label.testCatalog.basicInfo.name.helper": "Editing name, code and description is part of a later milestone.",
  "label.testCatalog.basicInfo.code": "Code",
  "label.testCatalog.basicInfo.description": "Description",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clinical",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Environmental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "Change test domain?",
  "label.testCatalog.basicInfo.domainModal.body": "Change this test's domain to {domain}? This affects how the test is categorized in the catalog.",
  "label.testCatalog.basicInfo.amr": "AMR surveillance test",
  "label.testCatalog.basicInfo.active": "Active",
  "label.testCatalog.basicInfo.orderable": "Orderable",
  "label.testCatalog.basicInfo.saved": "Basic info saved.",
  "label.testCatalog.sampleResults.saved": "Sample & results saved.",
  "label.testCatalog.sampleResults.empty": "No result components yet. Add one to define how this test's results are captured.",
  "label.testCatalog.sampleResults.newComponent": "(new component)",
  "label.testCatalog.sampleResults.code": "Component code",
  "label.testCatalog.sampleResults.label": "Component label",
  "label.testCatalog.sampleResults.resultType": "Result type",
  "label.testCatalog.sampleResults.resultType.N": "Numeric",
  "label.testCatalog.sampleResults.resultType.D": "Select list (dictionary)",
  "label.testCatalog.sampleResults.resultType.R": "Free text",
  "label.testCatalog.sampleResults.displayOrder": "Display order",
  "label.testCatalog.sampleResults.uom": "Unit of measure",
  "label.testCatalog.sampleResults.uom.none": "(none)",
  "label.testCatalog.sampleResults.significantDigits": "Significant digits",
  "label.testCatalog.sampleResults.defaultResult": "Default result",
  "label.testCatalog.sampleResults.allowMultiple": "Allow multiple readings",
  "label.testCatalog.sampleResults.options": "Select-list options",
  "label.testCatalog.sampleResults.option.value": "Value",
  "label.testCatalog.sampleResults.option.sortOrder": "Sort order",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.addOption": "Add option",
  "label.testCatalog.sampleResults.removeOption": "Remove option",
  "label.testCatalog.sampleResults.interpretations": "Interpretations",
  "label.testCatalog.sampleResults.interp.valueMatch": "Value match",
  "label.testCatalog.sampleResults.interp.text": "Interpretation",
  "label.testCatalog.sampleResults.interp.severity": "Severity",
  "label.testCatalog.sampleResults.addInterpretation": "Add interpretation",
  "label.testCatalog.sampleResults.removeInterpretation": "Remove interpretation",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Abnormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Critical",
  "label.testCatalog.sampleResults.actions": "Actions",
  "label.testCatalog.sampleResults.addComponent": "Add component",
  "label.testCatalog.sampleResults.removeComponent": "Remove component",
  "label.testCatalog.sampleResults.moveUp": "Move component up",
  "label.testCatalog.sampleResults.moveDown": "Move component down",
  "label.testCatalog.sampleResults.copyFrom": "Copy configuration from test",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Select a test…",
  "label.testCatalog.sampleResults.copyFromButton": "Copy from test",
  "label.testCatalog.sampleResults.copied": "Configuration copied.",
  "label.testCatalog.ranges.activated": "Test activated.",
  "label.testCatalog.ranges.ackModal.title": "Activate with coverage gaps?",
  "label.testCatalog.ranges.ackModal.confirm": "Acknowledge and activate",
  "label.testCatalog.ranges.ackModal.warning": "This test has reference-range coverage gaps.",
  "label.testCatalog.ranges.ackModal.body": "The following age windows have no reference range — results there cannot be flagged against a range. Acknowledge to activate anyway.",
  "label.testCatalog.ranges.male": "Male",
  "label.testCatalog.ranges.female": "Female",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "days",
  "label.testCatalog.ranges.months": "months",
  "label.testCatalog.ranges.years": "years",
  "label.testCatalog.ranges.both": "Both",
  "label.testCatalog.ranges.add": "Add range",
  "label.testCatalog.ranges.empty": "No reference ranges defined yet.",
  "label.testCatalog.ranges.saved": "Reference ranges saved.",
  "label.testCatalog.ranges.loadError": "Could not load reference ranges.",
  "label.testCatalog.ranges.col.sex": "Sex",
  "label.testCatalog.ranges.col.age": "Age range",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Critical",
  "label.testCatalog.ranges.col.actions": "Actions",
  "label.testCatalog.ranges.anyAge": "Any age",
  "label.testCatalog.ranges.coverage.title": "Coverage validation",
  "label.testCatalog.ranges.coverage.gapsHeading": "Uncovered age windows:",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Fully covered",
  "label.testCatalog.ranges.coverage.status.GAP": "Has gaps",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Has overlaps",
  "label.testCatalog.ranges.coverage.status.EMPTY": "No ranges",
  "label.testCatalog.ranges.modal.titleAdd": "Add reference range",
  "label.testCatalog.ranges.modal.titleEdit": "Edit reference range",
  "label.testCatalog.ranges.modal.sex": "Applies to",
  "label.testCatalog.ranges.modal.ageUnit": "Age unit",
  "label.testCatalog.ranges.modal.minAge": "From age",
  "label.testCatalog.ranges.modal.maxAge": "To age (blank = no upper bound)",
  "label.testCatalog.ranges.modal.lowNormal": "Normal low",
  "label.testCatalog.ranges.modal.highNormal": "Normal high",
  "label.testCatalog.ranges.modal.lowCritical": "Critical low",
  "label.testCatalog.ranges.modal.highCritical": "Critical high",
  "label.testCatalog.ranges.modal.ageError": "“To age” must be greater than “From age”.",
  "label.testCatalog.storage.saved": "Sample storage saved.",
  "label.testCatalog.storage.loadError": "Could not load sample storage settings.",
  "label.testCatalog.storage.storageHeading": "Storage",
  "label.testCatalog.storage.disposalHeading": "Disposal",
  "label.testCatalog.storage.handlingHeading": "Special handling",
  "label.testCatalog.storage.condition": "Storage condition",
  "label.testCatalog.storage.conditionCustom": "Custom condition",
  "label.testCatalog.storage.duration": "Maximum storage duration",
  "label.testCatalog.storage.durationUnit": "Duration unit",
  "label.testCatalog.storage.stabilityNotes": "Stability notes",
  "label.testCatalog.storage.protectFromLight": "Protect from light",
  "label.testCatalog.storage.doNotFreeze": "Do not freeze",
  "label.testCatalog.storage.doNotRefrigerate": "Do not refrigerate",
  "label.testCatalog.storage.disposalMethod": "Disposal method",
  "label.testCatalog.storage.disposalTimeframe": "Disposal timeframe",
  "label.testCatalog.storage.disposalUnit": "Timeframe unit",
  "label.testCatalog.storage.specialInstructions": "Special instructions",
  "label.testCatalog.storage.overrideRestricted": "Restrict storage-duration override",
  "label.testCatalog.storage.none": "— none —",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerated (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Frozen (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Deep frozen (−70°C)",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient / room temperature",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineration",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Biohazard waste",
  "label.testCatalog.storage.disposal.STANDARD": "Standard waste",
  "label.testCatalog.storage.unit.hours": "hours",
  "label.testCatalog.storage.unit.days": "days",
  "label.testCatalog.storage.unit.weeks": "weeks",
  "label.testCatalog.storage.unit.months": "months",
  "label.testCatalog.analyzers.infoCard": "Analyzers are linked to this test on the analyzer configuration screen. This list is read-only.",
  "label.testCatalog.analyzers.empty": "No analyzers are mapped to this test yet.",
  "label.testCatalog.analyzers.loadError": "Could not load analyzers for this test.",
  "label.testCatalog.analyzers.col.analyzer": "Analyzer",
  "label.testCatalog.analyzers.col.testName": "Analyzer test name",
  "label.testCatalog.displayOrder.pickSampleType": "Sample type",
  "label.testCatalog.displayOrder.intro": "Reorder how tests appear within a sample type. Order is saved automatically.",
  "label.testCatalog.displayOrder.empty": "No tests are assigned to this sample type.",
  "label.testCatalog.displayOrder.loadError": "Could not load the display order.",
  "label.testCatalog.displayOrder.saved": "Display order saved.",
  "label.testCatalog.displayOrder.moveUp": "Move up",
  "label.testCatalog.displayOrder.moveDown": "Move down",
  "label.testCatalog.displayOrder.col.position": "Position",
  "label.testCatalog.displayOrder.col.test": "Test",
  "label.testCatalog.displayOrder.dragHandle": "Drag to reorder",
  "label.testCatalog.terminology.intro": "Map this test to standard terminology codes for interoperability.",
  "label.testCatalog.terminology.col.source": "Source",
  "label.testCatalog.terminology.col.code": "Code",
  "label.testCatalog.terminology.col.relationship": "Relationship",
  "label.testCatalog.terminology.col.actions": "Actions",
  "label.testCatalog.terminology.source": "Terminology source",
  "label.testCatalog.terminology.code": "Code",
  "label.testCatalog.terminology.relationship": "Relationship",
  "label.testCatalog.terminology.addMapping": "Add mapping",
  "label.testCatalog.terminology.remove": "Remove mapping",
  "label.testCatalog.terminology.empty": "No terminology mappings yet.",
  "label.testCatalog.terminology.loadError": "Could not load terminology mappings.",
  "label.testCatalog.terminology.saved": "Terminology mappings saved.",
  "label.testCatalog.terminology.rel.none": "— none —",
  "label.testCatalog.terminology.rel.SAME_AS": "Same as",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Broader than",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Narrower than",
  "label.testCatalog.panels.intro": "Manage which panels this test belongs to, and its position within each.",
  "label.testCatalog.panels.addToPanel": "Add to panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Position",
  "label.testCatalog.panels.col.actions": "Actions",
  "label.testCatalog.panels.position": "Position",
  "label.testCatalog.panels.remove": "Remove from panel",
  "label.testCatalog.panels.empty": "This test is not in any panel yet.",
  "label.testCatalog.panels.loadError": "Could not load panel memberships.",
  "label.testCatalog.panels.saved": "Panel memberships saved.",
  "label.testCatalog.panels.createPanel": "Create new panel",
  "label.testCatalog.panels.createPanelHint": "New panels are created in Master Lists → Panel Management, where their sample type and ordering modules are configured.",
  "label.search": "Search",
  "label.testCatalog.list": "Test Catalog",
  "label.testCatalog.list.search": "Search by test name",
  "label.testCatalog.list.col.status": "Status",
  "label.testCatalog.list.filter.allDomains": "All domains",
  "label.testCatalog.list.filter.allStatus": "All statuses",
  "label.testCatalog.list.filter.inactive": "Inactive",
  "label.testCatalog.list.coverageIncomplete": "Coverage incomplete",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Any",
  "label.testCatalog.list.filter.amrOnly": "AMR only",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.error": "Couldn't load the test catalog. Adjust the filters or reload to try again.",
  "label.testCatalog.list.empty": "No tests match the current filters.",
  "sidenav.label.admin.testmgt.ManageMethod": "Manage Method",
  "sidenav.label.admin.testmgt.reflex": "Reflex Tests  Management",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "View Test Catalog",
  "sidenav.label.admin.usermgt": "User Management",
  "sideNav.label.arvfollowup1": "ARV Follow-up Version 1",
  "sideNav.label.arvfollowup2": "ARV Follow-up Version 2",
  "sideNav.label.arvreports1": "ARV Initial Version 1",
  "sideNav.label.arvreports2": "ARV Initial Version 2",
  "sideNav.label.arvversion1": "ARV-Version 1",
  "sideNav.label.associatedpatientreport": "Associated Patient Report",
  "sideNav.label.audittrail": "Audit Trail",
  "sidenav.label.barcode": "Barcode",
  "sidenav.label.batchorder": "Batch Order Entry",
  "sideNav.label.bypaneltype": "By Panel Type",
  "sideNav.label.bytesttype": "By Test Type",
  "sideNav.label.byunit": "By Unit",
  "sideNav.label.collectedarvpatientreports": "Collected ARV patient Report",
  "sidenav.label.cytology": "Cytology",
  "sidenav.label.cytology.dashboard": "Dashboard",
  "sideNav.label.delayedvalidation": "Delayed Validation",
  "sidenav.label.editorder": "Edit Order",
  "sideNav.label.eidreports1": "EID Version 1",
  "sideNav.label.eidreports2": "EID Version 2",
  "sideNav.label.exportcsvfile": "Export Routine CSV file",
  "sideNav.label.followuprequired": "Follow-up Required",
  "sideNav.label.generalreport": "General Report",
  "sideNav.label.hivtestsummary": "HIV Test Summary",
  "sidenav.label.immunochem": "Immunohistochemistry",
  "sidenav.label.immunochem.dashboard": "Dashboard",
  "sidenav.label.incomingorder": "Electronic Orders",
  "sideNav.label.intermediatebyservice": "Intermediate By Service",
  "sideNav.label.intermediatereport1": "Intermediate Version 1",
  "sideNav.label.intermediatereport2": "Intermediate Version 2",
  "sidenav.label.inventory": "Inventory",
  "sidenav.label.inventory.management": "Inventory Management",
  "sidenav.label.inventory.management.tooltip": "Manage inventory items, lots, and stock levels",
  "sidenav.label.inventory.tooltip": "Inventory management for reagents, kits, and supplies",
  "sideNav.label.noncomformitynotification": "Non-conformity Notification",
  "sideNav.label.noncomformityreportsbydate": "By Date",
  "sideNav.label.noncomformityreportsbylabno": "By Lab No",
  "sideNav.label.noncomformityreportsbyunit": "By Unit and Reason",
  "sidenav.label.notebook": "NoteBook",
  "sidenav.label.add.order": "Add Order",
  "sidenav.label.clinical.order": "Add Clinical Order",
  "sidenav.label.environmental.order": "Add Environmental Order",
  "sidenav.label.vector.order": "Add Vector Order",
  "sidenav.label.order": "Order",
  "sidenav.label.order.collect": "Collect Sample",
  "sidenav.label.order.dashboard": "Dashboard",
  "sidenav.label.order.enter": "Enter Order",
  "sidenav.label.order.label": "Label & Store",
  "sidenav.label.order.qa": "QA Review",
  "sidenav.label.pathology": "Pathology",
  "sidenav.label.pathology.dashboard": "Dashboard",
  "sideNav.label.referredtestreport": "Referred Out Tests Report",
  "sideNav.label.rejectionreport": "Rejection Report",
  "sidenav.label.reports": "Reports",
  "sidenav.label.reports.routine": "Routine",
  "sidenav.label.reports.study": "Study",
  "sidenav.label.results": "Results",
  "sidenav.label.results.byrange": "By Range of Lab numbers",
  "sidenav.label.results.order": "By Order",
  "sidenav.label.results.patient": "By Patient",
  "sidenav.label.results.testdate": "By Test Date",
  "sidenav.label.results.unit": "By Unit",
  "sideNav.label.sectionperformance": "Section Performance",
  "sideNav.label.specialrequest": "Special Request ",
  "sidenav.label.statisticsreport": "Statistics Report",
  "sidenav.label.statusreport": "Patient Status Report",
  "sidenav.label.storage.coldstorage": "Cold Storage Monitoring",
  "sidenav.label.storage.coldstorage.tooltip": "Monitor temperature and humidity of freezers and refrigerators",
  "sidenav.label.storage.management": "Storage Management",
  "sidenav.label.storage.management.tooltip": "Manage storage locations and devices",
  "sidenav.label.testsummary": "Summary of All Tests",
  "sidenav.label.validation": "Validation",
  "sidenav.label.validation.order": "Search By Order",
  "sidenav.label.validation.routine": "Routine",
  "sidenav.label.validation.study": "Study",
  "sidenav.label.validation.testdate": "Search By Test Date",
  "sideNav.label.viralloaddataexport": "Viral Load Data Export",
  "sideNav.label.vlversionnational": "VL version Nationale",
  "sidenav.label.workplan": "Workplan",
  "sidenav.label.workplan.panel": "By Panel Type",
  "sidenav.label.workplan.priority": "By Priority",
  "sidenav.label.workplan.test": "By Test Type",
  "sidenav.label.workplan.unit": "By Unit",
  "sideNav.title.activityreport": "Activity Report",
  "sidenav.title.aggregatereport": "Aggregate Reports",
  "sideNav.title.arvreports": "ARV Reports",
  "sideNav.title.associatedpatientreport": "Associated Patient Report",
  "sideNav.title.audittrail": "Audit Trail",
  "sideNav.title.collectedarvpatientreports": "Collected ARV patient Report",
  "sideNav.title.delayedvalidation": "Delayed Validation",
  "sideNav.title.eidreports": "EID Reports",
  "sideNav.title.exportbydate": "Export By Date",
  "sideNav.title.exportcsvfile": "Export Routine CSV file",
  "sideNav.title.indicator": "Indicator",
  "sideNav.title.intermediatereport": "Intermediate Report",
  "sideNav.title.noncomformityreports": "Non conformity Reports",
  "sideNav.title.referredtestreport": "Referred Out Tests Report",
  "sideNav.title.rejectionreport": "Rejection Report",
  "sideNav.title.specialrequest": "Special Request ",
  "sideNav.title.tatreport": "Turn Around Time",
  "sideNav.title.vlreport": "VL Report",
  "sideNav.label.audittrail.orderEvents": "Order Events",
  "sideNav.label.audittrail.systemEvents": "System Events",
  "sidenav.title.statusreport": "Patient Status Report",
  "systemAudit.filter.startDate": "Start Date",
  "systemAudit.filter.endDate": "End Date",
  "systemAudit.filter.entityType": "Entity Type",
  "systemAudit.filter.action": "Action",
  "systemAudit.filter.search": "Search",
  "systemAudit.filter.export": "Export CSV",
  "systemAudit.table.heading.time": "Time",
  "systemAudit.table.heading.entityType": "Entity Type",
  "systemAudit.table.heading.entityId": "Entity ID",
  "systemAudit.table.heading.action": "Action",
  "systemAudit.table.heading.user": "User",
  "systemAudit.table.heading.changes": "Changes",
  "systemAudit.noResults": "No system events found for the given filters.",
  "systemAudit.filter.all": "All",
  "systemAudit.filter.user": "User",
  "systemAudit.filter.searchText": "Search",
  "systemAudit.filter.searchText.placeholder": "Search by entity ID...",
  "systemAudit.filter.exportPdf": "Export PDF",
  "systemAudit.filter.selectedPatient": "Selected Patient",
  "systemAudit.filter.selectedPatient.none": "None",
  "systemAudit.filter.selectPatient": "Select Patient",
  "systemAudit.filter.selectAnotherPatient": "Select Another Patient",
  "systemAudit.action.insert": "Insert",
  "systemAudit.action.update": "Update",
  "systemAudit.action.delete": "Delete",
  "site.branding.cancel": "Cancel",
  "site.branding.color.format.error": "Invalid color format. Please use a valid CSS color (e.g., #0f62fe)",
  "site.branding.color.hex.label": "Hex Color Code",
  "site.branding.colorPicker.helperText": "Enter any CSS color (e.g., #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe or blue",
  "site.branding.confirm.remove": "Remove Logo",
  "site.branding.confirm.remove.message": "Are you sure you want to remove this logo and revert to the default OpenELIS logo?",
  "site.branding.current.logo": "Current Logo",
  "site.branding.description": "Customize your organization's visual branding including logos and colors",
  "site.branding.error.remove": "Error removing logo file.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Icon displayed in browser tabs and bookmarks",
  "site.branding.file.format.error": "Unsupported file format. Please use PNG, SVG, or JPG/JPEG",
  "site.branding.file.pending": "File selected - click Save Changes to upload",
  "site.branding.file.size.error": "File size exceeds 2MB limit",
  "site.branding.formats": "Formats: PNG, SVG, JPG (max 2MB)",
  "site.branding.header.color": "Header Color",
  "site.branding.header.color.description": "Background color for the application header bar",
  "site.branding.header.logo": "Header Logo",
  "site.branding.header.logo.description": "Logo displayed in the top-left of the application header",
  "site.branding.login.logo": "Login Page Logo",
  "site.branding.login.logo.description": "Logo displayed on the login page",
  "site.branding.login.using.header.logo": "Using header logo for login page",
  "site.branding.logo.upload.success": "Logo uploaded successfully",
  "site.branding.no.logo": "No custom logo (using default)",
  "site.branding.preview": "Preview",
  "site.branding.primary.color": "Primary Color",
  "site.branding.primary.color.description": "Color for primary buttons, active menu items, and links",
  "site.branding.remove.favicon": "Remove Favicon",
  "site.branding.remove.header.logo": "Remove Header Logo",
  "site.branding.remove.login.logo": "Remove Login Logo",
  "site.branding.remove.logo": "Remove Logo",
  "site.branding.reset.confirmation": "Are you sure you want to reset all branding to OpenELIS defaults? This will remove all custom logos and colors.",
  "site.branding.reset.error": "Error resetting branding to defaults.",
  "site.branding.reset.success": "Branding reset to default values successfully.",
  "site.branding.reset.to.defaults": "Reset to Default Branding",
  "site.branding.save": "Save Changes",
  "site.branding.save.error": "Error saving branding configuration",
  "site.branding.save.success": "Branding configuration saved successfully",
  "site.branding.secondary.color": "Secondary Color",
  "site.branding.secondary.color.description": "Color for secondary buttons, borders, and inactive states",
  "site.branding.section.colors": "Colors",
  "site.branding.section.logos": "Logos",
  "site.branding.title": "Site Branding",
  "site.branding.unsaved.changes": "You have unsaved changes. Do you want to save, discard, or cancel?",
  "site.branding.unsaved.changes.warning": "You have unsaved changes. Click Save to apply them.",
  "site.branding.upload.favicon": "Upload Favicon",
  "site.branding.upload.header.logo": "Upload Header Logo",
  "site.branding.upload.login.logo": "Upload Login Logo",
  "site.branding.upload.logo": "Upload Logo",
  "site.branding.use.header.logo.for.login": "Use same logo as header",
  "siteInfo.description.default.barcode": "Indicate the default number of bar code labels which should be printed with every order and specimen.",
  "siteInfo.description.dimensions": "Indicate the dimensions that bar code labels should conform to when printing.",
  "siteInfo.description.elements": "Check the box next to the optional elements that should appear on theorder and sample bar code labels.",
  "siteInfo.description.max.barcode": "Indicate the maximum number of bar code labels that can be printed for each order or specimen. Once the maximum has been reached, a user will be unable to print additional labels.",
  "siteInfo.elements.mandatory": "Mandatory Elements",
  "siteInfo.elements.optional": "Optional Elements",
  "siteInfo.section.altAccession": "Preprinted Bar Code Accession number",
  "siteInfo.section.elements": "Bar Code Label Elements",
  "siteInfo.section.number": "Number Bar Code Label",
  "siteInfo.section.size": "Dimensions Bar Code Label",
  "siteInfo.title.default.barcode": "Default Bar Code Labels",
  "siteInfo.title.default.barcode.block": "Block",
  "siteInfo.title.default.barcode.height": "Height",
  "siteInfo.title.default.barcode.order": "Order",
  "siteInfo.title.default.barcode.order.none": "None",
  "siteInfo.title.default.barcode.slide": "Slide",
  "siteInfo.title.default.barcode.specimen": "Specimen",
  "siteInfo.title.default.barcode.freezer": "Freezer",
  "siteInfo.title.default.barcode.width": "Width",
  "siteInfo.title.max.barcode": "Maximum Bar Code Labels",
  "started.date": "Started Date",
  "status": "Status",
  "status.in.progress": "In Progress",
  "status.unknown": "Unknown",
  "stillThere.message": "User session is about to time out. Click anywhere to stay logged in.",
  "stillThere.title": "Still There?",
  "stock.available": "Available",
  "stock.level": "Stock Level",
  "stock.status": "Stock Status",
  "stock.status.expired": "Expired",
  "stock.status.expiring": "Expiring",
  "stock.status.inStock": "In Stock",
  "stock.status.lowStock": "Low Stock",
  "stock.status.outOfStock": "Out of Stock",
  "storage.active": "Active",
  "storage.add.device": "Add Device",
  "storage.add.location": "Location",
  "storage.add.location.option": "Add Location...",
  "storage.add.new.device": "Add new device",
  "storage.add.rack": "Add Rack",
  "storage.add.box": "Add Box",
  "storage.add.room": "Add Room",
  "storage.add.shelf": "Add Shelf",
  "storage.allAssigned.title": "All Samples Assigned",
  "storage.assign.button": "Assign Location",
  "storage.assign.title": "Assign Storage Location",
  "storage.assigned": "Assigned",
  "storage.assigned.by": "Assigned By",
  "storage.assigned.date": "Assigned Date",
  "storage.barcode.scan.placeholder": "Scan barcode or enter manually",
  "storage.bulk.move.auto.assigned": "Auto-assigned positions (editable)",
  "storage.bulk.move.preview": "Bulk Move Preview",
  "storage.cannotDelete.hasAssignments": "Cannot delete {entityType} '{name}': has {count} assigned sample(s)",
  "storage.cannotDelete.hasChildren": "Cannot delete {entityType} '{name}': contains {count} {childType}(s)",
  "storage.capacity.calculated": "Calculated",
  "storage.capacity.manual": "Manual Limit",
  "storage.capacity.undetermined.tooltip": "Capacity cannot be calculated: some child locations lack defined capacities",
  "storage.capacity.warning": "{location} is {percentage}% full. Consider using alternative storage.",
  "storage.code.change.acknowledge": "I understand and want to proceed with the code change",
  "storage.code.change.warning": "Warning",
  "storage.code.change.warning.message": "Changing the code will invalidate any previously printed labels for this location.",
  "storage.confirm.add.device": "Do you want to create a new device '{name}'?",
  "storage.conditionNotes": "Condition Notes",
  "storage.conditionNotes.placeholder": "Enter any notes about storage conditions...",
  "storage.confirm.delete": "Confirm Delete",
  "storage.create.room.error": "Failed to create room: {error}",
  "storage.create.room.success": "Room \"{name}\" created successfully",
  "storage.current.location": "Current Location",
  "storage.currentLocation": "Current Location",
  "storage.delete.admin.only": "Only Global Administrators can delete locations",
  "storage.delete.are.you.sure": "Are you sure you want to delete",
  "storage.delete.cannot.be.undone": "This action cannot be undone.",
  "storage.delete.cascade.confirm": "Confirm Cascade Delete",
  "storage.delete.cascade.confirmation.checkbox": "I confirm that I want to delete this location and all its child locations. All samples will be unassigned. This action cannot be undone.",
  "storage.delete.cascade.summary": "This will delete {childCount} {childType}(s) and unassign {sampleCount} sample(s). Are you sure you want to proceed?",
  "storage.delete.cascade.warning": "Cascade Delete Warning",
  "storage.delete.checking": "Checking constraints...",
  "storage.delete.confirmation.checkbox": "I confirm that I want to delete this location. This action cannot be undone.",
  "storage.delete.constraints.title": "Cannot Delete",
  "storage.delete.device": "Delete Device",
  "storage.delete.error": "Failed to delete location",
  "storage.delete.location": "Delete Location",
  "storage.delete.rack": "Delete Rack",
  "storage.delete.room": "Delete Room",
  "storage.delete.shelf": "Delete Shelf",
  "storage.device.code": "Code",
  "storage.device.communicationProtocol": "Communication Protocol",
  "storage.device.communicationProtocol.helper": "Protocol used for device communication (e.g., BACnet)",
  "storage.device.ipAddress": "IP Address",
  "storage.device.ipAddress.helper": "IPv4 or IPv6 address for network-connected equipment",
  "storage.device.label": "Device",
  "storage.device.name": "Name",
  "storage.device.placeholder": "Select or type to create device...",
  "storage.device.port": "Port",
  "storage.device.port.helper": "Port number (1-65535) for communication",
  "storage.device.room": "Room",
  "storage.device.type": "Type",
  "storage.edit.device": "Edit Device",
  "storage.edit.error.loadLocation": "Failed to load location",
  "storage.edit.error.saveFailed": "Save failed",
  "storage.edit.error.saveHttp": "Save failed (HTTP {status})",
  "storage.edit.rack": "Edit Rack",
  "storage.edit.room": "Edit Room",
  "storage.edit.shelf": "Edit Shelf",
  "storage.edit.selectParent": "Select {parent}",
  "storage.editbox.error.loadBox": "Failed to load box",
  "storage.editbox.selectRack": "Select rack",
  "storage.box.capacity": "Capacity",
  "storage.box.rows": "Rows",
  "storage.box.columns": "Columns",
  "storage.box.preset": "Dimension preset",
  "storage.box.preset.select": "Select dimensions",
  "storage.error.location.inactive": "Cannot assign to inactive location",
  "storage.error.name.duplicate": "A {entityType} with this name already exists in the selected parent location",
  "storage.error.position.occupied": "Position is already occupied",
  "storage.expanded.capacityLimit": "Capacity Limit",
  "storage.expanded.createdBy": "Created By",
  "storage.expanded.createdDate": "Created Date",
  "storage.expanded.description": "Description",
  "storage.expanded.lastModifiedBy": "Last Modified By",
  "storage.expanded.lastModifiedDate": "Last Modified Date",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Position Schema Hint",
  "storage.expanded.temperatureSetting": "Temperature Setting",
  "storage.filter.by.locations": "Filter by locations",
  "storage.filter.by.locations.placeholder": "Filter by locations...",
  "storage.filter.device": "Filter by Device",
  "storage.filter.room": "Filter by Room",
  "storage.filter.status": "Filter by Status",
  "storage.hierarchical.path": "Location Path",
  "storage.inline.add.device": "Add New Device",
  "storage.inline.add.rack": "Add New Rack",
  "storage.inline.add.room": "Add New Room",
  "storage.inline.add.shelf": "Add New Shelf",
  "storage.location": "Location",
  "storage.location.active": "Active",
  "storage.location.current": "Storage location",
  "storage.location.code": "Code",
  "storage.location.code.helper": "Max 10 characters, alphanumeric with hyphens/underscores",
  "storage.location.description": "Description",
  "storage.location.label": "Storage Location",
  "storage.location.name": "Location Name",
  "storage.location.unassigned": "Unassigned",
  "storage.manageLocation.error.saveFailed": "Save failed",
  "storage.manageLocation.error.selectTarget": "Select a device, shelf, rack, or box before saving",
  "storage.nav.device": "Device",
  "storage.nav.room": "Room",
  "storage.nav.shelf": "Shelf",
  "storage.picker.backToSearch": "Back to search",
  "storage.picker.createNewLocation": "Create new location",
  "storage.picker.currentLocation": "Current location",
  "storage.picker.heading.assignLocation": "Assign Storage Location",
  "storage.picker.heading.moveSample": "Move Sample",
  "storage.picker.newLocation": "New location",
  "storage.picker.notes": "Notes",
  "storage.picker.position.optional": "Position (optional)",
  "storage.picker.select": "Select {level}",
  "storage.picker.addNewLevel": "Add new {level}",
  "storage.picker.inlineCreate.heading": "Create new {level}",
  "storage.picker.inlineCreate.error.title": "Could not create location",
  "storage.picker.inlineCreate.error": "Failed to create location",
  "storage.picker.sample.accession": "Accession",
  "storage.picker.sample.heading": "Sample",
  "storage.picker.sample.status": "Status",
  "storage.picker.sample.type": "Type",
  "storage.picker.storageLocation": "Storage location",
  "storage.metrics.active": "Active",
  "storage.metrics.disposed": "Disposed",
  "storage.metrics.storage.locations": "Storage Locations",
  "storage.metrics.total.samples": "Total Sample Items",
  "storage.mode.autocomplete": "Type-Ahead Search",
  "storage.mode.barcode": "Barcode Scan",
  "storage.mode.cascading": "Cascading Dropdowns",
  "storage.move.button": "Move Sample",
  "storage.move.reason.label": "Reason for Move",
  "storage.nav.boxes": "Boxes",
  "storage.nav.boxes.tooltip": "Manage storage boxes",
  "storage.nav.dashboard": "Storage Dashboard",
  "storage.nav.devices": "Devices",
  "storage.nav.devices.tooltip": "Manage storage devices",
  "storage.nav.locations": "Locations",
  "storage.nav.locations.tooltip": "Manage storage locations",
  "storage.nav.racks": "Racks",
  "storage.nav.racks.tooltip": "Manage storage racks",
  "storage.nav.rooms": "Rooms",
  "storage.nav.rooms.tooltip": "Manage storage rooms",
  "storage.nav.sample.items": "Sample Items",
  "storage.nav.sample.items.tooltip": "View and manage stored samples",
  "storage.nav.samples": "Sample Items",
  "storage.nav.samples.tooltip": "View and manage stored samples",
  "storage.nav.shelves": "Shelves",
  "storage.nav.shelves.tooltip": "Manage storage shelves",
  "storage.no.data": "No data available",
  "storage.occupancy": "Occupancy",
  "storage.position.label": "Position",
  "storage.rack.device": "Device",
  "storage.rack.dimensions": "Dimensions",
  "storage.rack.label": "Rack",
  "storage.rack.placeholder": "Select or type to create rack...",
  "storage.rack.room": "Room",
  "storage.rack.shelf": "Shelf",
  "storage.room.code": "Code",
  "storage.room.devices": "Devices",
  "storage.room.label": "Room",
  "storage.room.name": "Name",
  "storage.room.placeholder": "Select or type to create room...",
  "storage.room.samples": "Samples",
  "storage.sampleitem.id": "SampleItem ID",
  "storage.search.devices.placeholder": "Search by device name or code...",
  "storage.search.placeholder": "Search by sample ID or location...",
  "storage.search.racks.placeholder": "Search by rack label...",
  "storage.search.rooms.placeholder": "Search by room name or code...",
  "storage.search.samples.placeholder": "Search by sample ID or location...",
  "storage.search.shelves.placeholder": "Search by shelf label...",
  "storage.select.location": "Select Location",
  "storage.selectSample": "Select Sample",
  "storage.shelf.device": "Device",
  "storage.shelf.label": "Shelf",
  "storage.shelf.placeholder": "Select or type to create shelf...",
  "storage.shelf.room": "Room",
  "storage.status": "Status",
  "storage.status.disposed": "Disposed",
  "storage.success.assigned": "Sample assigned to storage location successfully",
  "storage.success.moved": "Sample moved to new location successfully",
  "storage.tab.devices": "Devices",
  "storage.tab.racks": "Racks",
  "storage.tab.rooms": "Rooms",
  "storage.tab.samples": "Sample Items",
  "storage.tab.shelves": "Shelves",
  "storage.target.location": "Target Location",
  "storage.unassigned.title": "Unassigned Samples",
  "storage.skipAssignment": "No storage required - samples will be processed immediately",
  "success.add.edited.msg": "Successfully Added/Edited",
  "success.delete.msg": "Succesfuly Deleted",
  "success.import.patient": "Patient Succesfully Imported",
  "success.report.status": "Succesfuly Generated Report",
  "success.save.msg": "Successfullly saved",
  "success.save.patient": "Patient Saved Successfully",
  "systemuser.firstName": "System User First Name",
  "systemuser.isActive": "Is Active",
  "systemuser.lastName": "System User Last Name",
  "systemuser.loginName": "System User Login Name",
  "systemuser.role": "Roles",
  "systemuserrole.apply": "Apply",
  "systemuserrole.copypermissions": "Copy Permisions From User",
  "systemuserrole.copypermissions.placeholder": "Copy Users Permisions",
  "systemuserrole.instruction.1": "There are two types of Roles. Global Roles which are set for the entire application and Lab Unit Roles which can be set for all Lab Units or specific Lab Units.",
  "systemuserrole.instruction.2": "The available Global Roles are: GLobal Administrator (Acces to all Admin Functions) ,Audit Trail (Access to all Audit Trail), User Account Administrator (has acces to all the user account administration features ,but not any other admin functions).",
  "systemuserrole.instruction.3": "The Lab Unit Roles are: Reception (Access to the Order, Patient, and Non-Conformity Tabs) ,Results (Access to the Work Plan, Non-Conformity, and Results Tabs) ,Validation (Access to the Validation and Non-Conformity Tabs), Reports (Acces to Reports Tab except CSV export only Availbale for Global Administrators).",
  "systemuserrole.instruction.4": "To assign Lab Unit Roles ,select all lab units or the specific lab unit from the drop down and select any roles you would like to set.",
  "systemuserrole.instruction.5": "You can also use the Copy Permisions Feature to copy the permisions of an existing user.Ensure that you have filled all the information above and enter the user name whose permissions you want to copy into the box and click apply.",
  "systemuserrole.newpermissions": "Add New Permission",
  "systemuserrole.rmpermissions": "Remove Permission",
  "systemuserrole.roles.global": "Global Roles",
  "systemuserrole.roles.labunit": "Lab Unit Roles",
  "test.add.copy.name": "Copy from Test Name",
  "test.antimicrobialResistance": "Antimicrobial Resistance",
  "test.description.active": "If the test is active it can be ordered on the order form or as part of a test algorithm.If it is not active it can not be ordered or be part of a test algorithm",
  "test.description.name": "The name of the test as it will appear within openELIS. Both English and French are required",
  "test.description.orderable": "If a test is active and orderable then it can be ordered on an order form. If it is active but not orderable then it will only be done if it is reflexed from another test",
  "test.description.panel": "If this test is part of a test panel then the panel can be added here.It is possible, but not usual, for a test to be in more then one panel",
  "test.description.reportName": "The name of the test as it will appear in reports. Both English and French are required.If the Name and reporting name are the same click on the button to copy the name",
  "test.description.testSection": "The test section in which the test will be done",
  "test.description.uom": "Unit of measure for the test. This usually only applies to numeric or alphanumeric result types",
  "test.field.active": "Active",
  "test.field.orderable": "Orderable",
  "test.inLabOnly": "In Lab Only",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Please Select Test to Modify!",
  "test.modify.header.test": "Test",
  "test.name": "Test Name",
  "test.notifyResults": "Notify Patient Of Results",
  "test.section": "Test Section",
  "test.section.label": "Test Section",
  "test.show.guide": "Show Guide",
  "testcalculation.label.calculation": "Calculation",
  "testcalculation.label.finalresult": "Final Result",
  "testcalculation.label.insertOperation": "Insert Operation",
  "testcalculation.label.integer": "Integer",
  "testcalculation.label.mathFucntion": "Mathematical Function",
  "testcalculation.label.name": "Calculation Name",
  "testcalculation.label.patientAttribute": "Patient Attribute",
  "testcalculation.label.searchNumericTest": "Search Numeric Test",
  "testcalculation.label.selectDictionaryValue": "Select Dictionary Value",
  "testcalculation.label.testResult": "Test Result",
  "testcalculation.label.textValue": "Text Value",
  "testCatalog.header.ageRange": "Age Range",
  "testCatalog.header.criticalRange": "Critical Range",
  "testCatalog.header.field": "Field",
  "testCatalog.header.gender": "Gender",
  "testCatalog.header.normalRange": "Normal Range",
  "testCatalog.header.reportingRange": "Reporting Range",
  "testCatalog.header.validRange": "Valid Range",
  "testCatalog.header.value": "Value",
  "admin.testCatalog.methods.title": "Methods",
  "admin.testCatalog.methods.column.name": "Method Name",
  "admin.testCatalog.methods.column.code": "Code",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Effective Date",
  "admin.testCatalog.methods.column.actions": "Actions",
  "admin.testCatalog.methods.action.edit": "Edit",
  "admin.testCatalog.methods.action.remove": "Remove",
  "admin.testCatalog.methods.btn.linkMethod": "+ Link Method",
  "admin.testCatalog.methods.btn.createMethod": "+ Create New Method",
  "admin.testCatalog.methods.btn.copyFromTest": "Copy from Test",
  "admin.testCatalog.methods.modal.link.title": "Link Method",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Select a method to link",
  "admin.testCatalog.methods.modal.link.noAvailable": "All active methods are already linked",
  "admin.testCatalog.methods.inline.nameEnglish": "Method Name (English)",
  "admin.testCatalog.methods.inline.nameFrench": "Method Name (French)",
  "admin.testCatalog.methods.inline.code": "Shortcode",
  "admin.testCatalog.methods.inline.codeHint": "3–10 uppercase alphanumeric characters, no spaces",
  "admin.testCatalog.methods.inline.createAndLink": "Create & Link",
  "admin.testCatalog.methods.copyFromTest.label": "Copy methods from test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Select source test",
  "admin.testCatalog.methods.effectiveDate.label": "Effective Date",
  "admin.testCatalog.methods.default.label": "Set as default",
  "admin.testCatalog.methods.error.duplicateLink": "This method is already linked to the test",
  "admin.testCatalog.methods.error.codeFormat": "Code must be 3–10 uppercase alphanumeric characters with no spaces",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Effective date is required",
  "admin.testCatalog.methods.empty": "No methods linked. Use '+ Link Method' or '+ Create New Method' to add one.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Name of the test this is for",
  "testnotification.instructionis.variables.body.0": "[testResult] : Result of the test",
  "testnotification.instructionis.variables.body.1": "[patientFirstName] : Patient's first name ",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial] : Patient's last name's initial",
  "testnotification.instructionis.variables.header": "List of variables:",
  "testnotification.instructions.body": "When a notification is created, it will first check if a message template is defined for the recipient/message type.",
  "testnotification.instructions.body.0": "If none exists, it will use the test default message.",
  "testnotification.instructions.body.1": "If that does not exist, it will use the system default message.",
  "testnotification.instructions.body.2": "Variables will be replaced by their corresponding values in the message body and the subject.",
  "testnotification.instructions.body.3": "Variables should always include the square brackets and should have no whitespace.",
  "testnotification.instructions.header": "Instructions:",
  "testnotification.messagetemplate": "Message",
  "testnotification.options": "Individiual Messages",
  "testnotification.patient.email": "Patient Email",
  "testnotification.patient.sms": "Patient SMS",
  "testnotification.patiententry.header": "Result Reporting",
  "testnotification.patiententry.info": "If OpenELIS is not able to connect to the recipient of the transmitted results it will queue them up. A large and growing queue is a sign that troubleshooting should be done including contacting the receiving party.",
  "testnotification.provider.email": "Provider Email",
  "testnotification.provider.sms": "Provider SMS",
  "testnotification.subjecttemplate": "Subject",
  "testnotification.systemdefault.template": "System Default Message",
  "testnotification.testdefault.editIcon": "Edit Test Notification",
  "testnotification.testdefault.template": "Default Message for Test",
  "testnotificationconfig.browse.title": "Test Notification Configuration",
  "tests.not.assigned": "Tests not assigned",
  "testsection.testSectionName": "Test Section Name",
  "testUnit.existing": "Existing Test Units",
  "testUnit.existing.inactive": "Inactive Test Units.  Assign tests to activate.",
  "testUnit.new": "New Unit Test",
  "text.length.max": "Text length Should not be greater than 200",
  "title.notestfoundmatching": "No test Found Matching",
  "to.title": "To",
  "tooltip.banner.menu.generic.sample.results": "Enter test results for generic samples",
  "total.quantity": "Total Quantity",
  "transaction.date": "Date",
  "transaction.quantity": "Quantity",
  "transaction.type": "Type",
  "transaction.user": "User",
  "true.label": "True",
  "unifiedSystemUser.add.user": "Add User",
  "unifiedSystemUser.browser.button.add": "Add New user",
  "unifiedSystemUser.browser.search": "Search By User Names",
  "unifiedSystemUser.browser.search.placeholder": "Search By User Names...",
  "unifiedSystemUser.browser.title": "User Management",
  "unifiedSystemUser.edit.user": "Modify User",
  "unifiedSystemUser.select": "Select",
  "unknown.section": "Unknown Section",
  "unknown.test": "Unknown Test",
  "uom.browse.title": "Unit Of Measure",
  "uom.create.heading.confirmation": "Confirmation",
  "uom.existing": "Current Unit of Measure",
  "uom.existing.inactive": "Inactive Unit of Measure. Assign tests to this Unit of Measure to activate it.",
  "uom.new": "Create a new Unit of Measure",
  "uom.new.added": "New Unit of Measure will get added",
  "uom.notification.duplicate": "Unit of Measure already exists",
  "uom.notification.save": "New Unit Of Measure has been saved.",
  "uom.uomName": "Unit Of Measure Name",
  "training.installation.message": "Training Installation",
  "translation.edit.title": "Edit Translations",
  "translation.export": "Export CSV",
  "translation.export.success": "Translations exported successfully",
  "translation.fallback": "Fallback (English)",
  "translation.management.description": "View and edit translations for metadata.",
  "translation.management.title": "Translation Management",
  "translation.missing": "Missing",
  "translation.search": "Search translations...",
  "translation.selectLocale": "Select Language",
  "translation.showMissing": "Show Missing Only",
  "translation.stats.title": "Translation Progress",
  "translation.stats.total": "Total entries: {count}",
  "translation.update.error": "Failed to update translation",
  "translation.update.success": "Translation updated successfully",
  "translation.value": "Translation",
  "usage.analysisId": "Analysis ID",
  "usage.date": "Date Used",
  "usage.notes": "Notes",
  "usage.notes.placeholder": "Add any notes about this usage",
  "usage.quantityUsed": "Quantity Used",
  "usage.quantityUsed.helper": "Enter the number of units consumed",
  "usage.record.button": "Record Usage",
  "usage.record.success": "Usage recorded successfully",
  "usage.record.title": "Record Inventory Usage",
  "usage.testResultId": "Test Result ID (Optional)",
  "usage.testResultId.placeholder": "Link to test result for traceability",
  "user.select.instruction": "Select a User to Modify or to Deactivate . You can set a Filter ,Search for users, or Add a User along with the controls at the top.",
  "validation.accept.all": "Save All Results",
  "validation.accept.normal": "Save All Normal",
  "validation.field.required": "This field is required",
  "validation.ignore.all": "Ignore All Results",
  "validation.label.nonconform": "= Sample or Order is nonconforming or Test has been rejected",
  "validation.password.match": "Passwords must match",
  "validation.password.minLength": "Password must be at least 7 characters",
  "validation.password.notSameAsOld": "New password must not be the same as the old password",
  "validation.password.specialChar": "Password must contain at least one special character (*$#!) and one uppercase letter",
  "validation.no.records.display": "There are no records to display",
  "validation.reject.all": "Retest All Tests",
  "validation.save.error": "Results have been validated successfully",
  "validation.save.success": "Results have been validated successfully",
  "validation.search.noresult": "No Results found to be validated",
  "validation.search.noresult.analyser": "No Results found from : ",
  "vl.arvRegimen": "ARV Regimen",
  "vl.durationOnARV": "Duration on ARV (months)",
  "vl.durationOnARV.placeholder": "Enter months on treatment",
  "vl.indication": "Indication for VL Test",
  "vl.lastVLDate": "Date of Last VL Result",
  "vl.lastVLResult": "Last VL Result (copies/mL)",
  "vl.lastVLResult.placeholder": "e.g., 150",
  "vl.pregnancyStatus": "Pregnancy / Breastfeeding Status",
  "workplan.page.title": "Workplan {0}",
  "workplan.panel.selection.error.msg": "This is an invalid error message.",
  "workplan.panel.title": "Workplan By Panel",
  "workplan.panel.types": "Panel Type",
  "workplan.print": "Print Workplan",
  "workplan.priority.list": "Priority",
  "workplan.priority.title": "Workplan By Priority",
  "workplan.run": "Get Workplan",
  "workplan.test.title": "Workplan By Test",
  "workplan.test.types": "Test Type",
  "workplan.title": "Workplan",
  "workplan.unit.title": "Workplan By Unit",
  "workplan.unit.types": "Unit Type",
  "yes.option": "Yes",
  "shipment.module.title": "Shipment Management",
  "shipment.breadcrumb": "Sample Shipment",
  "shipment.nav.dashboard": "Dashboard",
  "shipment.nav.createBox": "Create Box",
  "shipment.nav.receiveBox": "Receive Box",
  "shipment.dashboard.title": "Shipment Dashboard",
  "shipment.dashboard.description": "Manage shipment boxes and track referred samples",
  "shipment.dashboard.tabs.shipments": "Shipments",
  "shipment.dashboard.tabs.unassigned": "Unassigned Tests",
  "shipment.tab.boxes": "Shipment Boxes",
  "shipment.tab.unassignedSamples": "Unassigned Samples",
  "shipment.label.boxId": "Box ID",
  "shipment.label.createdDate": "Created Date",
  "shipment.label.daysUnassigned": "Days Unassigned",
  "shipment.label.destination": "Destination",
  "shipment.label.priority": "Priority",
  "shipment.label.referralTest": "Referral Test",
  "shipment.label.sampleCount": "Sample Count",
  "shipment.label.state": "State",
  "shipment.label.tests": "Tests",
  "shipment.filter.state": "Filter by State",
  "shipment.filter.facility": "Filter by Facility",
  "shipment.action.addToBox": "Add to Box",
  "shipment.action.cancelReferral": "Cancel Referral",
  "shipment.action.confirmRejection": "Confirm Rejection",
  "shipment.action.createBox": "Create New Box",
  "shipment.action.markAsLost": "Mark as Lost",
  "shipment.action.printManifest": "Print Manifest",
  "shipment.action.rejectSample": "Reject Sample",
  "shipment.action.saveAndMarkReady": "Save & Mark Ready to Send",
  "shipment.action.saveBox": "Save Box",
  "shipment.action.saveDraft": "Save as Draft",
  "shipment.action.scanSample": "Scan Sample",
  "shipment.box.addSample": "Add Sample",
  "shipment.box.addSampleDescription": "Select samples to add to this shipping box",
  "shipment.box.addSamples": "Add Samples",
  "shipment.box.autoGenerate": "Auto-generate",
  "shipment.box.capacity": "Capacity",
  "shipment.box.capacityValue": "{capacity} samples",
  "shipment.box.create": "Create Box",
  "shipment.box.createDescription": "Create a new shipping box for referred samples",
  "shipment.box.created": "Created Date: ",
  "shipment.box.createdBy": "Created By :",
  "shipment.box.createdDate": "Created Date",
  "shipment.box.destination": "Destination",
  "shipment.box.downloadLabel": "Download Label",
  "shipment.box.downloadManifest": "Download Manifest",
  "shipment.box.generateLabel": "Generate Label",
  "shipment.box.generateManifest": "Generate Manifest",
  "shipment.box.id": "Box ID: ",
  "shipment.box.labelDownloaded": "Label downloaded successfully",
  "shipment.box.labelPrefix": "Label Prefix",
  "shipment.box.labelPrefixHelper": "Configured by administrator in Site Settings",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest downloaded successfully",
  "shipment.box.noSamples": "This box does not contain any samples yet",
  "shipment.box.noUnassignedSamples": "No unassigned samples found for this facility",
  "shipment.box.notes": "Notes",
  "shipment.box.notesPlaceholder": "Enter any special handling instructions or notes...",
  "shipment.box.number": "Box Number",
  "shipment.box.readyConfirmation": "Are you sure you want to mark this box as ready to send?",
  "shipment.box.readySampleCount": "This box contains {count} sample(s)",
  "shipment.box.readyToSend": "Mark Ready to Send",
  "shipment.box.reconcile": "Reconcile",
  "shipment.box.removeSample": "Remove Sample",
  "shipment.box.removeSampleConfirmation": "Are you sure you want to remove this sample from the box?",
  "shipment.box.resendManifest": "Resend Manifest",
  "shipment.box.sampleCount": "Sample Count",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} remaining)",
  "shipment.box.samplesAdded": "Samples Added",
  "shipment.box.samplesSelected": "{count} sample(s) selected",
  "shipment.box.scanExisting": "Scan existing",
  "shipment.box.scanExistingId": "Scan or enter existing Box ID",
  "shipment.box.scanExistingIdPlaceholder": "Scan barcode or type box ID",
  "shipment.box.sendBox": "Send Box",
  "shipment.box.sendConfirmation": "Are you sure you want to send this box?",
  "shipment.box.sendSampleCount": "This box contains {count} sample(s) that will be marked as sent",
  "shipment.box.state": "State",
  "shipment.box.summary": "Summary",
  "shipment.box.temperature": "Temperature Requirement",
  "shipment.box.title": "Box {boxId}",
  "shipment.box.useExistingId": "Box ID Mode",
  "shipment.dashboard.boxNotFound": "No box found with ID \"{boxId}\". Try filtering the list instead.",
  "shipment.dashboard.scanBoxPlaceholder": "Search or scan Box ID (press Enter to navigate)",
  "shipment.error.addSample": "Failed to add sample to box",
  "shipment.error.assignToBox": "Failed to assign sample to box",
  "shipment.error.boxFull": "Box is full. Cannot add more samples.",
  "shipment.error.boxNotEmpty": "Box must have at least one sample",
  "shipment.error.boxNotFound": "Box not found",
  "shipment.error.cancelReferral": "Failed to cancel referral",
  "shipment.error.confirmReception": "Failed to confirm reception",
  "shipment.error.createBox": "Failed to create shipping box",
  "shipment.error.exceedsCapacity": "Cannot add {requested} sample(s). Only {available} slot(s) available.",
  "shipment.error.fetchBox": "Failed to fetch box information",
  "shipment.error.fetchBoxes": "Failed to fetch available boxes",
  "shipment.error.generateLabel": "Error generating shipping label",
  "shipment.error.generateManifest": "Error generating manifest",
  "shipment.error.invalidState": "Invalid box state for this operation",
  "shipment.error.markAsLost": "Failed to mark sample as lost",
  "shipment.error.markReady": "Failed to mark box as ready to send",
  "shipment.error.noDestinationFacility": "No destination facility specified for this sample",
  "shipment.error.noReferralId": "No referral ID available for this sample",
  "shipment.error.noSampleSelected": "Please select at least one sample",
  "shipment.error.partialReception": "Some sample status updates failed. Please try again.",
  "shipment.error.reasonRequired": "Please provide a reason",
  "shipment.error.reconcile": "Error reconciling box",
  "shipment.error.removeSample": "Failed to remove sample from box",
  "shipment.error.sampleAlreadyAssigned": "This sample is already assigned to a box",
  "shipment.error.sampleAlreadyInBox": "Sample already in box",
  "shipment.error.sampleNotFound": "Sample not found",
  "shipment.error.saveFailed": "Failed to save",
  "shipment.error.searchFailed": "Failed to search for sample. Please try again.",
  "shipment.error.selectBox": "Please select a box",
  "shipment.error.sendBox": "Failed to send box",
  "shipment.filter.clear": "Clear Filters",
  "shipment.filter.dateFrom": "From Date",
  "shipment.filter.dateTo": "To Date",
  "shipment.filter.referenceLab": "Reference Lab",
  "shipment.label.addedDate": "Added Date",
  "shipment.label.position": "Position",
  "shipment.label.samples": "Samples",
  "shipment.label.shippingLabel": "SHIPPING LABEL",
  "shipment.manifest.generated": "Generated:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Manifest recall is no longer available (7-day limit exceeded since send)",
  "shipment.manifest.regenerationExpired": "Manifest regeneration is no longer available (24-hour limit exceeded since send)",
  "shipment.manifest.serviceLocation": "Service Location:",
  "shipment.manifest.specimenBarcodes": "Specimen Barcodes",
  "shipment.manifest.title": "Shipping Manifest",
  "shipment.manifest.totalSamples": "Total Samples:",
  "shipment.modal.addToBox.existingBox": "Add to existing box",
  "shipment.modal.addToBox.mode": "Select an option",
  "shipment.modal.addToBox.newBox": "Create new box",
  "shipment.modal.addToBox.newBoxInfo.message": "You will be redirected to create a new box for this sample",
  "shipment.modal.addToBox.newBoxInfo.title": "Create New Box",
  "shipment.modal.addToBox.noDraftBoxes.message": "No draft boxes found for this destination. A new box will be created.",
  "shipment.modal.addToBox.noDraftBoxes.title": "No Draft Boxes Available",
  "shipment.modal.addToBox.selectBox": "Select Box",
  "shipment.modal.addToBox.title": "Add Sample to Box",
  "shipment.modal.cancelReferral.reason": "Reason for cancellation",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Please explain why this referral is being cancelled...",
  "shipment.modal.cancelReferral.title": "Cancel Referral",
  "shipment.modal.cancelReferral.warning.message": "This action will permanently cancel the referral and cannot be undone.",
  "shipment.modal.cancelReferral.warning.title": "Warning",
  "shipment.modal.createBox.cancel": "Cancel",
  "shipment.modal.createBox.submit": "Create",
  "shipment.modal.createBox.title": "Create New Box",
  "shipment.modal.markAsLost.reason": "Reason for marking as lost",
  "shipment.modal.markAsLost.reasonPlaceholder": "Please explain why this sample is being marked as lost...",
  "shipment.modal.markAsLost.title": "Mark Sample as Lost",
  "shipment.modal.markAsLost.warning.message": "This action will permanently mark the sample as lost and cannot be undone.",
  "shipment.modal.markAsLost.warning.title": "Warning",
  "shipment.modal.rejectSample": "Reject Sample",
  "shipment.modal.rejectSampleMessage": "Are you sure you want to reject sample {accession}?",
  "shipment.nav.reports": "Reports",
  "shipment.nav.settings": "Settings",
  "shipment.notification.boxCreated": "Box created successfully",
  "shipment.notification.boxReadyToSend": "Box marked as Ready to Send",
  "shipment.notification.boxReconciled": "Box has been reconciled successfully",
  "shipment.notification.boxSent": "Box sent successfully",
  "shipment.notification.error": "An error occurred: {message}",
  "shipment.notification.partialSamplesAdded": "Only {added} of {total} samples added. Box capacity reached ({notAdded} not added).",
  "shipment.notification.receptionComplete": "Shipment received successfully",
  "shipment.notification.referralCancelled": "Referral cancelled successfully",
  "shipment.notification.sampleAdded": "Sample {accessionNumber} added with {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sample assigned to box successfully",
  "shipment.notification.sampleMarkedAsLost": "Sample marked as lost",
  "shipment.notification.sampleRejected": "Sample {accession} rejected: {reason}",
  "shipment.notification.sampleRemoved": "Sample removed from box",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} other {# samples added to box}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sample(s) removed due to capacity reduction.",
  "shipment.reception.applyToAll": "Apply status to all...",
  "shipment.reception.confirmMessage": "Confirm reception of {count} sample(s)?",
  "shipment.reception.confirmReception": "Confirm Reception",
  "shipment.reception.damaged": "Damaged",
  "shipment.reception.description": "Scan box barcode to receive and verify samples",
  "shipment.reception.enterBoxId": "Please enter a box ID",
  "shipment.reception.generalNotes": "General Notes",
  "shipment.reception.generalNotesPlaceholder": "Enter general reception notes",
  "shipment.reception.importError": "Error importing shipments from remote server",
  "shipment.reception.importFromFhir": "Import from FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.leaked": "Leaked",
  "shipment.reception.markAllMissing": "Mark All Missing",
  "shipment.reception.markAllReceived": "Mark All Received",
  "shipment.reception.missing": "Missing",
  "shipment.reception.notes": "Notes",
  "shipment.reception.notesPlaceholder": "Enter notes if needed",
  "shipment.reception.notesRequired": "Notes are required for samples not received in good condition",
  "shipment.reception.notesRequiredPlaceholder": "Required: describe the issue",
  "shipment.reception.pending": "Pending",
  "shipment.reception.received": "Received",
  "shipment.reception.rejected": "Rejected",
  "shipment.reception.sampleNotFound": "Sample {accessionNumber} not found in this box",
  "shipment.reception.sampleScanned": "Sample {accessionNumber} checked in as received",
  "shipment.reception.sampleVerification": "Sample Verification",
  "shipment.reception.scanBox": "Box ID / Barcode",
  "shipment.reception.scanBoxPlaceholder": "Scan or enter box barcode",
  "shipment.reception.scanButton": "Scan Box",
  "shipment.reception.scanSample": "Scan Sample ID",
  "shipment.reception.scanSampleButton": "Check In Sample",
  "shipment.reception.scanSamplePlaceholder": "Scan or type sample accession number",
  "shipment.reception.status": "Reception Status",
  "shipment.reception.title": "Receive Shipment",
  "shipment.rejection.damaged": "Damaged",
  "shipment.rejection.expired": "Expired",
  "shipment.rejection.insufficientVolume": "Insufficient Volume",
  "shipment.rejection.other": "Other",
  "shipment.rejection.reason": "Rejection Reason",
  "shipment.rejection.wrongType": "Wrong Sample Type",
  "shipment.report.contents": "Contents",
  "shipment.report.description": "Generate and export shipment reports by box, date, destination, or reference lab",
  "shipment.report.export.excel": "Export Excel",
  "shipment.report.export.pdf": "Export PDF",
  "shipment.report.generate": "Generate Report",
  "shipment.report.noResults": "No shipment records found for the selected filters",
  "shipment.report.receivedDate": "Received Date",
  "shipment.report.receivedStatus": "Received Status",
  "shipment.report.receiver": "Receiver",
  "shipment.report.receivingUser": "Receiving User",
  "shipment.report.sender": "Sender",
  "shipment.report.sentDate": "Sent Date",
  "shipment.report.title": "Shipment Reports",
  "shipment.report.totalBoxes": "Total Boxes",
  "shipment.report.totalSamples": "Total Samples",
  "shipment.sample.accessionNumber": "Accession Number",
  "shipment.sample.remove": "Remove",
  "shipment.sample.search": "Search sample by accession number",
  "shipment.sample.searchPlaceholder": "Scan or enter accession number",
  "shipment.sample.status": "Status",
  "shipment.sample.type": "Sample Type",
  "shipment.settings.administration": "Administration",
  "shipment.settings.boxLabelSection": "Box Label Configuration",
  "shipment.settings.description": "Configure shipment module settings",
  "shipment.settings.fhirConfig": "FHIR Mapping Options",
  "shipment.settings.fhirConfigDesc": "Configure SupplyDelivery mapping and specimen container types for FHIR interoperability",
  "shipment.settings.fhirConfigNote": "FHIR mapping is configured via application properties. Contact your system administrator for changes.",
  "shipment.settings.fhirConfigSaveError": "Error saving FHIR mapping configuration",
  "shipment.settings.fhirConfigSaved": "FHIR mapping configuration saved",
  "shipment.settings.fhirContainerType": "Specimen Container Type (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Display Name",
  "shipment.settings.fhirNonConformity": "Non-Conformity Codes (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "SNOMED CT Code",
  "shipment.settings.manageFacilities": "Manage Facility Registry",
  "shipment.settings.manageFacilitiesDesc": "Add, edit, or remove reference laboratory destinations",
  "shipment.settings.manageUsers": "Manage Users",
  "shipment.settings.manageUsersDesc": "Configure user accounts and roles for the shipment module",
  "shipment.settings.prefixHelperText": "Prefix used when generating new box IDs (e.g. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Preview: {preview}",
  "shipment.settings.prefixRequired": "Box label prefix is required",
  "shipment.settings.prefixSaveError": "Error saving box label prefix",
  "shipment.settings.prefixSaved": "Box label prefix saved successfully",
  "shipment.settings.siteOrgDescription": "Select the organization that represents this laboratory. Only shipments destined for this organization will be imported from remote FHIR servers.",
  "shipment.settings.siteOrgLabel": "This Laboratory",
  "shipment.settings.siteOrgSaveError": "Error saving site organization",
  "workflow.clinical": "Clinical",
  "workflow.environmental": "Environmental / Other",
  "provider.name": "Provider Name",
  "provider.name.placeholder": "Enter provider name",
  "provider.phone": "Provider Phone",
  "provider.search.helper": "Enter provider name or phone number and press Search.",
  "site.search": "Site Search",
  "site.name": "Site Name",
  "site.name.placeholder": "Enter site name",
  "site.location": "Location",
  "site.type": "Type",
  "site.department": "Department / Ward / Unit",
  "site.department.selectFirst": "Select facility first...",
  "site.department.none": "No subunits available",
  "sample.filterByLabUnit": "Filter by Lab Unit",
  "sample.allLabUnits": "All Lab Units",
  "sample.orderPanels": "Order Panels",
  "sample.orderTests": "Order Tests",
  "sample.referToReferenceLab": "Refer test to a reference lab",
  "sample.optional.info": "Sample and test selection is optional at this step. Tests and sample type can be specified later during collection.",
  "panel.search.placeholder": "Choose Available panel",
  "test.search.placeholder": "Choose Available Test",
  "select.regimen": "Select Regimen...",
  "select": "Select...",
  "generating": "Generating...",
  "label.order": "Order Label",
  "label.sample": "Sample Label",
  "label.slide": "Slide Label",
  "label.block": "Block Label",
  "label.freezer": "Freezer Label",
  "environmental.coming.soon": "Environmental workflow",
  "environmental.location.info": "Location hierarchy fields (Region/District/Town-Village) and GPS capture will be available here.",
  "env.collectionConditions.title": "Default Collection Conditions",
  "env.collectionConditions.subtitle": "Defaults applied to all samples in this batch.",
  "env.collectionMethod": "Collection Method",
  "env.waterTemp": "Water Temp (°C)",
  "env.ambientTemp": "Ambient Temp (°C)",
  "env.weather": "Weather",
  "env.preservationMethod": "Preservation Method",
  "env.preservationMethod.placeholder": "e.g., HNO3 acidification, 4°C cooler",
  "env.fieldNotes": "Field Notes",
  "env.fieldNotes.placeholder": "Enter field observations...",
  "env.sample.manifest.title": "Per-Sample Manifest",
  "env.sample.manifest.subtitle": "one row = one physical sample",
  "env.sample.container": "Container",
  "env.sample.gpsLat": "GPS Lat",
  "env.sample.gpsLat.placeholder": "e.g. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "e.g. 106.8456",
  "env.sample.locationDetails": "Location Details",
  "env.sample.locationDetails.placeholder": "e.g., Inlet, Bank...",
  "env.sample.collected": "Collected",
  "env.sample.duplicate": "Duplicate sample",
  "env.sample.addRow": "+ Add sample row",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} in this batch",
  "env.sample.testsAndPanels": "Tests & Panels",
  "env.sample.tests.required": "required",
  "env.complianceStandards.title": "Applicable Compliance Standards",
  "env.complianceStandards.subtitle": "Select the regulatory standards that apply to this order.",
  "env.complianceStandards.label": "Compliance Standards",
  "env.complianceStandards.placeholder": "Select standards...",
  "env.complianceStandards.empty": "No active compliance standards configured. Add them in Administration → Compliance Standards.",
  "order.dashboard.samplingSite": "Sampling Site",
  "order.search.placeholder.env": "Search by site name or lab number...",
  "order.filter.dateFrom": "From",
  "order.filter.dateTo": "To",
  "program.placeholder": "Type to filter or select from the list",
  "program.helper": "Type to filter or select from the list. Selecting a program displays its specific Additional Order Information fields below.",
  "patient.externalSearch": "External Search",
  "patient.results": "Patient Results",
  "patient.id.placeholder": "Enter Patient Id",
  "patient.lastName.placeholder": "Enter Patient's Last Name",
  "patient.firstName.placeholder": "Enter Patient's First Name",
  "patient.natId": "Unique Health ID",
  "patient.dataSource": "Data Source",
  "patient.noResults": "0-0 of 0 items",
  "patient.new.info": "Enter new patient information below. The patient will be created when the order is saved.",
  "pagination.showing": "Showing {start}-{end} of {total} tests",
  "results.found.for": "results found for \"{term}\"",
  "selected": "Selected",
  "shipment.settings.siteOrgSaved": "Site organization saved (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Site Organization (FHIR)",
  "shipment.settings.title": "Shipment Settings",
  "shipment.state.cancelled": "Cancelled",
  "shipment.state.draft": "Draft",
  "shipment.state.inTransit": "In Transit",
  "shipment.state.lostInTransit": "Lost in Transit",
  "shipment.state.partiallyReceived": "Partially Received",
  "shipment.state.readyToSend": "Ready to Send",
  "shipment.state.received": "Received",
  "shipment.state.reconciled": "Reconciled",
  "shipment.state.sent": "Sent",
  "shipment.stats.delivered": "Delivered",
  "shipment.stats.inTransit": "In Transit",
  "shipment.stats.reconciled": "Reconciled",
  "shipment.stats.totalSamples": "Total Samples",
  "shipment.temperature.ambient": "Ambient (Room Temperature)",
  "shipment.temperature.deepFrozen": "Deep Frozen (-80°C)",
  "shipment.temperature.dryIce": "Dry Ice",
  "shipment.temperature.frozen": "Frozen (-20°C)",
  "shipment.temperature.refrigerated": "Refrigerated (2-8°C)",
  "shipment.validation.addSample": "Add at least one sample",
  "shipment.validation.selectDestination": "Select a destination facility",
  "qc.dashboard.title": "Quality Control Dashboard",
  "qc.dashboard.lastUpdate": "Last Updated",
  "qc.dashboard.complianceStatus": "Compliance Status",
  "qc.dashboard.compliant": "Compliant",
  "qc.dashboard.warning": "Warning",
  "qc.dashboard.nonCompliant": "Non-Compliant",
  "qc.dashboard.violationsCount": "{count} violations",
  "qc.dashboard.lastResult": "Last Result",
  "qc.dashboard.noInstruments": "No instruments configured",
  "qc.dashboard.subtitle": "Monitor instrument QC status and alerts",
  "qc.dashboard.loading": "Loading dashboard data...",
  "qc.dashboard.refresh": "Refresh",
  "qc.dashboard.lastUpdated": "Last Updated",
  "qc.dashboard.error.title": "Error",
  "qc.dashboard.error.loadFailed": "Failed to load dashboard data. Please try again.",
  "qc.dashboard.tab.instruments": "Instruments",
  "qc.dashboard.tab.alerts": "Alerts",
  "qc.dashboard.summary.inControl": "Instruments In Control",
  "qc.dashboard.summary.warningStatus": "Warning Status",
  "qc.dashboard.summary.outOfControl": "Out of Control",
  "qc.dashboard.summary.passRate": "Overall QC Pass Rate",
  "qc.dashboard.summary.ofTotal": "{percentage}% of total instruments",
  "qc.dashboard.instruments.title": "Instrument Quality Control Status",
  "qc.dashboard.instruments.subtitle": "Monitor compliance status and QC performance for all laboratory instruments",
  "qc.dashboard.instruments.search": "Search instruments...",
  "qc.dashboard.instruments.col.id": "Instrument ID",
  "qc.dashboard.instruments.col.name": "Instrument Name",
  "qc.dashboard.instruments.col.type": "Type",
  "qc.dashboard.instruments.col.location": "Location",
  "qc.dashboard.instruments.col.status": "Status",
  "qc.dashboard.instruments.col.analytes": "Analytes",
  "qc.dashboard.instruments.col.violations": "Recent Violations",
  "qc.dashboard.instruments.col.lastUpdate": "Last Update",
  "qc.dashboard.instruments.col.actions": "Actions",
  "qc.dashboard.instruments.view": "View",
  "qc.dashboard.instruments.status.green": "In Control",
  "qc.dashboard.instruments.status.yellow": "Warning",
  "qc.dashboard.instruments.status.red": "Out of Control",
  "qc.dashboard.instruments.noViolations": "No violations",
  "qc.dashboard.instruments.empty": "No instruments found",
  "qc.dashboard.alerts.title": "QC Violations & Alerts",
  "qc.dashboard.alerts.subtitle": "Showing violations from last {period}",
  "qc.dashboard.alerts.timePeriod": "Time Period",
  "qc.dashboard.alerts.timePeriod.24h": "Last 24 Hours",
  "qc.dashboard.alerts.timePeriod.72h": "Last 72 Hours",
  "qc.dashboard.alerts.timePeriod.7d": "Last 7 Days",
  "qc.dashboard.alerts.timePeriod.30d": "Last 30 Days",
  "qc.dashboard.alerts.timePeriod.all": "All Time",
  "qc.dashboard.alerts.active": "Active QC Violations",
  "qc.dashboard.alerts.active.count": "{count} unacknowledged violation(s) requiring attention",
  "qc.dashboard.alerts.active.empty": "No active violations",
  "qc.dashboard.alerts.acknowledge": "Acknowledge",
  "qc.dashboard.alerts.acknowledged": "Acknowledged Violations",
  "qc.dashboard.alerts.acknowledged.count": "{count} violation(s) have been acknowledged",
  "qc.dashboard.alerts.acknowledged.empty": "No acknowledged violations",
  "qc.dashboard.alerts.col.severity": "Severity",
  "qc.dashboard.alerts.col.time": "Time",
  "qc.dashboard.alerts.col.instrument": "Instrument",
  "qc.dashboard.alerts.col.analyte": "Analyte",
  "qc.dashboard.alerts.col.rule": "Rule",
  "qc.dashboard.alerts.col.acknowledgedBy": "Acknowledged By",
  "qc.dashboard.alerts.col.acknowledgedDate": "Acknowledged Date",
  "qc.chart.axis.date": "Date/Time",
  "qc.chart.axis.value": "Standard Deviations (σ)",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Violation",
  "qc.chart.mean": "Mean",
  "qc.chart.noData": "No QC data available",
  "qc.chart.tooltip.date": "Date",
  "qc.chart.tooltip.value": "Value",
  "qc.chart.tooltip.violations": "Violations",
  "qc.chart.tooltip.zScore": "Z-Score",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Levey-Jennings Chart",
  "qc.charts.dateRange": "Date Range",
  "qc.charts.controlLevel": "Control Level",
  "qc.charts.export": "Export Chart",
  "qc.charts.noData": "No QC data available",
  "qc.violations.title": "QC Violations",
  "qc.violations.severity": "Severity",
  "qc.violations.rule": "Rule",
  "qc.violations.date": "Date",
  "qc.violations.status": "Status",
  "qc.violations.unresolved": "Unresolved",
  "qc.violations.resolved": "Resolved",
  "qc.violations.acknowledged": "Acknowledged",
  "qc.correctiveActions.title": "Corrective Actions",
  "qc.correctiveActions.create": "Create Corrective Action",
  "qc.correctiveActions.type": "Action Type",
  "qc.correctiveActions.description": "Description",
  "qc.correctiveActions.assignedTo": "Assigned To",
  "qc.correctiveActions.status": "Status",
  "qc.correctiveActions.pending": "Pending",
  "qc.correctiveActions.inProgress": "In Progress",
  "qc.correctiveActions.completed": "Completed",
  "qc.correctiveActions.resolutionNotes": "Resolution Notes",
  "qc.alerts.title": "QC Alerts",
  "qc.alerts.markAsRead": "Mark as Read",
  "qc.alerts.viewDetails": "View Details",
  "qc.rules.title": "Westgard Rules Configuration",
  "qc.rules.enable": "Enable",
  "qc.rules.disable": "Disable",
  "qc.rules.preset": "Preset Configuration",
  "qc.rules.basic": "Basic",
  "qc.rules.standard": "Standard",
  "qc.rules.comprehensive": "Comprehensive",
  "qc.rules.1₂ₛ.description": "One control exceeds ±2SD",
  "qc.rules.1₃ₛ.description": "One control exceeds ±3SD",
  "qc.rules.2₂ₛ.description": "Two consecutive controls exceed ±2SD in same direction",
  "qc.rules.R₄ₛ.description": "Range between two controls exceeds 4SD",
  "qc.rules.4₁ₛ.description": "Four consecutive controls exceed ±1SD in same direction",
  "qc.rules.10ₓ.description": "Ten consecutive controls on same side of mean",
  "qc.rules.3₁ₛ.description": "Three consecutive controls exceed ±1SD in same direction",
  "qc.rules.7ₜ.description": "Seven consecutive controls trending in same direction",
  "qc.ruleConfig.title": "Rule Configuration",
  "qc.ruleConfig.subtitle": "Configure Westgard rules per analyzer and test combination",
  "qc.ruleConfig.field.analyzer": "Analyzer",
  "qc.ruleConfig.field.selectAnalyzer": "Select an analyzer",
  "qc.ruleConfig.field.test": "Test",
  "qc.ruleConfig.field.selectTest": "Select a test",
  "qc.ruleConfig.field.severity": "Severity",
  "qc.ruleConfig.severity.warning": "Warning",
  "qc.ruleConfig.severity.rejection": "Rejection",
  "qc.ruleConfig.category.rejection": "Rejection Rules",
  "qc.ruleConfig.category.warning": "Warning Rules",
  "qc.ruleConfig.action.reset": "Reset to Defaults",
  "qc.ruleConfig.loading": "Loading rule configuration...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Select an analyzer and test to configure Westgard rules.",
  "qc.ruleConfig.error.title": "Error",
  "qc.ruleConfig.error.selectAnalyzerTest": "Please select both an analyzer and a test.",
  "qc.ruleConfig.error.saveFailed": "Failed to save rule configuration.",
  "qc.ruleConfig.success.title": "Success",
  "qc.ruleConfig.success.saved": "Rule configuration saved successfully.",
  "qc.ruleConfig.table.title": "Configured Rule Sets",
  "qc.ruleConfig.table.empty": "No rule configurations found.",
  "qc.ruleConfig.field.enabledRules": "Enabled Rules",
  "qc.ruleConfig.unconfigured.title": "Unconfigured Control Mappings",
  "qc.ruleConfig.unconfigured.subtitle": "Control lots without Westgard rule configurations",
  "qc.ruleConfig.unconfigured.configure": "Configure",
  "qc.ruleConfig.unconfigured.activeLots": "Active Lots",
  "qc.ruleConfig.modal.title.edit": "Edit Rule Configuration",
  "qc.ruleConfig.modal.title.create": "Create Rule Configuration",
  "button.saving": "Saving...",
  "qc.controlLots.title": "Control Lots",
  "qc.controlLots.create": "Create Control Lot",
  "qc.controlLots.productName": "Product Name",
  "qc.controlLots.lotNumber": "Lot Number",
  "qc.controlLots.level": "Control Level",
  "qc.controlLots.statisticsMethod": "Statistics Calculation Method",
  "qc.controlLots.initialRuns": "Initial Runs",
  "qc.controlLots.rolling": "Rolling Window",
  "qc.controlLots.manufacturerFixed": "Manufacturer Fixed",
  "qc.controlLots.activationDate": "Activation Date",
  "qc.controlLots.expirationDate": "Expiration Date",
  "qc.controlLots.status.active": "Active",
  "qc.controlLots.status.establishment": "Establishment",
  "qc.controlLots.status.expired": "Expired",
  "qc.controlLots.subtitle": "Manage QC control lots for Westgard rule evaluation",
  "qc.controlLots.empty": "No control lots found",
  "qc.controlLot.filter.allStatuses": "All Statuses",
  "qc.controlLot.status.establishment": "Establishment",
  "qc.controlLot.status.active": "Active",
  "qc.controlLot.status.expired": "Expired",
  "qc.controlLot.field.lotNumber": "Lot Number",
  "qc.controlLot.field.lotNumberPlaceholder": "Enter lot number",
  "qc.controlLot.field.material": "Control Material",
  "qc.controlLot.field.materialPlaceholder": "Enter material name",
  "qc.controlLot.field.manufacturer": "Manufacturer",
  "qc.controlLot.field.level": "Control Level",
  "qc.controlLot.field.selectLevel": "Select level",
  "qc.controlLot.field.expiration": "Expiration Date",
  "qc.controlLot.field.analyzer": "Analyzer",
  "qc.controlLot.field.selectAnalyzer": "Select analyzer",
  "qc.controlLot.field.test": "Test",
  "qc.controlLot.field.selectTest": "Select test",
  "qc.controlLot.field.isActive": "Status",
  "qc.controlLot.field.inactive": "Inactive",
  "qc.controlLot.field.active": "Active",
  "qc.controlLot.field.status": "Status",
  "qc.controlLot.loading": "Loading...",
  "qc.controlLot.error.title": "Error",
  "qc.controlLot.error.saveFailed": "Failed to save control lot",
  "qc.controlLot.new.title": "New Control Lot",
  "qc.controlLot.new.subtitle": "Create a new QC control lot",
  "qc.controlLot.edit.title": "Edit Control Lot",
  "qc.controlLot.edit.subtitle": "Update control lot configuration",
  "qc.controlLot.validation.lotNumberRequired": "Lot number is required",
  "qc.controlLot.validation.materialRequired": "Material is required",
  "qc.controlLot.validation.levelRequired": "Control level is required",
  "qc.controlLot.validation.expirationRequired": "Expiration date is required",
  "qc.controlLot.validation.analyzerRequired": "Analyzer is required",
  "qc.controlLot.validation.testRequired": "Test is required",
  "qc.controlLot.level.low": "Low",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "High",
  "qc.controlLot.statistics.title": "Statistics Configuration",
  "qc.controlLot.statistics.configure": "Configure",
  "qc.controlLot.statistics.method": "Calculation Method",
  "qc.controlLot.statistics.mean": "Mean",
  "qc.controlLot.statistics.sd": "Standard Deviation",
  "qc.controlLot.statistics.config.title": "Statistics Configuration",
  "qc.controlLot.statistics.config.label": "Configure statistics method",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Manufacturer Fixed",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Use manufacturer-provided mean and SD values",
  "qc.controlLot.statistics.method.rolling": "Rolling Window",
  "qc.controlLot.statistics.method.rolling.description": "Recalculate from the most recent N results",
  "qc.controlLot.statistics.method.initial_runs": "Initial Runs",
  "qc.controlLot.statistics.method.initial_runs.description": "Calculate once from the first N establishment runs",
  "qc.controlLot.statistics.manufacturerValues": "Manufacturer Values",
  "qc.controlLot.statistics.rollingConfig": "Rolling Configuration",
  "qc.controlLot.statistics.windowSize": "Window Size",
  "qc.controlLot.statistics.windowSize.helper": "Number of recent results to include in calculation",
  "qc.controlLot.statistics.initialRunsConfig": "Initial Runs Configuration",
  "qc.controlLot.statistics.initialRunsRequired": "Runs Required",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Number of establishment runs before statistics are calculated",
  "qc.instrumentDetail.analytesMonitored": "Analytes Monitored",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} other {# violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "Activity Timeline",
  "qc.instrumentDetail.tab.controlChart": "Control Chart",
  "qc.instrumentDetail.timeline.empty": "No alerts or corrective actions recorded for the selected time period",
  "qc.instrumentDetail.timeline.violation": "Violation",
  "qc.instrumentDetail.timeline.correctiveAction": "Corrective Action",
  "qc.instrumentDetail.timeline.loading": "Loading activity timeline...",
  "qc.instrumentDetail.chart.selectAnalyte": "Select Analyte",
  "qc.instrumentDetail.chart.loading": "Loading control chart...",
  "qc.instrumentDetail.chart.noData": "No QC data available for this analyte",
  "qc.instrumentDetail.chart.activeRules": "Active QC Rules",
  "qc.instrumentDetail.chart.noRules": "No active rules configured",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Mean (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Std Dev (s)",
  "qc.instrumentDetail.error.loadFailed": "Failed to load instrument details",
  "question.text.required": "Question text is required",
  "compliance.legend.limitTypes": "LIMIT TYPES:",
  "compliance.limitType.borderlineShort": "Borderline ⚑",
  "compliance.limitType.descriptiveShort": "Qualitative",
  "compliance.limitType.MAXIMUM": "High Limit ≤",
  "compliance.limitType.MINIMUM": "Low Limit ≥",
  "compliance.limitType.RANGE": "Normal Range",
  "compliance.limitType.BORDERLINE": "Borderline 🚩",
  "compliance.limitType.DESCRIPTIVE": "Qualitative",
  "compliance.limitType.EXACT": "Exact",
  "compliance.limitType.SELECT_MAP": "Value Mapping",
  "compliance.status.ACTIVE": "Active",
  "compliance.status.DRAFT": "Draft",
  "compliance.status.SUPERSEDED": "Superseded",
  "compliance.status.ARCHIVED": "Archived",
  "compliance.standard.placeholder.name": "e.g., PP No. 22/2021 — Water Quality",
  "compliance.standard.placeholder.issuingBody": "e.g., Government of Indonesia",
  "compliance.standard.placeholder.regulationNumber": "e.g., PP 22/2021",
  "compliance.standard.placeholder.version": "e.g., 2021",
  "compliance.standard.placeholder.countryRegion": "e.g., Indonesia",
  "compliance.standard.placeholder.description": "Optional. Full description of the standard's scope.",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Lower / Min",
  "compliance.threshold.placeholder.upper": "Upper / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Archive",
  "compliance.standard.archiveHeading": "Archive Compliance Standard",
  "compliance.standard.archivePrompt": "Archive this standard? Existing evaluated results stay linked to it for audit, but the standard will be hidden from active selection lists. This action can be reverted by editing the standard's status back to Active.",
  "compliance.standard.archived": "Compliance standard archived.",
  "compliance.standard.archiveError": "Could not archive this standard.",
  "button.complianceStandard.copy": "Copy Standard",
  "compliance.standard.copied": "Compliance standard copied as a new Draft.",
  "compliance.standard.copyError": "Could not copy this standard.",
  "compliance.standard.viewLinkedTests": "View Linked Tests",
  "compliance.testEditor.groupBy": "Group by",
  "compliance.testEditor.section.configuration": "Configuration",
  "compliance.testEditor.section.organization": "Organization",
  "compliance.testEditor.section.resources": "Resources",
  "compliance.testEditor.section.automation": "Automation",
  "compliance.testEditor.section.compliance": "Compliance",
  "compliance.testEditor.tab.compliance": "Compliance",
  "compliance.testEditor.tabPlaceholder": "Coming with the Test Editor surface — manage this from the Modify Test page for now.",
  "compliance.parameterGroup.editBtn": "Edit",
  "compliance.parameterGroup.moveUp": "Move up",
  "compliance.parameterGroup.moveDown": "Move down",
  "compliance.parameterGroup.updateError": "Could not update parameter group.",
  "compliance.testEditor.standardInactiveBanner": "This test has thresholds linked to {name} which is now {status}. Results will no longer be evaluated against this standard.",
  "compliance.standard.viewLinkedTests.heading": "Linked Tests — {name}",
  "compliance.standard.viewLinkedTests.empty": "No tests are currently linked to this standard.",
  "compliance.filter.status": "Status",
  "compliance.filter.region": "Region",
  "compliance.filter.allStatuses": "All Statuses",
  "compliance.filter.allRegions": "All Regions",
  "compliance.filter.sampleType": "Sample Type",
  "compliance.filter.allSampleTypes": "All Sample Types",
  "compliance.sampleTypes.addLabel": "Add sample type",
  "compliance.sampleTypes.noneConfigured": "None configured",
  "compliance.sampleTypes.noneTitle": "No sample types configured yet.",
  "compliance.sampleTypes.noneSubtitle": "Add at least one sample type before linking tests.",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} other {# sample types configured}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Groups",
  "compliance.standard.tests": "Tests",
  "compliance.standard.expiryDate": "Expiry Date",
  "compliance.parameterGroups.heading": "Parameter Groups & Linked Tests",
  "compliance.parameterGroups.requireSampleTypes": "Configure the standard's fields and sample types first, then link tests.",
  "compliance.button.save": "Save",
  "compliance.button.saving": "Saving…",
  "compliance.parameterGroup.createError": "Could not add parameter group.",
  "compliance.parameterGroup.deleteHeading": "Delete Parameter Group",
  "compliance.parameterGroup.deletePrompt": "Delete the parameter group {name} and all of its thresholds? This cannot be undone.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} other {# tests are}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Could not save this row.",
  "compliance.threshold.deleteError": "Could not remove this row.",
  "compliance.validation.required": "This field is required.",
  "compliance.validation.expiryAfterEffective": "Expiry date must be on or after the effective date.",
  "compliance.validation.missingUpper": "Upper limit is required.",
  "compliance.validation.missingLower": "Lower limit is required.",
  "compliance.validation.missingBounds": "Both lower and upper bounds are required.",
  "compliance.validation.lowerGtUpper": "Lower bound must be less than or equal to upper bound.",
  "compliance.validation.missingDescriptive": "Qualitative value is required.",
  "compliance.linkTest.selectNoOptions": "This test is select-list but has no options configured in the test catalog. Add result options in test management before linking it to a compliance standard.",
  "compliance.linkTest.resultTypeLegend": "Result type",
  "compliance.linkTest.resultType.numeric": "Numeric (use limit values)",
  "compliance.linkTest.resultType.select": "Select list (map options to status)",
  "compliance.linkTest.optionsHint": "Add the result options for this test (e.g. 'Absent', 'Present'). The next step lets you map each one to a compliance status.",
  "compliance.linkTest.optionLabel": "Option value",
  "compliance.linkTest.optionPlaceholder": "e.g. Absent",
  "compliance.linkTest.optionsRequired": "Add at least one option above before mapping statuses.",
  "compliance.admin.title": "Compliance Standards Administration",
  "compliance.admin.tile.explain": "Manage compliance standards, parameter groups, and per-test thresholds (e.g. PP 22/2021, WHO Drinking Water).",
  "compliance.tabs.standardsAdmin": "Compliance Standards List",
  "compliance.tabs.testThresholds": "Compliance Tab (Test Editor)",
  "compliance.testEditor.back": "Back",
  "compliance.testEditor.editTest": "Edit Test:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Sample Type:",
  "compliance.testEditor.resultType": "Result Type:",
  "compliance.testEditor.saveTest": "Save Test",
  "compliance.testEditor.saveDisabledHint": "Other test-editor tabs are not yet wired in this iteration.",
  "compliance.testEditor.thresholdsHeading": "Compliance Thresholds for",
  "compliance.testEditor.addThreshold": "Add Threshold",
  "compliance.testEditor.addThresholdHeading": "Link {name} to a compliance standard",
  "compliance.testEditor.pickStandard": "Compliance standard",
  "compliance.testEditor.pickStandardPlaceholder": "-- Select a standard --",
  "compliance.testEditor.pickGroup": "Parameter group",
  "compliance.testEditor.pickGroupPlaceholder": "-- Select a parameter group --",
  "compliance.testEditor.pickGroupHint": "Pick a standard and parameter group above to configure the threshold.",
  "compliance.testEditor.unlink": "Unlink",
  "compliance.testEditor.unlinkHeading": "Unlink Threshold",
  "compliance.testEditor.unlinkPrompt": "Remove this threshold from {test}? The threshold itself stays on the standard's parameter group; only the link to this specific test is removed.",
  "compliance.testEditor.linkedBanner": "This test is linked to {count, plural, one {# compliance standard} other {# compliance standards}}. Thresholds are evaluated at validation time.",
  "compliance.testEditor.expandRow": "Expand row",
  "compliance.testEditor.col.standard": "Standard",
  "compliance.testEditor.col.parameterGroup": "Parameter Group",
  "compliance.testEditor.col.limitType": "Limit Type",
  "compliance.testEditor.col.thresholdRange": "Threshold / Range",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Effective",
  "compliance.testEditor.col.status": "Status",
  "compliance.testThresholds.selectHint": "Select a test to view its compliance thresholds linked across standards.",
  "compliance.testThresholds.overviewHeading": "Tests linked to compliance standards",
  "compliance.testThresholds.overviewCount": "{filtered} of {total} test{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "No tests are linked to compliance standards yet.",
  "compliance.testThresholds.overviewEmptyHint": "CSV-seeded thresholds at parameter-group level appear in Tab 1 (Compliance Standards Admin), not here. Search above to pick a test from the catalog and link it to a standard.",
  "compliance.testThresholds.noLinkedMatches": "No linked tests match \"{q}\".",
  "compliance.testThresholds.addSection": "Add a test to compliance",
  "compliance.testThresholds.col.test": "Test",
  "compliance.testThresholds.col.code": "Code",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Sample Types",
  "compliance.testThresholds.col.thresholdCount": "# Thresholds",
  "compliance.testThresholds.col.standardCount": "# Standards",
  "compliance.testThresholds.openEditor": "Open",
  "compliance.testThresholds.title": "Test Compliance Thresholds",
  "compliance.testThresholds.tile.explain": "View compliance thresholds linked to a specific test, grouped by standard and parameter group.",
  "compliance.testThresholds.searchLabel": "Search test",
  "compliance.testThresholds.searchPlaceholder": "Filter test list…",
  "compliance.testThresholds.test": "Test",
  "compliance.testThresholds.selectPlaceholder": "-- Select a test --",
  "compliance.testThresholds.empty": "No compliance thresholds are linked to this test yet. Click + Add Threshold above to link it to a compliance standard's parameter group.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Limit Type",
  "compliance.testThresholds.value": "Value",
  "compliance.testThresholds.note": "Note",
  "compliance.testThresholds.unknownStandard": "Unknown standard",
  "compliance.button.openAdmin": "Open Compliance Standards Admin",
  "compliance.button.addStandard": "Add Standard",
  "compliance.button.saveStandard": "Save Standard",
  "compliance.button.linkTest": "Link Test to Group",
  "compliance.button.saveLimits": "Save Limits",
  "compliance.button.saveMapping": "Save Mapping",
  "compliance.search": "Search standards",
  "compliance.search.placeholder": "Search by name, issuing body, regulation, country…",
  "compliance.list.empty": "No compliance standards yet.",
  "compliance.standard.name": "Standard Name",
  "compliance.standard.issuingBody": "Issuing Body",
  "compliance.standard.regulationNumber": "Regulation Number",
  "compliance.standard.version": "Version",
  "compliance.standard.countryRegion": "Country / Region",
  "compliance.standard.status": "Status",
  "compliance.standard.effectiveDate": "Effective Date",
  "compliance.standard.description": "Description",
  "compliance.standard.addNew": "Add New Compliance Standard",
  "compliance.standard.edit": "Edit Compliance Standard",
  "compliance.standard.preSeeded": "Pre-seeded",
  "compliance.standard.saved": "Compliance standard saved.",
  "compliance.standard.saveError": "Could not save standard.",
  "compliance.standard.saveBeforeGroups": "Save the standard before adding parameter groups.",
  "compliance.standard.deleted": "Compliance standard deleted.",
  "compliance.standard.deleteError": "Could not delete standard (it may be pre-seeded or have linked thresholds).",
  "compliance.standard.deleteHeading": "Delete Compliance Standard",
  "compliance.standard.deletePrompt": "Are you sure you want to delete this standard? Pre-seeded standards and standards with linked thresholds cannot be deleted.",
  "compliance.sampleTypes.heading": "Applicable Sample Types",
  "compliance.sampleTypes.explicitHint": "Declare which sample type categories this standard applies to. These selections drive the test filter when linking tests.",
  "compliance.sampleTypes.empty": "No sample types declared yet.",
  "compliance.sampleTypes.selectPlaceholder": "Select sample type...",
  "compliance.sampleTypes.addBtn": "Add Sample Type",
  "compliance.sampleTypes.remove": "Remove",
  "compliance.parameterGroups": "Parameter Groups",
  "compliance.parameterGroups.empty": "No parameter groups defined yet.",
  "compliance.parameterGroups.add": "Add Parameter Group",
  "compliance.parameterGroup.name": "Group name",
  "compliance.parameterGroup.description": "Description",
  "compliance.parameterGroup.deleteBtn": "Delete",
  "compliance.label.tests": "tests",
  "compliance.linkedTest.name": "Test",
  "compliance.linkedTest.sampleTypes": "Sample Types",
  "compliance.linkedTest.limits": "Limits Configured",
  "compliance.linkedTest.editLimits": "Edit limits",
  "compliance.linkedTest.unlink": "Remove from group",
  "compliance.linkedTest.unlinkHeading": "Remove Test from Group",
  "compliance.linkedTest.unlinkConfirm": "Remove",
  "compliance.linkedTest.unlinkPrompt": "Remove this test from the group? All threshold definitions for this test in this group will be deleted.",
  "compliance.group.noTests": "No tests linked to this group yet. Link tests to define compliance thresholds for evaluation.",
  "compliance.linkTest.heading": "Link Test to Group",
  "compliance.linkTest.step1": "Step 1 — Filter by Sample Type",
  "compliance.linkTest.step2": "Step 2 — Search & Select Test",
  "compliance.linkTest.step3Numeric": "Step 3 — Configure Limits",
  "compliance.linkTest.step3Select": "Step 3 — Compliance Value Mapping",
  "compliance.linkTest.filterByST": "Filter by sample type:",
  "compliance.linkTest.searchTest": "Search test catalog",
  "compliance.linkTest.searchPlaceholder": "Type to search by name or code...",
  "compliance.linkTest.noResults": "No matching tests found.",
  "compliance.linkTest.selectListBadge": "Select List",
  "compliance.linkTest.clearSelection": "Clear selection",
  "compliance.multiLimit.editHeading": "Configure Limits",
  "compliance.multiLimit.hint": "Enable one or more limit types for this test. At least one limit type must be enabled.",
  "compliance.multiLimit.type": "Limit Type",
  "compliance.multiLimit.lower": "Lower",
  "compliance.multiLimit.upper": "Upper",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Note / Advisory",
  "compliance.multiLimit.descriptive.placeholder": "e.g., No odor, Absent, Clear",
  "compliance.multiLimit.note.placeholder": "Optional note",
  "compliance.limitType.high": "High Limit ≤",
  "compliance.limitType.high.hint": "Non-compliant if result exceeds upper limit",
  "compliance.limitType.low": "Low Limit ≥",
  "compliance.limitType.low.hint": "Non-compliant if result is below lower limit",
  "compliance.limitType.range": "Normal Range",
  "compliance.limitType.range.hint": "Compliant within lower–upper range",
  "compliance.limitType.borderline": "Borderline (Advisory)",
  "compliance.limitType.borderline.hint": "Advisory zone — triggers review flag, not fail",
  "compliance.limitType.descriptive": "Qualitative / Descriptive",
  "compliance.limitType.descriptive.hint": "Text value evaluated by analyst",
  "compliance.selectMap.editHeading": "Compliance Mapping",
  "compliance.selectMap.hint": "Map each result option to its compliance status. Options come from the test catalog.",
  "compliance.selectMap.option": "Result Option",
  "compliance.selectMap.status": "Compliance Status",
  "compliance.selectMap.preview": "Preview",
  "compliance.selectMap.badge": "Value Mapping",
  "compliance.selectMap.optionsLabel": "options mapped",
  "compliance.selectMap.statusForOption": "Compliance status for {option}",
  "compliance.status.compliant": "Compliant",
  "compliance.status.borderline": "Borderline",
  "compliance.status.nonCompliant": "Non-Compliant",
  "compliance.status.compliantWithIcon": "Compliant ✓",
  "compliance.status.borderlineWithIcon": "Borderline ⚑",
  "compliance.status.nonCompliantWithIcon": "Non-Compliant ✗",
  "compliance.linkedTest.noLimits": "No limits configured",
  "compliance.threshold.savedThresholds": "Compliance thresholds linked to the test.",
  "compliance.threshold.savedValueMap": "Value-mapping threshold saved.",
  "compliance.threshold.savedPartialError": "Some thresholds could not be saved. Review the highlighted rows.",
  "compliance.threshold.unlinked": "Threshold unlinked from the test.",
  "compliance.threshold.unlinkError": "Could not unlink this threshold.",
  "notification.title.success": "Success",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Vector Surveillance",
  "vector.admin.title": "Vector Surveillance Setup",
  "vector.admin.groups": "Organism Groups",
  "vector.admin.group.code": "Code",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Color Tag",
  "vector.admin.group.description": "Description",
  "vector.admin.active": "Active",
  "vector.admin.system": "System",
  "vector.admin.trapTypes": "Trap Types",
  "vector.admin.trapType.name": "Name",
  "vector.admin.trapType.description": "Description",
  "vector.admin.species": "Species",
  "vector.admin.selectGroup": "Select a group on the left to manage its trap types and species.",
  "vector.admin.newGroup": "New group (unsaved)",
  "vector.admin.newTrapType": "New trap type",
  "vector.admin.newSpecies": "New species",
  "vector.admin.saveGroup": "Save group",
  "vector.admin.saveTrap": "Save trap",
  "vector.admin.saveSpecies": "Save species",
  "vector.admin.addGroup": "+ Add group",
  "vector.admin.addTrapType": "+ Add trap type",
  "vector.admin.addSpecies": "+ Add species",
  "vector.admin.locked": "locked",
  "vector.admin.systemGroup": "System-protected group",
  "vector.admin.systemGroup.desc": "The code is locked because this group is referenced by core reports and seed data. You may still edit the label, color, and description.",
  "vector.admin.usedBy": "Used by",
  "vector.admin.status": "Status",
  "vector.admin.status.active": "Active",
  "vector.admin.status.inactive": "Inactive",
  "vector.admin.group": "Organism group",
  "vector.admin.trapType.group": "Target organism group",
  "vector.admin.trapType.groups": "Organism groups",
  "vector.admin.trapType.sampleTypes": "Sample types",
  "vector.admin.sampleType": "Sample type",
  "vector.admin.search.groups": "Search by code or label...",
  "vector.admin.search.traps": "Search trap name or description...",
  "vector.admin.search.species": "Search genus or species...",
  "vector.admin.samplingSites": "Sampling Sites",
  "vector.admin.samplingSite.newSite": "New site",
  "vector.admin.samplingSite.allSites": "All Sites",
  "vector.admin.samplingSite.code": "Code",
  "vector.admin.samplingSite.name": "Site Name",
  "vector.admin.samplingSite.type": "Site Type",
  "vector.admin.samplingSite.region": "Region",
  "vector.admin.samplingSite.district": "District",
  "vector.admin.samplingSite.contactName": "Contact Person",
  "vector.admin.samplingSite.contactPhone": "Contact Phone",
  "vector.admin.samplingSite.gpsLatitude": "GPS Latitude",
  "vector.admin.samplingSite.gpsLongitude": "GPS Longitude",
  "vector.admin.samplingSite.environmentalZone": "Environmental Zone",
  "vector.admin.samplingSite.address": "Address",
  "vector.admin.samplingSite.description": "Description",
  "vector.admin.samplingSite.source": "Source",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Last Collection",
  "vector.admin.samplingSite.search": "Search by code, name, region...",
  "vector.admin.samplingSite.saveSite": "Save site",
  "vector.admin.samplingSites.registry": "Sampling Site Registry",
  "vector.admin.samplingSite.deactivate": "Deactivate",
  "vector.admin.samplingSite.activate": "Activate",
  "vector.admin.samplingSite.location": "Location",
  "vector.admin.samplingSite.allTypes": "All types",
  "vector.admin.samplingSite.subtype": "Subtype",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. River, Well, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "City",
  "vector.admin.samplingSite.addressLocation": "Address Location",
  "vector.admin.samplingSite.addressSearch.placeholder": "Search location to auto-fill dropdowns...",
  "vector.admin.samplingSite.gpsCoordinates": "GPS Coordinates",
  "vector.admin.samplingSite.lastModified": "Last Modified",
  "label.noResults": "No results found",
  "vector.admin.addSite": "+ New Site",
  "vector.order.title": "New Vector Order",
  "vector.order.subtitle": "Lab unit: Vector Surveillance Lab — Vector domain active.",
  "vector.order.samplingSite": "Sampling Site",
  "vector.order.site.placeholder": "Search by site name or code...",
  "vector.order.specimen": "Specimen",
  "vector.order.organism": "Animal / Organism",
  "vector.order.organism.hint": "Common name — e.g., Mosquito, Tick, Rodent, Sandfly.",
  "vector.order.organism.placeholder": "Search organism or species...",
  "vector.order.quantity": "Quantity",
  "vector.order.quantity.hint": "Number of organisms in this pool.",
  "vector.order.requester.section": "Requester / Ordering Programme",
  "vector.order.requester": "Requester",
  "vector.order.requester.placeholder": "Search by organisation name or code...",
  "vector.order.panels": "Order Panels",
  "vector.order.panels.search": "Choose available panel",
  "vector.order.tests": "Order Tests",
  "vector.order.tests.search": "Choose available test",
  "vector.order.collectionContext": "Collection Context (optional — bionomics capture)",
  "vector.order.timeOfDay": "Time of Day",
  "vector.order.timeOfDay.dawn": "Dawn",
  "vector.order.timeOfDay.day": "Day",
  "vector.order.timeOfDay.dusk": "Dusk",
  "vector.order.timeOfDay.night": "Night",
  "vector.order.restingContext": "Resting Context",
  "vector.order.restingContext.outdoor": "Outdoor (exophilic)",
  "vector.order.restingContext.indoor": "Indoor (endophilic)",
  "vector.order.restingContext.peridomestic": "Peridomestic",
  "vector.order.humanBitingCatch": "Human-Biting Catch",
  "vector.order.humanBitingCatch.hint": "specimen came from a human-landing collection",
  "vector.order.collectionNotes": "Collection Notes",
  "vector.order.collectionNotes.placeholder": "Weather, trap conditions, anomalies...",
  "vector.admin.group.code.placeholder": "e.g., SANDFLY",
  "vector.admin.group.label.placeholder": "e.g., Sandfly",
  "vector.species.genus.placeholder": "e.g., Mansonia",
  "vector.species.species.placeholder": "e.g., uniformis",
  "vector.species.subspecies.placeholder": "e.g., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Species",
  "vector.species.subspecies": "Subspecies",
  "vector.species.pathogensOfInterest": "Pathogens of Interest",
  "vector.species.lifecycleStages": "Lifecycle Stages",
  "vector.species.pathogenCategory": "Pathogen category",
  "vector.species.lifecycleCategory": "Lifecycle category",
  "workflow.vector": "Vector Surveillance",
  "vector.sampleType": "Sample Type",
  "vector.organismGroup": "Organism Group",
  "vector.species": "Species",
  "vector.animalOrganism": "Animal/Organism",
  "vector.animalOrganism.add": "Add Animal/Organism",
  "vector.animalOrganism.remove": "Remove Animal/Organism",
  "vector.collectedVolume": "Quantity in Pool",
  "vector.lifecycleStage": "Lifecycle Stage",
  "vector.trapType": "Trap Type",
  "vector.poolingMethod": "Pooling Method",
  "vector.poolCount": "Number of Pools",
  "vector.samplesPerPool": "Specimens per Pool",
  "vector.totalSpecimens": "Total Specimens",
  "vector.pathogensOfInterest": "Pathogens of Interest",
  "vector.homogeneous": "Homogeneous",
  "vector.random": "Random",
  "vector.collectionSite": "Collection Site",
  "vector.collectionSiteName": "Collection Site Name",
  "vector.gpsLatitude": "GPS Latitude",
  "vector.gpsLongitude": "GPS Longitude",
  "patient.search.merged.tag": "Merged",
  "patient.merged.banner.title": "This patient record was merged",
  "patient.merged.banner.subtitle": "Active records are kept on Patient {target}.",
  "patient.merged.banner.subtitle.noTarget": "This record has been merged into another patient.",
  "admin.testCatalog.tabs.ariaLabel": "Test details tabs",
  "admin.testCatalog.tabs.details": "Details",
  "admin.testCatalog.tabs.labels": "Labels",
  "admin.testCatalog.labels.masterOverride.label": "Allow Order Entry Override",
  "admin.testCatalog.labels.masterOverride.on": "On",
  "admin.testCatalog.labels.masterOverride.off": "Off",
  "admin.testCatalog.labels.linkedPresets.title": "Linked Label Presets",
  "admin.testCatalog.labels.linkedPresets.empty": "No label presets linked. Use the dropdown below to add one.",
  "admin.testCatalog.labels.col.presetName": "Preset Name",
  "admin.testCatalog.labels.col.defaultQty": "Default Qty",
  "admin.testCatalog.labels.col.maxQty": "Max Qty",
  "admin.testCatalog.labels.col.allowOverride": "Allow Override",
  "admin.testCatalog.labels.col.actions": "Actions",
  "admin.testCatalog.labels.action.remove": "Remove preset link",
  "admin.testCatalog.labels.addPreset.label": "Add Label Type",
  "admin.testCatalog.labels.addPreset.placeholder": "Select a label preset",
  "admin.testCatalog.labels.preview.title": "Order Entry Preview",
  "admin.testCatalog.labels.preview.col.locked": "Locked",
  "admin.testCatalog.labels.preview.locked": "Locked",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Label configuration saved.",
  "admin.testCatalog.labels.save.error": "Failed to save label configuration.",
  "orderEntry.labels.orderTable.title": "Order Labels",
  "orderEntry.labels.sampleTable.title": "Sample Labels",
  "orderEntry.labels.col.row": "Row",
  "orderEntry.labels.col.sample": "Sample",
  "orderEntry.labels.col.quantity": "Quantity",
  "orderEntry.labels.orderRow.header": "Order",
  "orderEntry.labels.sampleRow.header": "Sample {number}",
  "orderEntry.labels.input.sample": "Sample {number} {column} quantity",
  "orderEntry.labels.source.test": "From test",
  "orderEntry.labels.source.presetDefault": "Preset default",
  "orderEntry.labels.locked.tooltipFor": "{label} is locked by the test configuration and cannot be changed.",
  "orderEntry.labels.total": "Total labels: {total}",
  "orderEntry.labels.heading": "LABELS"
}
